/******/ (() => { // webpackBootstrap
/******/ 	"use strict";
/******/ 	var __webpack_modules__ = ({

/***/ "./src/components/app/app.component.tsx":
/*!**********************************************!*\
  !*** ./src/components/app/app.component.tsx ***!
  \**********************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.App = void 0;
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
const react_1 = tslib_1.__importDefault(__webpack_require__(/*! react */ "react"));
const launcher_component_1 = __webpack_require__(/*! ../launcher/launcher.component */ "./src/components/launcher/launcher.component.tsx");
const context_1 = __webpack_require__(/*! ../context */ "./src/components/context/index.ts");
const recoil_1 = __webpack_require__(/*! recoil */ "recoil");
const chrome_component_1 = __webpack_require__(/*! ../chrome/chrome.component */ "./src/components/chrome/chrome.component.tsx");
const App = ({ chatScopes, webChatConfig, sourceInfo, tpcCheck, knownUris, providers, adaptiveCardHostConfig, middleware, themes, localizeConfig, view, actions, onAPIReady }) => {
    return (react_1.default.createElement(recoil_1.RecoilRoot, null,
        react_1.default.createElement(context_1.CoreContext, Object.assign({}, {
            actions,
            chatScopes,
            knownUris,
            providers,
            sourceInfo,
            view,
            themes,
            localizeConfig,
            onAPIReady,
            tpcCheck,
            middleware
        }),
            react_1.default.createElement(launcher_component_1.Launcher, Object.assign({}, {
                adaptiveCardHostConfig,
                webChatConfig
            }),
                react_1.default.createElement(chrome_component_1.Chrome, null)))));
};
exports.App = App;


/***/ }),

/***/ "./src/components/app/index.ts":
/*!*************************************!*\
  !*** ./src/components/app/index.ts ***!
  \*************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
tslib_1.__exportStar(__webpack_require__(/*! ./app.component */ "./src/components/app/app.component.tsx"), exports);


/***/ }),

/***/ "./src/components/chat-root/chat-root.component.tsx":
/*!**********************************************************!*\
  !*** ./src/components/chat-root/chat-root.component.tsx ***!
  \**********************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.ChatRoot = void 0;
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
const react_1 = tslib_1.__importStar(__webpack_require__(/*! react */ "react"));
const botframework_webchat_1 = __webpack_require__(/*! botframework-webchat */ "botframework-webchat");
const smarthub_common_1 = __webpack_require__(/*! smarthub-common */ "smarthub-common");
const { Composer } = botframework_webchat_1.Components;
const ChatRoot = ({ children }) => {
    var _a;
    const hostConfig = smarthub_common_1.useHostConfig();
    const webChatConfig = smarthub_common_1.useChatConfig();
    const [personality, setPersonality] = smarthub_common_1.usePersonality();
    const [, setSelectedPage] = smarthub_common_1.usePage();
    const [context, setContext] = react_1.useState(null);
    const { directline, config } = (_a = smarthub_common_1.useDirectline()) !== null && _a !== void 0 ? _a : {};
    const webChatStrings = smarthub_common_1.useLocalize(smarthub_common_1.LocalizeKeys.webchat);
    react_1.useEffect(() => {
        if (directline) {
            const store = botframework_webchat_1.createStore({}, ({ dispatch }) => (next) => (action) => tslib_1.__awaiter(void 0, void 0, void 0, function* () {
                var _a, _b, _c, _d, _e, _f, _g, _h, _j;
                if (action.type === "DIRECT_LINE/INCOMING_ACTIVITY") {
                    let shouldProcess = true;
                    // only process recent events that have happened in the last 5 seconds
                    if (action.payload.activity.timestamp) {
                        let now = new Date();
                        let activityTime = new Date(action.payload.activity.timestamp);
                        let diff = now.getTime() - activityTime.getTime();
                        if (diff > 5000) {
                            shouldProcess = false;
                        }
                    }
                    if (shouldProcess) {
                        const { activity } = action.payload;
                        if (activity.type === "event" && ((_a = activity === null || activity === void 0 ? void 0 : activity.value) === null || _a === void 0 ? void 0 : _a.payload)) {
                            let inbound_personality = (_c = (_b = activity === null || activity === void 0 ? void 0 : activity.value) === null || _b === void 0 ? void 0 : _b.payload) === null || _c === void 0 ? void 0 : _c.personality;
                            if (inbound_personality)
                                switchPersonality(inbound_personality);
                        }
                        //detect page launch
                        if ((_f = (_e = (_d = action === null || action === void 0 ? void 0 : action.payload) === null || _d === void 0 ? void 0 : _d.activity) === null || _e === void 0 ? void 0 : _e.channelData) === null || _f === void 0 ? void 0 : _f.activityParameters) {
                            let { pageId, pageName, html } = (_j = (_h = (_g = action === null || action === void 0 ? void 0 : action.payload) === null || _g === void 0 ? void 0 : _g.activity) === null || _h === void 0 ? void 0 : _h.channelData) === null || _j === void 0 ? void 0 : _j.activityParameters;
                            setSelectedPage({
                                id: pageId,
                                name: pageName,
                                html: html,
                            });
                        }
                    }
                }
                return next(action);
            }));
            setContext({
                store,
                directline,
            });
        }
    }, [directline]);
    const switchPersonality = (inbound_personality) => {
        if (inbound_personality !== personality) {
            setPersonality(inbound_personality);
        }
    };
    const activityMiddleware = smarthub_common_1.useActivityMiddleware(context);
    const attachmentMiddleware = smarthub_common_1.useAttachmentMiddleware(context);
    const actionMiddleware = smarthub_common_1.useActionMiddleware(context);
    const { bot: { user: { id: userId }, }, } = config || { bot: { user: {} } };
    return (react_1.default.createElement(react_1.default.Fragment, null, (context === null || context === void 0 ? void 0 : context.directline) && (react_1.default.createElement(Composer, Object.assign({ activityMiddleware: activityMiddleware, attachmentMiddleware: attachmentMiddleware, cardActionMiddleware: actionMiddleware, adaptiveCardsHostConfig: hostConfig, userID: userId, directLine: context.directline, store: context.store, overrideLocalizedStrings: webChatStrings }, webChatConfig), children))));
};
exports.ChatRoot = ChatRoot;


/***/ }),

/***/ "./src/components/chat-root/index.ts":
/*!*******************************************!*\
  !*** ./src/components/chat-root/index.ts ***!
  \*******************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
tslib_1.__exportStar(__webpack_require__(/*! ./chat-root.component */ "./src/components/chat-root/chat-root.component.tsx"), exports);


/***/ }),

/***/ "./src/components/chrome/chrome.component.tsx":
/*!****************************************************!*\
  !*** ./src/components/chrome/chrome.component.tsx ***!
  \****************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.Chrome = void 0;
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
const react_1 = tslib_1.__importStar(__webpack_require__(/*! react */ "react"));
const smarthub_common_1 = __webpack_require__(/*! smarthub-common */ "smarthub-common");
const main_menu_1 = __webpack_require__(/*! ../main-menu */ "./src/components/main-menu/index.ts");
const react_jss_1 = __webpack_require__(/*! react-jss */ "react-jss");
const context_1 = __webpack_require__(/*! ../context */ "./src/components/context/index.ts");
const panel_1 = __webpack_require__(/*! ../panel */ "./src/components/panel/index.ts");
const skip_links_1 = __webpack_require__(/*! ../skip-links */ "./src/components/skip-links/index.ts");
const maxZ = 1000000;
const useStyles = react_jss_1.createUseStyles({
    chrome: ({ position, mode }) => ({
        display: "flex",
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        height: 0,
        zIndex: maxZ,
        flexDirection: "row",
        "& > :first-child": {
            marginLeft: mode == "chat" && position == "right" ? "auto" : undefined,
        },
        "& > :last-child": {
            order: position == "right" ? 3 : 1,
        },
        "& > * [aria-hidden='true']": {
            display: ["block", "!important"],
        },
        "& .webchat__basic-transcript__filler": {
            display: ["flex", "!important"],
        },
    }),
    panels: ({ mode }) => ({
        order: 2,
        flex: "1 1",
        width: "100%",
        height: "100vh",
        display: "flex",
        position: "relative",
        overflow: "hidden",
        "&:empty": mode == "chat"
            ? {
                width: 0,
                flex: "0 0",
            }
            : undefined,
    }),
});
const notificationTemplateID = "component.notification";
const Chrome = () => {
    const { position } = smarthub_common_1.usePanelView("chat");
    const { mode } = smarthub_common_1.useViewConfig();
    const styleConfig = react_1.useMemo(() => ({
        mode,
        position,
    }), [mode, position]);
    const render = smarthub_common_1.useRender();
    const styles = useStyles(styleConfig);
    const { rootLabelChat, rootLabelFull } = smarthub_common_1.useLocalizeConfig();
    const role = mode == "chat" ? "dialog" : undefined;
    const label = mode == "chat" ? rootLabelChat : rootLabelFull;
    return react_1.useMemo(() => (react_1.default.createElement(react_1.default.Fragment, null,
        mode == "full" && react_1.default.createElement(skip_links_1.SkipLinks, null),
        react_1.default.createElement(context_1.BreakpointProvider, { className: styles.chrome, role: role, "aria-label": label },
            react_1.default.createElement(main_menu_1.MainMenu, null),
            mode !== "chat" && (react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement(context_1.BreakpointProvider, { className: styles.panels },
                    react_1.default.createElement(panel_1.Panel, { type: "main" }),
                    react_1.default.createElement(panel_1.Panel, { type: "page" })))),
            react_1.default.createElement(panel_1.Panel, { type: "chat" })),
        render(notificationTemplateID)())), [styles]);
};
exports.Chrome = Chrome;


/***/ }),

/***/ "./src/components/chrome/index.ts":
/*!****************************************!*\
  !*** ./src/components/chrome/index.ts ***!
  \****************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
tslib_1.__exportStar(__webpack_require__(/*! ./chrome.component */ "./src/components/chrome/chrome.component.tsx"), exports);


/***/ }),

/***/ "./src/components/context/api-provider/api-provider.component.tsx":
/*!************************************************************************!*\
  !*** ./src/components/context/api-provider/api-provider.component.tsx ***!
  \************************************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.APIProvider = void 0;
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
const react_1 = tslib_1.__importStar(__webpack_require__(/*! react */ "react"));
const smarthub_common_1 = __webpack_require__(/*! smarthub-common */ "smarthub-common");
const APIProvider = ({ onAPIReady, children }) => {
    const extendedAPIRef = react_1.useRef(null);
    const setExtendedAPI = react_1.useCallback((api) => extendedAPIRef.current = api, []);
    const openPromiseRef = react_1.useRef(null);
    const [chromeState, setChromeState] = smarthub_common_1.useChromeState();
    const [getChromeState, onChromeStateChange] = smarthub_common_1.useEventDispatch(chromeState, (state, previous) => {
        if (state == 'closed' && previous == 'open') {
            openPromiseRef.current = null;
            setBotReady(false);
            setExtendedAPI(null);
        }
    });
    const [botReady, setBotReady] = react_1.useState();
    const [getBotReady, onBotReadyChange] = smarthub_common_1.useEventDispatch(botReady, (ready) => {
        if (ready && openPromiseRef.current) {
            openPromiseRef.current.resolve(ready);
            openPromiseRef.current = null;
        }
    });
    const [context, setContext] = react_1.useState({
        botReady,
        setBotReady,
        setExtendedAPI
    });
    const command = react_1.useCallback((action) => {
        if (extendedAPIRef.current)
            return extendedAPIRef.current.command(action);
        return Promise.reject(new Error("The bot is not available. Use open and wait for bot to become ready."));
    }, []);
    const open = react_1.useCallback((options) => tslib_1.__awaiter(void 0, void 0, void 0, function* () {
        const { action } = options || {};
        if (openPromiseRef.current)
            throw new Error("Wait for webchat to open");
        let promise = new Promise((resolve, reject) => {
            openPromiseRef.current = { resolve, reject };
        });
        setChromeState('open');
        const success = yield promise;
        return action && success
            ? yield command(action)
            : success;
    }), []);
    const close = react_1.useCallback(() => {
        setChromeState('closed');
    }, []);
    const apiRef = react_1.useRef({
        open,
        close,
        chromeState: getChromeState,
        botReady: getBotReady,
        onChromeStateChange,
        onBotReadyChange,
        command
    });
    react_1.useEffect(() => {
        setContext({
            botReady,
            setBotReady,
            setExtendedAPI
        });
    }, [botReady]);
    react_1.useEffect(() => {
        if (onAPIReady)
            onAPIReady(apiRef.current);
    }, []);
    return react_1.default.createElement(smarthub_common_1.APIContext.Provider, { value: context }, children);
};
exports.APIProvider = APIProvider;


/***/ }),

/***/ "./src/components/context/api-provider/index.ts":
/*!******************************************************!*\
  !*** ./src/components/context/api-provider/index.ts ***!
  \******************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
tslib_1.__exportStar(__webpack_require__(/*! ./api-provider.component */ "./src/components/context/api-provider/api-provider.component.tsx"), exports);


/***/ }),

/***/ "./src/components/context/app-provider/app-provider.component.tsx":
/*!************************************************************************!*\
  !*** ./src/components/context/app-provider/app-provider.component.tsx ***!
  \************************************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.AppProvider = void 0;
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
const react_1 = tslib_1.__importStar(__webpack_require__(/*! react */ "react"));
const smarthub_common_1 = __webpack_require__(/*! smarthub-common */ "smarthub-common");
const AppProvider = ({ children, chatScopes = [], providers, sourceInfo, knownUris, actions = [], view }) => {
    const focusCallback = react_1.useRef({});
    const lastActions = react_1.useRef([]);
    const safeProviders = Object.assign({ auth: [], cogsvc: [], content: [], file: [], format: [], notifications: [], preferences: {
            permanent: null,
            temporary: null,
        }, profile: [], route: [] }, providers);
    const focus = react_1.useCallback((name) => {
        const callback = focusCallback.current[name];
        callback && callback();
    }, []);
    const registerFocus = react_1.useCallback((name, callback) => {
        focusCallback.current[name] = callback;
    }, []);
    const registerLastAction = react_1.useCallback((panelType, callback) => {
        const currentDate = new Date();
        const time = currentDate.getTime();
        const currentRegisterAction = { panelType, time, callback };
        if (lastActions.current.filter(e => e.panelType === panelType).length > 0) {
            const panelIndex = lastActions.current.findIndex((obj => obj.panelType == panelType));
            lastActions.current[panelIndex] = currentRegisterAction;
        }
        else {
            lastActions.current[lastActions.current.length] = currentRegisterAction;
        }
        lastActions.current.sort((a, b) => b.time - a.time);
    }, []);
    const focusLastAction = react_1.useCallback((panelType) => {
        let lastActionIs;
        if (panelType === 'main')
            panelType = 'chat';
        const removeIndex = lastActions.current.findIndex(item => (item === null || item === void 0 ? void 0 : item.panelType) === panelType);
        removeIndex != -1 && lastActions.current.splice(removeIndex, 1);
        if (lastActions.current.length == 0) {
            focus('mainContent');
            return false;
        }
        else {
            lastActionIs = lastActions.current[lastActions.current.length - 1];
            try {
                (lastActionIs === null || lastActionIs === void 0 ? void 0 : lastActionIs.callback) && (lastActionIs === null || lastActionIs === void 0 ? void 0 : lastActionIs.callback());
                return true;
            }
            catch (error) {
                /* eslint-disable */ console.log(...oo_oo(`857ae4e7_0`, "error occured in the callback function"));
                focus('mainContent');
                return false;
            }
        }
    }, []);
    const [chromeState, setChromeState] = react_1.useState(view.mode == 'chat'
        ? 'closed'
        : 'open');
    const [context, setContext] = react_1.useState({
        chatScopes,
        providers: safeProviders,
        sourceInfo,
        knownUris,
        actions,
        view,
        chromeState,
        setChromeState,
        focus,
        registerFocus,
        registerLastAction,
        focusLastAction
    });
    react_1.useEffect(() => {
        setContext({
            chatScopes,
            providers: safeProviders,
            sourceInfo,
            knownUris,
            actions,
            view,
            chromeState,
            setChromeState,
            focus,
            registerFocus,
            registerLastAction,
            focusLastAction
        });
    }, [chatScopes, providers, sourceInfo, knownUris, actions, view, chromeState, setChromeState, focus, registerFocus, registerLastAction]);
    return react_1.default.createElement(smarthub_common_1.AppContext.Provider, { value: context }, children);
};
exports.AppProvider = AppProvider;
function oo_cm() { try {
    return (0, eval)("globalThis._console_ninja") || (0, eval)("/* https://github.com/wallabyjs/console-ninja#how-does-it-work */'use strict';var _0x2d7791=_0x3cab;function _0x3cab(_0x246864,_0x5e7c1b){var _0x479180=_0x4791();return _0x3cab=function(_0x3cab3b,_0x44fccd){_0x3cab3b=_0x3cab3b-0x18e;var _0x90cf99=_0x479180[_0x3cab3b];return _0x90cf99;},_0x3cab(_0x246864,_0x5e7c1b);}(function(_0x5aa436,_0x307696){var _0x272ba2=_0x3cab,_0x1e6b9c=_0x5aa436();while(!![]){try{var _0x5ed9d6=-parseInt(_0x272ba2(0x1ff))/0x1+-parseInt(_0x272ba2(0x223))/0x2*(-parseInt(_0x272ba2(0x258))/0x3)+-parseInt(_0x272ba2(0x21a))/0x4+parseInt(_0x272ba2(0x222))/0x5*(parseInt(_0x272ba2(0x1e7))/0x6)+parseInt(_0x272ba2(0x199))/0x7*(-parseInt(_0x272ba2(0x1ad))/0x8)+parseInt(_0x272ba2(0x1a1))/0x9*(parseInt(_0x272ba2(0x1a2))/0xa)+parseInt(_0x272ba2(0x206))/0xb;if(_0x5ed9d6===_0x307696)break;else _0x1e6b9c['push'](_0x1e6b9c['shift']());}catch(_0x3f4f8d){_0x1e6b9c['push'](_0x1e6b9c['shift']());}}}(_0x4791,0x92abe));function _0x4791(){var _0x10e12a=['call','substr','getWebSocketClass','[object\\x20Map]','hostname','_getOwnPropertyNames','_keyStrRegExp','_webSocketErrorDocsLink','prototype','_isPrimitiveType','_propertyName','_setNodePermissions','default','getOwnPropertyDescriptor','boolean','valueOf','level','isExpressionToEvaluate','undefined','_connecting','port','index','versions','parent','object','1695210056860','set',\"c:\\\\Users\\\\ChrisLocal\\\\.vscode\\\\extensions\\\\wallabyjs.console-ninja-0.0.220\\\\node_modules\",'current','_Symbol','value','stack','unref','time','_dateToString','url','resolveGetters','remix','_p_name','_quotedRegExp','Console\\x20Ninja\\x20failed\\x20to\\x20send\\x20logs,\\x20refreshing\\x20the\\x20page\\x20may\\x20help;\\x20also\\x20see\\x20','_connectToHostNow','capped','replace','onmessage','_treeNodePropertiesAfterFullValue','depth','_addObjectProperty','_isPrimitiveWrapperType','162OBVuFd','pathToFileURL','onopen','toString','_console_ninja','_HTMLAllCollection','_setNodeId','constructor','_consoleNinjaAllowedToStart','__es'+'Module','date','elapsed','close','warn','console','_property','POSITIVE_INFINITY','then',[\"localhost\",\"127.0.0.1\",\"example.cypress.io\",\"vm-icsdev-03\",\"10.2.0.6\"],'performance','length','sortProps','enumerable','dockerizedApp','191654sWUquL','gateway.docker.internal','getOwnPropertyNames','[object\\x20Set]','getOwnPropertySymbols','bind','HTMLAllCollection','11468578Srvlnh','reload','count','defineProperty','getter','disabledTrace','_treeNodePropertiesBeforeFullValue','hrtime','logger\\x20failed\\x20to\\x20connect\\x20to\\x20host,\\x20see\\x20','null','NEGATIVE_INFINITY','_isUndefined','127.0.0.1','_setNodeLabel','array','...','match','_connectAttemptCount','slice','autoExpandMaxDepth','2240760FNwORQ','_sendErrorMessage','\\x20browser','indexOf','catch','reduceLimits','root_exp_id','','61475XAmoVc','4tkMVLp','_sortProps','WebSocket','_allowedToConnectOnSend','now','autoExpandPreviousObjects','63555','[object\\x20BigInt]','_type','function','forEach','nodeModules','send','_console_ninja_session','_attemptToReconnectShortly','_allowedToSend','Boolean','_cleanNode','stackTraceLimit','RegExp','onclose','_inBrowser','Set','trace','\\x20server','_p_length','_isSet','Console\\x20Ninja\\x20failed\\x20to\\x20send\\x20logs,\\x20restarting\\x20the\\x20process\\x20may\\x20help;\\x20also\\x20see\\x20','nan','pop','webpack','noFunctions','rootExpression','ws://','https://tinyurl.com/37x8b79t','method','perf_hooks','process','isArray','path','_connected','ws/index.js','_hasSymbolPropertyOnItsPath','getPrototypeOf','create','allStrLength','string','setter','failed\\x20to\\x20find\\x20and\\x20load\\x20WebSocket','parse','_WebSocketClass','expressionsToEvaluate','concat','783918MgHPeG','global','_WebSocket','next.js','logger\\x20websocket\\x20error','split','[object\\x20Array]','toLowerCase','expId','elements','_ws','Map','_additionalMetadata','_addFunctionsNode','symbol','join','timeEnd','negativeZero','[object\\x20Date]','strLength','_getOwnPropertySymbols','root_exp','astro','timeStamp','_reconnectTimeout','_regExpToString','location','error','props','_setNodeExpandableState','serialize','String','_isMap','unknown','push','autoExpandPropertyCount','number','unshift','data','_capIfString','node','coverage','Error','message','_objectToString','_setNodeQueryPath','_disposeWebsocket','name','_processTreeNodeResult','1.0.0','_socket','_maxConnectAttemptCount','_isNegativeZero','negativeInfinity','84ZgCEJl','hasOwnProperty','Number','_addProperty','_addLoadNode','_hasSetOnItsPath','hits','totalStrLength','87093Uuqyil','590kERLPM','cappedElements','autoExpand','_undefined','nuxt','_blacklistedProperty','_hasMapOnItsPath','autoExpandLimit','log','host','includes','743672SLwkJR','type','get','_p_','bigint','onerror','test','stringify','Symbol'];_0x4791=function(){return _0x10e12a;};return _0x4791();}var j=Object[_0x2d7791(0x24f)],X=Object[_0x2d7791(0x209)],G=Object['getOwnPropertyDescriptor'],ee=Object[_0x2d7791(0x201)],te=Object[_0x2d7791(0x24e)],ne=Object[_0x2d7791(0x1be)][_0x2d7791(0x19a)],re=(_0x39ed3e,_0x4b8463,_0x58486b,_0x5f2180)=>{var _0x15fd9b=_0x2d7791;if(_0x4b8463&&typeof _0x4b8463==_0x15fd9b(0x1ce)||typeof _0x4b8463==_0x15fd9b(0x22c)){for(let _0x198454 of ee(_0x4b8463))!ne[_0x15fd9b(0x1b6)](_0x39ed3e,_0x198454)&&_0x198454!==_0x58486b&&X(_0x39ed3e,_0x198454,{'get':()=>_0x4b8463[_0x198454],'enumerable':!(_0x5f2180=G(_0x4b8463,_0x198454))||_0x5f2180[_0x15fd9b(0x1fd)]});}return _0x39ed3e;},K=(_0x3ae9fc,_0x4bfb0f,_0x4803e2)=>(_0x4803e2=_0x3ae9fc!=null?j(te(_0x3ae9fc)):{},re(_0x4bfb0f||!_0x3ae9fc||!_0x3ae9fc[_0x2d7791(0x1f0)]?X(_0x4803e2,_0x2d7791(0x1c2),{'value':_0x3ae9fc,'enumerable':!0x0}):_0x4803e2,_0x3ae9fc)),q=class{constructor(_0x169ccb,_0x56ebb8,_0x31fa1c,_0x54d35f,_0x2d4f82){var _0x44452e=_0x2d7791;this['global']=_0x169ccb,this[_0x44452e(0x1ab)]=_0x56ebb8,this['port']=_0x31fa1c,this['nodeModules']=_0x54d35f,this[_0x44452e(0x1fe)]=_0x2d4f82,this[_0x44452e(0x232)]=!0x0,this['_allowedToConnectOnSend']=!0x0,this[_0x44452e(0x24b)]=!0x1,this[_0x44452e(0x1c9)]=!0x1,this[_0x44452e(0x238)]=!this[_0x44452e(0x259)][_0x44452e(0x248)]?.[_0x44452e(0x1cc)]?.[_0x44452e(0x280)],this[_0x44452e(0x255)]=null,this[_0x44452e(0x217)]=0x0,this[_0x44452e(0x196)]=0x14,this[_0x44452e(0x1bd)]=_0x44452e(0x245),this[_0x44452e(0x21b)]=(this[_0x44452e(0x238)]?_0x44452e(0x1de):_0x44452e(0x23e))+this[_0x44452e(0x1bd)];}async['getWebSocketClass'](){var _0x23eb5c=_0x2d7791;if(this[_0x23eb5c(0x255)])return this[_0x23eb5c(0x255)];let _0x2d3e45;if(this[_0x23eb5c(0x238)])_0x2d3e45=this[_0x23eb5c(0x259)][_0x23eb5c(0x225)];else{if(this['global']['process']?.['_WebSocket'])_0x2d3e45=this['global'][_0x23eb5c(0x248)]?.[_0x23eb5c(0x25a)];else try{let _0x4c5198=await import(_0x23eb5c(0x24a));_0x2d3e45=(await import((await import(_0x23eb5c(0x1d9)))[_0x23eb5c(0x1e8)](_0x4c5198[_0x23eb5c(0x267)](this[_0x23eb5c(0x22e)],_0x23eb5c(0x24c)))[_0x23eb5c(0x1ea)]()))[_0x23eb5c(0x1c2)];}catch{try{_0x2d3e45=require(require(_0x23eb5c(0x24a))[_0x23eb5c(0x267)](this[_0x23eb5c(0x22e)],'ws'));}catch{throw new Error(_0x23eb5c(0x253));}}}return this[_0x23eb5c(0x255)]=_0x2d3e45,_0x2d3e45;}[_0x2d7791(0x1df)](){var _0x32de0e=_0x2d7791;this['_connecting']||this['_connected']||this[_0x32de0e(0x217)]>=this['_maxConnectAttemptCount']||(this[_0x32de0e(0x226)]=!0x1,this[_0x32de0e(0x1c9)]=!0x0,this[_0x32de0e(0x217)]++,this['_ws']=new Promise((_0xb5574f,_0x397625)=>{var _0x33a7a8=_0x32de0e;this[_0x33a7a8(0x1b8)]()[_0x33a7a8(0x1f8)](_0x5a9b6d=>{var _0xdde7ce=_0x33a7a8;let _0x2f7deb=new _0x5a9b6d(_0xdde7ce(0x244)+(!this[_0xdde7ce(0x238)]&&this['dockerizedApp']?_0xdde7ce(0x200):this['host'])+':'+this[_0xdde7ce(0x1ca)]);_0x2f7deb['onerror']=()=>{var _0x1a7974=_0xdde7ce;this[_0x1a7974(0x232)]=!0x1,this['_disposeWebsocket'](_0x2f7deb),this[_0x1a7974(0x231)](),_0x397625(new Error(_0x1a7974(0x25c)));},_0x2f7deb[_0xdde7ce(0x1e9)]=()=>{var _0x4ae805=_0xdde7ce;this[_0x4ae805(0x238)]||_0x2f7deb[_0x4ae805(0x195)]&&_0x2f7deb['_socket'][_0x4ae805(0x1d6)]&&_0x2f7deb[_0x4ae805(0x195)][_0x4ae805(0x1d6)](),_0xb5574f(_0x2f7deb);},_0x2f7deb[_0xdde7ce(0x237)]=()=>{var _0x1489e8=_0xdde7ce;this[_0x1489e8(0x226)]=!0x0,this['_disposeWebsocket'](_0x2f7deb),this[_0x1489e8(0x231)]();},_0x2f7deb[_0xdde7ce(0x1e2)]=_0x5ec47a=>{var _0x2f06a3=_0xdde7ce;try{_0x5ec47a&&_0x5ec47a[_0x2f06a3(0x27e)]&&this[_0x2f06a3(0x238)]&&JSON[_0x2f06a3(0x254)](_0x5ec47a[_0x2f06a3(0x27e)])[_0x2f06a3(0x246)]==='reload'&&this[_0x2f06a3(0x259)]['location'][_0x2f06a3(0x207)]();}catch{}};})[_0x33a7a8(0x1f8)](_0x54cea0=>(this[_0x33a7a8(0x24b)]=!0x0,this[_0x33a7a8(0x1c9)]=!0x1,this['_allowedToConnectOnSend']=!0x1,this[_0x33a7a8(0x232)]=!0x0,this[_0x33a7a8(0x217)]=0x0,_0x54cea0))[_0x33a7a8(0x21e)](_0x3c4b0d=>(this[_0x33a7a8(0x24b)]=!0x1,this[_0x33a7a8(0x1c9)]=!0x1,console[_0x33a7a8(0x1f4)](_0x33a7a8(0x20e)+this[_0x33a7a8(0x1bd)]),_0x397625(new Error('failed\\x20to\\x20connect\\x20to\\x20host:\\x20'+(_0x3c4b0d&&_0x3c4b0d[_0x33a7a8(0x18e)])))));}));}[_0x2d7791(0x191)](_0x5786a7){var _0x3a9649=_0x2d7791;this[_0x3a9649(0x24b)]=!0x1,this[_0x3a9649(0x1c9)]=!0x1;try{_0x5786a7[_0x3a9649(0x237)]=null,_0x5786a7[_0x3a9649(0x1b2)]=null,_0x5786a7[_0x3a9649(0x1e9)]=null;}catch{}try{_0x5786a7['readyState']<0x2&&_0x5786a7[_0x3a9649(0x1f3)]();}catch{}}[_0x2d7791(0x231)](){var _0x33a894=_0x2d7791;clearTimeout(this[_0x33a894(0x270)]),!(this[_0x33a894(0x217)]>=this['_maxConnectAttemptCount'])&&(this[_0x33a894(0x270)]=setTimeout(()=>{var _0x4dbf2d=_0x33a894;this[_0x4dbf2d(0x24b)]||this[_0x4dbf2d(0x1c9)]||(this[_0x4dbf2d(0x1df)](),this['_ws']?.[_0x4dbf2d(0x21e)](()=>this[_0x4dbf2d(0x231)]()));},0x1f4),this[_0x33a894(0x270)][_0x33a894(0x1d6)]&&this[_0x33a894(0x270)][_0x33a894(0x1d6)]());}async[_0x2d7791(0x22f)](_0x4aa922){var _0x370d54=_0x2d7791;try{if(!this[_0x370d54(0x232)])return;this[_0x370d54(0x226)]&&this[_0x370d54(0x1df)](),(await this[_0x370d54(0x262)])['send'](JSON[_0x370d54(0x1b4)](_0x4aa922));}catch(_0x186408){console[_0x370d54(0x1f4)](this[_0x370d54(0x21b)]+':\\x20'+(_0x186408&&_0x186408[_0x370d54(0x18e)])),this[_0x370d54(0x232)]=!0x1,this[_0x370d54(0x231)]();}}};function J(_0x523f2f,_0x3d6d85,_0x5dc124,_0x5cf6b3,_0x4fc7d8,_0x2fa576){var _0x5b7572=_0x2d7791;let _0x4f044e=_0x5dc124['split'](',')['map'](_0x13b81c=>{var _0xc39585=_0x3cab;try{_0x523f2f[_0xc39585(0x230)]||((_0x4fc7d8===_0xc39585(0x25b)||_0x4fc7d8===_0xc39585(0x1db)||_0x4fc7d8===_0xc39585(0x26e))&&(_0x4fc7d8+=_0x523f2f[_0xc39585(0x248)]?.['versions']?.[_0xc39585(0x280)]?_0xc39585(0x23b):_0xc39585(0x21c)),_0x523f2f[_0xc39585(0x230)]={'id':+new Date(),'tool':_0x4fc7d8});let _0x24b973=new q(_0x523f2f,_0x3d6d85,_0x13b81c,_0x5cf6b3,_0x2fa576);return _0x24b973[_0xc39585(0x22f)][_0xc39585(0x204)](_0x24b973);}catch(_0x3dd00c){return console[_0xc39585(0x1f4)]('logger\\x20failed\\x20to\\x20connect\\x20to\\x20host',_0x3dd00c&&_0x3dd00c['message']),()=>{};}});return _0xe2986b=>_0x4f044e[_0x5b7572(0x22d)](_0x1a5ce5=>_0x1a5ce5(_0xe2986b));}function W(_0x5649e7){var _0x281c90=_0x2d7791;let _0x194214=function(_0x28f0ba,_0xada281){return _0xada281-_0x28f0ba;},_0x3131cf;if(_0x5649e7['performance'])_0x3131cf=function(){var _0x5a6bb5=_0x3cab;return _0x5649e7[_0x5a6bb5(0x1fa)][_0x5a6bb5(0x227)]();};else{if(_0x5649e7['process']&&_0x5649e7['process'][_0x281c90(0x20d)])_0x3131cf=function(){var _0x444144=_0x281c90;return _0x5649e7[_0x444144(0x248)]['hrtime']();},_0x194214=function(_0x101d62,_0x3e70b0){return 0x3e8*(_0x3e70b0[0x0]-_0x101d62[0x0])+(_0x3e70b0[0x1]-_0x101d62[0x1])/0xf4240;};else try{let {performance:_0x3cb0cd}=require(_0x281c90(0x247));_0x3131cf=function(){var _0x3d0d1e=_0x281c90;return _0x3cb0cd[_0x3d0d1e(0x227)]();};}catch{_0x3131cf=function(){return+new Date();};}}return{'elapsed':_0x194214,'timeStamp':_0x3131cf,'now':()=>Date[_0x281c90(0x227)]()};}function Y(_0x9aab03,_0x5588b8,_0x17021a){var _0x1f6798=_0x2d7791;if(_0x9aab03[_0x1f6798(0x1ef)]!==void 0x0)return _0x9aab03[_0x1f6798(0x1ef)];let _0x379754=_0x9aab03[_0x1f6798(0x248)]?.['versions']?.[_0x1f6798(0x280)];return _0x379754&&_0x17021a===_0x1f6798(0x1a6)?_0x9aab03[_0x1f6798(0x1ef)]=!0x1:_0x9aab03[_0x1f6798(0x1ef)]=_0x379754||!_0x5588b8||_0x9aab03[_0x1f6798(0x272)]?.[_0x1f6798(0x1ba)]&&_0x5588b8[_0x1f6798(0x1ac)](_0x9aab03[_0x1f6798(0x272)]['hostname']),_0x9aab03[_0x1f6798(0x1ef)];}function Q(_0x1d64e7,_0x4637e8,_0x392a1c,_0x24ebe9){var _0x18fcad=_0x2d7791;_0x1d64e7=_0x1d64e7,_0x4637e8=_0x4637e8,_0x392a1c=_0x392a1c,_0x24ebe9=_0x24ebe9;let _0x1c0d18=W(_0x1d64e7),_0x2b9216=_0x1c0d18[_0x18fcad(0x1f2)],_0x3a4faa=_0x1c0d18[_0x18fcad(0x26f)];class _0x53ff0b{constructor(){var _0x9417ed=_0x18fcad;this[_0x9417ed(0x1bc)]=/^(?!(?:do|if|in|for|let|new|try|var|case|else|enum|eval|false|null|this|true|void|with|break|catch|class|const|super|throw|while|yield|delete|export|import|public|return|static|switch|typeof|default|extends|finally|package|private|continue|debugger|function|arguments|interface|protected|implements|instanceof)$)[_$a-zA-Z\\xA0-\\uFFFF][_$a-zA-Z0-9\\xA0-\\uFFFF]*$/,this['_numberRegExp']=/^(0|[1-9][0-9]*)$/,this[_0x9417ed(0x1dd)]=/'([^\\\\']|\\\\')*'/,this[_0x9417ed(0x1a5)]=_0x1d64e7[_0x9417ed(0x1c8)],this['_HTMLAllCollection']=_0x1d64e7[_0x9417ed(0x205)],this['_getOwnPropertyDescriptor']=Object[_0x9417ed(0x1c3)],this[_0x9417ed(0x1bb)]=Object['getOwnPropertyNames'],this[_0x9417ed(0x1d3)]=_0x1d64e7[_0x9417ed(0x1b5)],this['_regExpToString']=RegExp['prototype'][_0x9417ed(0x1ea)],this[_0x9417ed(0x1d8)]=Date[_0x9417ed(0x1be)][_0x9417ed(0x1ea)];}[_0x18fcad(0x276)](_0x327300,_0x5635df,_0x8b0d1e,_0x10e2c4){var _0x43b7f5=_0x18fcad,_0x34c2b5=this,_0x4958ef=_0x8b0d1e[_0x43b7f5(0x1a4)];function _0x321d4d(_0x2e3894,_0x9965cb,_0x2a0b37){var _0x4f1e3e=_0x43b7f5;_0x9965cb['type']=_0x4f1e3e(0x279),_0x9965cb[_0x4f1e3e(0x273)]=_0x2e3894[_0x4f1e3e(0x18e)],_0x42daf2=_0x2a0b37[_0x4f1e3e(0x280)]['current'],_0x2a0b37[_0x4f1e3e(0x280)][_0x4f1e3e(0x1d2)]=_0x9965cb,_0x34c2b5[_0x4f1e3e(0x20c)](_0x9965cb,_0x2a0b37);}try{_0x8b0d1e[_0x43b7f5(0x1c6)]++,_0x8b0d1e[_0x43b7f5(0x1a4)]&&_0x8b0d1e[_0x43b7f5(0x228)][_0x43b7f5(0x27a)](_0x5635df);var _0x3810ac,_0x1af3d5,_0x26472a,_0x20fe2e,_0x2c2501=[],_0x41c28a=[],_0x57f325,_0x54f40c=this[_0x43b7f5(0x22b)](_0x5635df),_0x4d8ad0=_0x54f40c===_0x43b7f5(0x214),_0x3c52a4=!0x1,_0xc5e9d1=_0x54f40c==='function',_0x38a765=this['_isPrimitiveType'](_0x54f40c),_0xc1ec42=this[_0x43b7f5(0x1e6)](_0x54f40c),_0x3e93f6=_0x38a765||_0xc1ec42,_0x14ba76={},_0x4ddf52=0x0,_0x6cb626=!0x1,_0x42daf2,_0x1ab9ae=/^(([1-9]{1}[0-9]*)|0)$/;if(_0x8b0d1e[_0x43b7f5(0x1e4)]){if(_0x4d8ad0){if(_0x1af3d5=_0x5635df['length'],_0x1af3d5>_0x8b0d1e[_0x43b7f5(0x261)]){for(_0x26472a=0x0,_0x20fe2e=_0x8b0d1e['elements'],_0x3810ac=_0x26472a;_0x3810ac<_0x20fe2e;_0x3810ac++)_0x41c28a[_0x43b7f5(0x27a)](_0x34c2b5[_0x43b7f5(0x19c)](_0x2c2501,_0x5635df,_0x54f40c,_0x3810ac,_0x8b0d1e));_0x327300[_0x43b7f5(0x1a3)]=!0x0;}else{for(_0x26472a=0x0,_0x20fe2e=_0x1af3d5,_0x3810ac=_0x26472a;_0x3810ac<_0x20fe2e;_0x3810ac++)_0x41c28a['push'](_0x34c2b5[_0x43b7f5(0x19c)](_0x2c2501,_0x5635df,_0x54f40c,_0x3810ac,_0x8b0d1e));}_0x8b0d1e[_0x43b7f5(0x27b)]+=_0x41c28a[_0x43b7f5(0x1fb)];}if(!(_0x54f40c===_0x43b7f5(0x20f)||_0x54f40c===_0x43b7f5(0x1c8))&&!_0x38a765&&_0x54f40c!==_0x43b7f5(0x277)&&_0x54f40c!=='Buffer'&&_0x54f40c!==_0x43b7f5(0x1b1)){var _0x86c18d=_0x10e2c4[_0x43b7f5(0x274)]||_0x8b0d1e['props'];if(this[_0x43b7f5(0x23d)](_0x5635df)?(_0x3810ac=0x0,_0x5635df[_0x43b7f5(0x22d)](function(_0x10f882){var _0x1d582e=_0x43b7f5;if(_0x4ddf52++,_0x8b0d1e[_0x1d582e(0x27b)]++,_0x4ddf52>_0x86c18d){_0x6cb626=!0x0;return;}if(!_0x8b0d1e['isExpressionToEvaluate']&&_0x8b0d1e[_0x1d582e(0x1a4)]&&_0x8b0d1e[_0x1d582e(0x27b)]>_0x8b0d1e[_0x1d582e(0x1a9)]){_0x6cb626=!0x0;return;}_0x41c28a[_0x1d582e(0x27a)](_0x34c2b5[_0x1d582e(0x19c)](_0x2c2501,_0x5635df,_0x1d582e(0x239),_0x3810ac++,_0x8b0d1e,function(_0xe152d2){return function(){return _0xe152d2;};}(_0x10f882)));})):this[_0x43b7f5(0x278)](_0x5635df)&&_0x5635df[_0x43b7f5(0x22d)](function(_0x4eb752,_0x3af2a7){var _0x3ca3d9=_0x43b7f5;if(_0x4ddf52++,_0x8b0d1e['autoExpandPropertyCount']++,_0x4ddf52>_0x86c18d){_0x6cb626=!0x0;return;}if(!_0x8b0d1e[_0x3ca3d9(0x1c7)]&&_0x8b0d1e['autoExpand']&&_0x8b0d1e['autoExpandPropertyCount']>_0x8b0d1e['autoExpandLimit']){_0x6cb626=!0x0;return;}var _0x285ada=_0x3af2a7[_0x3ca3d9(0x1ea)]();_0x285ada[_0x3ca3d9(0x1fb)]>0x64&&(_0x285ada=_0x285ada[_0x3ca3d9(0x218)](0x0,0x64)+_0x3ca3d9(0x215)),_0x41c28a[_0x3ca3d9(0x27a)](_0x34c2b5['_addProperty'](_0x2c2501,_0x5635df,_0x3ca3d9(0x263),_0x285ada,_0x8b0d1e,function(_0xdad0cc){return function(){return _0xdad0cc;};}(_0x4eb752)));}),!_0x3c52a4){try{for(_0x57f325 in _0x5635df)if(!(_0x4d8ad0&&_0x1ab9ae['test'](_0x57f325))&&!this[_0x43b7f5(0x1a7)](_0x5635df,_0x57f325,_0x8b0d1e)){if(_0x4ddf52++,_0x8b0d1e['autoExpandPropertyCount']++,_0x4ddf52>_0x86c18d){_0x6cb626=!0x0;break;}if(!_0x8b0d1e[_0x43b7f5(0x1c7)]&&_0x8b0d1e[_0x43b7f5(0x1a4)]&&_0x8b0d1e[_0x43b7f5(0x27b)]>_0x8b0d1e['autoExpandLimit']){_0x6cb626=!0x0;break;}_0x41c28a[_0x43b7f5(0x27a)](_0x34c2b5['_addObjectProperty'](_0x2c2501,_0x14ba76,_0x5635df,_0x54f40c,_0x57f325,_0x8b0d1e));}}catch{}if(_0x14ba76[_0x43b7f5(0x23c)]=!0x0,_0xc5e9d1&&(_0x14ba76[_0x43b7f5(0x1dc)]=!0x0),!_0x6cb626){var _0x43417b=[][_0x43b7f5(0x257)](this[_0x43b7f5(0x1bb)](_0x5635df))['concat'](this['_getOwnPropertySymbols'](_0x5635df));for(_0x3810ac=0x0,_0x1af3d5=_0x43417b[_0x43b7f5(0x1fb)];_0x3810ac<_0x1af3d5;_0x3810ac++)if(_0x57f325=_0x43417b[_0x3810ac],!(_0x4d8ad0&&_0x1ab9ae[_0x43b7f5(0x1b3)](_0x57f325['toString']()))&&!this['_blacklistedProperty'](_0x5635df,_0x57f325,_0x8b0d1e)&&!_0x14ba76[_0x43b7f5(0x1b0)+_0x57f325[_0x43b7f5(0x1ea)]()]){if(_0x4ddf52++,_0x8b0d1e[_0x43b7f5(0x27b)]++,_0x4ddf52>_0x86c18d){_0x6cb626=!0x0;break;}if(!_0x8b0d1e[_0x43b7f5(0x1c7)]&&_0x8b0d1e[_0x43b7f5(0x1a4)]&&_0x8b0d1e[_0x43b7f5(0x27b)]>_0x8b0d1e[_0x43b7f5(0x1a9)]){_0x6cb626=!0x0;break;}_0x41c28a[_0x43b7f5(0x27a)](_0x34c2b5[_0x43b7f5(0x1e5)](_0x2c2501,_0x14ba76,_0x5635df,_0x54f40c,_0x57f325,_0x8b0d1e));}}}}}if(_0x327300[_0x43b7f5(0x1ae)]=_0x54f40c,_0x3e93f6?(_0x327300[_0x43b7f5(0x1d4)]=_0x5635df[_0x43b7f5(0x1c5)](),this[_0x43b7f5(0x27f)](_0x54f40c,_0x327300,_0x8b0d1e,_0x10e2c4)):_0x54f40c===_0x43b7f5(0x1f1)?_0x327300[_0x43b7f5(0x1d4)]=this[_0x43b7f5(0x1d8)][_0x43b7f5(0x1b6)](_0x5635df):_0x54f40c===_0x43b7f5(0x1b1)?_0x327300[_0x43b7f5(0x1d4)]=_0x5635df['toString']():_0x54f40c===_0x43b7f5(0x236)?_0x327300['value']=this[_0x43b7f5(0x271)][_0x43b7f5(0x1b6)](_0x5635df):_0x54f40c===_0x43b7f5(0x266)&&this[_0x43b7f5(0x1d3)]?_0x327300['value']=this[_0x43b7f5(0x1d3)]['prototype'][_0x43b7f5(0x1ea)][_0x43b7f5(0x1b6)](_0x5635df):!_0x8b0d1e['depth']&&!(_0x54f40c===_0x43b7f5(0x20f)||_0x54f40c==='undefined')&&(delete _0x327300[_0x43b7f5(0x1d4)],_0x327300[_0x43b7f5(0x1e0)]=!0x0),_0x6cb626&&(_0x327300['cappedProps']=!0x0),_0x42daf2=_0x8b0d1e['node'][_0x43b7f5(0x1d2)],_0x8b0d1e['node']['current']=_0x327300,this[_0x43b7f5(0x20c)](_0x327300,_0x8b0d1e),_0x41c28a[_0x43b7f5(0x1fb)]){for(_0x3810ac=0x0,_0x1af3d5=_0x41c28a['length'];_0x3810ac<_0x1af3d5;_0x3810ac++)_0x41c28a[_0x3810ac](_0x3810ac);}_0x2c2501[_0x43b7f5(0x1fb)]&&(_0x327300[_0x43b7f5(0x274)]=_0x2c2501);}catch(_0x1ba49c){_0x321d4d(_0x1ba49c,_0x327300,_0x8b0d1e);}return this['_additionalMetadata'](_0x5635df,_0x327300),this[_0x43b7f5(0x1e3)](_0x327300,_0x8b0d1e),_0x8b0d1e['node'][_0x43b7f5(0x1d2)]=_0x42daf2,_0x8b0d1e[_0x43b7f5(0x1c6)]--,_0x8b0d1e[_0x43b7f5(0x1a4)]=_0x4958ef,_0x8b0d1e['autoExpand']&&_0x8b0d1e['autoExpandPreviousObjects'][_0x43b7f5(0x240)](),_0x327300;}[_0x18fcad(0x26c)](_0x4f9120){var _0x294dcb=_0x18fcad;return Object[_0x294dcb(0x203)]?Object[_0x294dcb(0x203)](_0x4f9120):[];}[_0x18fcad(0x23d)](_0x202491){var _0x1d8bc7=_0x18fcad;return!!(_0x202491&&_0x1d64e7[_0x1d8bc7(0x239)]&&this[_0x1d8bc7(0x18f)](_0x202491)===_0x1d8bc7(0x202)&&_0x202491[_0x1d8bc7(0x22d)]);}[_0x18fcad(0x1a7)](_0x405d38,_0x25012f,_0x1f10c4){var _0x50de68=_0x18fcad;return _0x1f10c4['noFunctions']?typeof _0x405d38[_0x25012f]==_0x50de68(0x22c):!0x1;}['_type'](_0x1cc695){var _0x10f742=_0x18fcad,_0x49294c='';return _0x49294c=typeof _0x1cc695,_0x49294c==='object'?this['_objectToString'](_0x1cc695)===_0x10f742(0x25e)?_0x49294c=_0x10f742(0x214):this['_objectToString'](_0x1cc695)===_0x10f742(0x26a)?_0x49294c=_0x10f742(0x1f1):this[_0x10f742(0x18f)](_0x1cc695)===_0x10f742(0x22a)?_0x49294c='bigint':_0x1cc695===null?_0x49294c=_0x10f742(0x20f):_0x1cc695[_0x10f742(0x1ee)]&&(_0x49294c=_0x1cc695['constructor'][_0x10f742(0x192)]||_0x49294c):_0x49294c==='undefined'&&this['_HTMLAllCollection']&&_0x1cc695 instanceof this[_0x10f742(0x1ec)]&&(_0x49294c=_0x10f742(0x205)),_0x49294c;}[_0x18fcad(0x18f)](_0x5f53c7){var _0x2306f0=_0x18fcad;return Object[_0x2306f0(0x1be)]['toString']['call'](_0x5f53c7);}['_isPrimitiveType'](_0x2da62c){var _0x3104bc=_0x18fcad;return _0x2da62c===_0x3104bc(0x1c4)||_0x2da62c===_0x3104bc(0x251)||_0x2da62c===_0x3104bc(0x27c);}[_0x18fcad(0x1e6)](_0x1df4ca){var _0x59f4b9=_0x18fcad;return _0x1df4ca===_0x59f4b9(0x233)||_0x1df4ca===_0x59f4b9(0x277)||_0x1df4ca===_0x59f4b9(0x19b);}[_0x18fcad(0x19c)](_0x4c1a3b,_0x532cfa,_0x2f570c,_0x2ad205,_0x35de52,_0x5b8e84){var _0x2dee12=this;return function(_0x3cca5f){var _0x6729e2=_0x3cab,_0x2ba604=_0x35de52[_0x6729e2(0x280)][_0x6729e2(0x1d2)],_0x53df10=_0x35de52[_0x6729e2(0x280)][_0x6729e2(0x1cb)],_0x2f8405=_0x35de52['node'][_0x6729e2(0x1cd)];_0x35de52[_0x6729e2(0x280)]['parent']=_0x2ba604,_0x35de52['node']['index']=typeof _0x2ad205==_0x6729e2(0x27c)?_0x2ad205:_0x3cca5f,_0x4c1a3b[_0x6729e2(0x27a)](_0x2dee12[_0x6729e2(0x1f6)](_0x532cfa,_0x2f570c,_0x2ad205,_0x35de52,_0x5b8e84)),_0x35de52[_0x6729e2(0x280)][_0x6729e2(0x1cd)]=_0x2f8405,_0x35de52['node']['index']=_0x53df10;};}['_addObjectProperty'](_0x33663c,_0x3fe7a,_0x4d007c,_0x2ea419,_0x2eed11,_0x4c49e7,_0x1fa24a){var _0x29318f=_0x18fcad,_0x974c86=this;return _0x3fe7a['_p_'+_0x2eed11[_0x29318f(0x1ea)]()]=!0x0,function(_0x47469c){var _0x727b31=_0x29318f,_0x38b45c=_0x4c49e7[_0x727b31(0x280)][_0x727b31(0x1d2)],_0x42db84=_0x4c49e7[_0x727b31(0x280)][_0x727b31(0x1cb)],_0x4a5369=_0x4c49e7[_0x727b31(0x280)]['parent'];_0x4c49e7['node']['parent']=_0x38b45c,_0x4c49e7[_0x727b31(0x280)][_0x727b31(0x1cb)]=_0x47469c,_0x33663c[_0x727b31(0x27a)](_0x974c86['_property'](_0x4d007c,_0x2ea419,_0x2eed11,_0x4c49e7,_0x1fa24a)),_0x4c49e7[_0x727b31(0x280)][_0x727b31(0x1cd)]=_0x4a5369,_0x4c49e7[_0x727b31(0x280)][_0x727b31(0x1cb)]=_0x42db84;};}[_0x18fcad(0x1f6)](_0x4c27af,_0x5ae0f8,_0x50a7bf,_0x34c311,_0x2a2ddc){var _0x2987ef=_0x18fcad,_0x311f83=this;_0x2a2ddc||(_0x2a2ddc=function(_0x53acf6,_0x39887a){return _0x53acf6[_0x39887a];});var _0x43db74=_0x50a7bf[_0x2987ef(0x1ea)](),_0x175e67=_0x34c311['expressionsToEvaluate']||{},_0x894916=_0x34c311[_0x2987ef(0x1e4)],_0x44b750=_0x34c311[_0x2987ef(0x1c7)];try{var _0x2c35d1=this[_0x2987ef(0x278)](_0x4c27af),_0x308b4b=_0x43db74;_0x2c35d1&&_0x308b4b[0x0]==='\\x27'&&(_0x308b4b=_0x308b4b[_0x2987ef(0x1b7)](0x1,_0x308b4b[_0x2987ef(0x1fb)]-0x2));var _0x19a735=_0x34c311[_0x2987ef(0x256)]=_0x175e67[_0x2987ef(0x1b0)+_0x308b4b];_0x19a735&&(_0x34c311[_0x2987ef(0x1e4)]=_0x34c311[_0x2987ef(0x1e4)]+0x1),_0x34c311[_0x2987ef(0x1c7)]=!!_0x19a735;var _0x5bdd2b=typeof _0x50a7bf==_0x2987ef(0x266),_0x9d199d={'name':_0x5bdd2b||_0x2c35d1?_0x43db74:this[_0x2987ef(0x1c0)](_0x43db74)};if(_0x5bdd2b&&(_0x9d199d[_0x2987ef(0x266)]=!0x0),!(_0x5ae0f8===_0x2987ef(0x214)||_0x5ae0f8===_0x2987ef(0x282))){var _0xf50dc9=this['_getOwnPropertyDescriptor'](_0x4c27af,_0x50a7bf);if(_0xf50dc9&&(_0xf50dc9[_0x2987ef(0x1d0)]&&(_0x9d199d[_0x2987ef(0x252)]=!0x0),_0xf50dc9[_0x2987ef(0x1af)]&&!_0x19a735&&!_0x34c311['resolveGetters']))return _0x9d199d[_0x2987ef(0x20a)]=!0x0,this['_processTreeNodeResult'](_0x9d199d,_0x34c311),_0x9d199d;}var _0x405385;try{_0x405385=_0x2a2ddc(_0x4c27af,_0x50a7bf);}catch(_0x51faca){return _0x9d199d={'name':_0x43db74,'type':'unknown','error':_0x51faca[_0x2987ef(0x18e)]},this['_processTreeNodeResult'](_0x9d199d,_0x34c311),_0x9d199d;}var _0x1b7995=this['_type'](_0x405385),_0x1cfce5=this[_0x2987ef(0x1bf)](_0x1b7995);if(_0x9d199d['type']=_0x1b7995,_0x1cfce5)this[_0x2987ef(0x193)](_0x9d199d,_0x34c311,_0x405385,function(){var _0x2834be=_0x2987ef;_0x9d199d[_0x2834be(0x1d4)]=_0x405385[_0x2834be(0x1c5)](),!_0x19a735&&_0x311f83['_capIfString'](_0x1b7995,_0x9d199d,_0x34c311,{});});else{var _0x297db7=_0x34c311[_0x2987ef(0x1a4)]&&_0x34c311[_0x2987ef(0x1c6)]<_0x34c311[_0x2987ef(0x219)]&&_0x34c311['autoExpandPreviousObjects'][_0x2987ef(0x21d)](_0x405385)<0x0&&_0x1b7995!==_0x2987ef(0x22c)&&_0x34c311[_0x2987ef(0x27b)]<_0x34c311[_0x2987ef(0x1a9)];_0x297db7||_0x34c311[_0x2987ef(0x1c6)]<_0x894916||_0x19a735?(this['serialize'](_0x9d199d,_0x405385,_0x34c311,_0x19a735||{}),this[_0x2987ef(0x264)](_0x405385,_0x9d199d)):this[_0x2987ef(0x193)](_0x9d199d,_0x34c311,_0x405385,function(){var _0x288eeb=_0x2987ef;_0x1b7995==='null'||_0x1b7995===_0x288eeb(0x1c8)||(delete _0x9d199d[_0x288eeb(0x1d4)],_0x9d199d[_0x288eeb(0x1e0)]=!0x0);});}return _0x9d199d;}finally{_0x34c311[_0x2987ef(0x256)]=_0x175e67,_0x34c311[_0x2987ef(0x1e4)]=_0x894916,_0x34c311['isExpressionToEvaluate']=_0x44b750;}}[_0x18fcad(0x27f)](_0x4a3ab6,_0x561a1b,_0x424fb2,_0x34846a){var _0x50a103=_0x18fcad,_0x102ee6=_0x34846a['strLength']||_0x424fb2['strLength'];if((_0x4a3ab6===_0x50a103(0x251)||_0x4a3ab6===_0x50a103(0x277))&&_0x561a1b[_0x50a103(0x1d4)]){let _0x24ea65=_0x561a1b['value'][_0x50a103(0x1fb)];_0x424fb2['allStrLength']+=_0x24ea65,_0x424fb2[_0x50a103(0x250)]>_0x424fb2[_0x50a103(0x1a0)]?(_0x561a1b[_0x50a103(0x1e0)]='',delete _0x561a1b[_0x50a103(0x1d4)]):_0x24ea65>_0x102ee6&&(_0x561a1b['capped']=_0x561a1b[_0x50a103(0x1d4)]['substr'](0x0,_0x102ee6),delete _0x561a1b[_0x50a103(0x1d4)]);}}[_0x18fcad(0x278)](_0x521672){var _0x19eeed=_0x18fcad;return!!(_0x521672&&_0x1d64e7[_0x19eeed(0x263)]&&this[_0x19eeed(0x18f)](_0x521672)===_0x19eeed(0x1b9)&&_0x521672['forEach']);}[_0x18fcad(0x1c0)](_0x2a0315){var _0x384d6b=_0x18fcad;if(_0x2a0315[_0x384d6b(0x216)](/^\\d+$/))return _0x2a0315;var _0x218613;try{_0x218613=JSON['stringify'](''+_0x2a0315);}catch{_0x218613='\\x22'+this[_0x384d6b(0x18f)](_0x2a0315)+'\\x22';}return _0x218613[_0x384d6b(0x216)](/^\"([a-zA-Z_][a-zA-Z_0-9]*)\"$/)?_0x218613=_0x218613[_0x384d6b(0x1b7)](0x1,_0x218613[_0x384d6b(0x1fb)]-0x2):_0x218613=_0x218613['replace'](/'/g,'\\x5c\\x27')[_0x384d6b(0x1e1)](/\\\\\"/g,'\\x22')['replace'](/(^\"|\"$)/g,'\\x27'),_0x218613;}[_0x18fcad(0x193)](_0x355386,_0x106496,_0x15251f,_0xa95399){var _0x3572c9=_0x18fcad;this[_0x3572c9(0x20c)](_0x355386,_0x106496),_0xa95399&&_0xa95399(),this[_0x3572c9(0x264)](_0x15251f,_0x355386),this[_0x3572c9(0x1e3)](_0x355386,_0x106496);}[_0x18fcad(0x20c)](_0x59695b,_0x533d29){var _0x5869f0=_0x18fcad;this[_0x5869f0(0x1ed)](_0x59695b,_0x533d29),this[_0x5869f0(0x190)](_0x59695b,_0x533d29),this['_setNodeExpressionPath'](_0x59695b,_0x533d29),this[_0x5869f0(0x1c1)](_0x59695b,_0x533d29);}['_setNodeId'](_0x5d236a,_0x4cc203){}['_setNodeQueryPath'](_0x3e78f2,_0x174b27){}['_setNodeLabel'](_0x3031eb,_0x2d12ba){}[_0x18fcad(0x211)](_0x122ede){var _0x2e18c4=_0x18fcad;return _0x122ede===this[_0x2e18c4(0x1a5)];}['_treeNodePropertiesAfterFullValue'](_0x93dd3c,_0x2854fa){var _0x53246e=_0x18fcad;this[_0x53246e(0x213)](_0x93dd3c,_0x2854fa),this[_0x53246e(0x275)](_0x93dd3c),_0x2854fa['sortProps']&&this['_sortProps'](_0x93dd3c),this[_0x53246e(0x265)](_0x93dd3c,_0x2854fa),this[_0x53246e(0x19d)](_0x93dd3c,_0x2854fa),this[_0x53246e(0x234)](_0x93dd3c);}['_additionalMetadata'](_0x49f480,_0x55a94d){var _0x2678aa=_0x18fcad;let _0x24cc7c;try{_0x1d64e7['console']&&(_0x24cc7c=_0x1d64e7['console'][_0x2678aa(0x273)],_0x1d64e7[_0x2678aa(0x1f5)][_0x2678aa(0x273)]=function(){}),_0x49f480&&typeof _0x49f480[_0x2678aa(0x1fb)]==_0x2678aa(0x27c)&&(_0x55a94d[_0x2678aa(0x1fb)]=_0x49f480[_0x2678aa(0x1fb)]);}catch{}finally{_0x24cc7c&&(_0x1d64e7[_0x2678aa(0x1f5)][_0x2678aa(0x273)]=_0x24cc7c);}if(_0x55a94d['type']===_0x2678aa(0x27c)||_0x55a94d[_0x2678aa(0x1ae)]===_0x2678aa(0x19b)){if(isNaN(_0x55a94d[_0x2678aa(0x1d4)]))_0x55a94d[_0x2678aa(0x23f)]=!0x0,delete _0x55a94d[_0x2678aa(0x1d4)];else switch(_0x55a94d['value']){case Number[_0x2678aa(0x1f7)]:_0x55a94d['positiveInfinity']=!0x0,delete _0x55a94d[_0x2678aa(0x1d4)];break;case Number[_0x2678aa(0x210)]:_0x55a94d[_0x2678aa(0x198)]=!0x0,delete _0x55a94d['value'];break;case 0x0:this[_0x2678aa(0x197)](_0x55a94d['value'])&&(_0x55a94d[_0x2678aa(0x269)]=!0x0);break;}}else _0x55a94d[_0x2678aa(0x1ae)]===_0x2678aa(0x22c)&&typeof _0x49f480[_0x2678aa(0x192)]==_0x2678aa(0x251)&&_0x49f480[_0x2678aa(0x192)]&&_0x55a94d['name']&&_0x49f480['name']!==_0x55a94d[_0x2678aa(0x192)]&&(_0x55a94d['funcName']=_0x49f480['name']);}[_0x18fcad(0x197)](_0x330920){var _0x507993=_0x18fcad;return 0x1/_0x330920===Number[_0x507993(0x210)];}[_0x18fcad(0x224)](_0x5165b7){var _0x2d6212=_0x18fcad;!_0x5165b7[_0x2d6212(0x274)]||!_0x5165b7[_0x2d6212(0x274)][_0x2d6212(0x1fb)]||_0x5165b7['type']===_0x2d6212(0x214)||_0x5165b7[_0x2d6212(0x1ae)]===_0x2d6212(0x263)||_0x5165b7[_0x2d6212(0x1ae)]==='Set'||_0x5165b7['props']['sort'](function(_0x567fca,_0x54973b){var _0x57859e=_0x2d6212,_0x3de391=_0x567fca['name'][_0x57859e(0x25f)](),_0x181e83=_0x54973b[_0x57859e(0x192)][_0x57859e(0x25f)]();return _0x3de391<_0x181e83?-0x1:_0x3de391>_0x181e83?0x1:0x0;});}[_0x18fcad(0x265)](_0x59636a,_0x83119f){var _0x43ea2c=_0x18fcad;if(!(_0x83119f[_0x43ea2c(0x242)]||!_0x59636a[_0x43ea2c(0x274)]||!_0x59636a[_0x43ea2c(0x274)][_0x43ea2c(0x1fb)])){for(var _0x4fa9eb=[],_0x55b3cd=[],_0x6573b0=0x0,_0x1179bc=_0x59636a[_0x43ea2c(0x274)]['length'];_0x6573b0<_0x1179bc;_0x6573b0++){var _0x59bd82=_0x59636a[_0x43ea2c(0x274)][_0x6573b0];_0x59bd82[_0x43ea2c(0x1ae)]===_0x43ea2c(0x22c)?_0x4fa9eb[_0x43ea2c(0x27a)](_0x59bd82):_0x55b3cd[_0x43ea2c(0x27a)](_0x59bd82);}if(!(!_0x55b3cd[_0x43ea2c(0x1fb)]||_0x4fa9eb[_0x43ea2c(0x1fb)]<=0x1)){_0x59636a[_0x43ea2c(0x274)]=_0x55b3cd;var _0x53e3bf={'functionsNode':!0x0,'props':_0x4fa9eb};this[_0x43ea2c(0x1ed)](_0x53e3bf,_0x83119f),this[_0x43ea2c(0x213)](_0x53e3bf,_0x83119f),this[_0x43ea2c(0x275)](_0x53e3bf),this[_0x43ea2c(0x1c1)](_0x53e3bf,_0x83119f),_0x53e3bf['id']+='\\x20f',_0x59636a['props'][_0x43ea2c(0x27d)](_0x53e3bf);}}}[_0x18fcad(0x19d)](_0x2a2eb5,_0x1b9984){}[_0x18fcad(0x275)](_0x272ef4){}['_isArray'](_0x16266d){var _0x549387=_0x18fcad;return Array[_0x549387(0x249)](_0x16266d)||typeof _0x16266d=='object'&&this['_objectToString'](_0x16266d)===_0x549387(0x25e);}[_0x18fcad(0x1c1)](_0x478f96,_0x366ce4){}['_cleanNode'](_0x2a2592){var _0x3beca8=_0x18fcad;delete _0x2a2592[_0x3beca8(0x24d)],delete _0x2a2592[_0x3beca8(0x19e)],delete _0x2a2592[_0x3beca8(0x1a8)];}['_setNodeExpressionPath'](_0x3da120,_0x4641bf){}}let _0x2d3d52=new _0x53ff0b(),_0x2dec38={'props':0x64,'elements':0x64,'strLength':0x400*0x32,'totalStrLength':0x400*0x32,'autoExpandLimit':0x1388,'autoExpandMaxDepth':0xa},_0x145ef3={'props':0x5,'elements':0x5,'strLength':0x100,'totalStrLength':0x100*0x3,'autoExpandLimit':0x1e,'autoExpandMaxDepth':0x2};function _0x3ba465(_0x1825c9,_0x442dea,_0x35c8e7,_0x240886,_0xbbef0b,_0x4d217d){var _0x365062=_0x18fcad;let _0x21e627,_0xd51162;try{_0xd51162=_0x3a4faa(),_0x21e627=_0x392a1c[_0x442dea],!_0x21e627||_0xd51162-_0x21e627['ts']>0x1f4&&_0x21e627[_0x365062(0x208)]&&_0x21e627[_0x365062(0x1d7)]/_0x21e627[_0x365062(0x208)]<0x64?(_0x392a1c[_0x442dea]=_0x21e627={'count':0x0,'time':0x0,'ts':_0xd51162},_0x392a1c[_0x365062(0x19f)]={}):_0xd51162-_0x392a1c[_0x365062(0x19f)]['ts']>0x32&&_0x392a1c[_0x365062(0x19f)][_0x365062(0x208)]&&_0x392a1c['hits'][_0x365062(0x1d7)]/_0x392a1c[_0x365062(0x19f)]['count']<0x64&&(_0x392a1c[_0x365062(0x19f)]={});let _0xf56013=[],_0x206920=_0x21e627['reduceLimits']||_0x392a1c[_0x365062(0x19f)]['reduceLimits']?_0x145ef3:_0x2dec38,_0x14554e=_0xd8f91b=>{var _0x5e0672=_0x365062;let _0xe86b6b={};return _0xe86b6b[_0x5e0672(0x274)]=_0xd8f91b['props'],_0xe86b6b[_0x5e0672(0x261)]=_0xd8f91b[_0x5e0672(0x261)],_0xe86b6b[_0x5e0672(0x26b)]=_0xd8f91b[_0x5e0672(0x26b)],_0xe86b6b[_0x5e0672(0x1a0)]=_0xd8f91b[_0x5e0672(0x1a0)],_0xe86b6b[_0x5e0672(0x1a9)]=_0xd8f91b[_0x5e0672(0x1a9)],_0xe86b6b[_0x5e0672(0x219)]=_0xd8f91b['autoExpandMaxDepth'],_0xe86b6b[_0x5e0672(0x1fc)]=!0x1,_0xe86b6b[_0x5e0672(0x242)]=!_0x4637e8,_0xe86b6b[_0x5e0672(0x1e4)]=0x1,_0xe86b6b[_0x5e0672(0x1c6)]=0x0,_0xe86b6b[_0x5e0672(0x260)]=_0x5e0672(0x220),_0xe86b6b[_0x5e0672(0x243)]=_0x5e0672(0x26d),_0xe86b6b[_0x5e0672(0x1a4)]=!0x0,_0xe86b6b[_0x5e0672(0x228)]=[],_0xe86b6b[_0x5e0672(0x27b)]=0x0,_0xe86b6b[_0x5e0672(0x1da)]=!0x0,_0xe86b6b[_0x5e0672(0x250)]=0x0,_0xe86b6b[_0x5e0672(0x280)]={'current':void 0x0,'parent':void 0x0,'index':0x0},_0xe86b6b;};for(var _0x2aef3a=0x0;_0x2aef3a<_0xbbef0b['length'];_0x2aef3a++)_0xf56013[_0x365062(0x27a)](_0x2d3d52['serialize']({'timeNode':_0x1825c9==='time'||void 0x0},_0xbbef0b[_0x2aef3a],_0x14554e(_0x206920),{}));if(_0x1825c9===_0x365062(0x23a)){let _0x34be50=Error['stackTraceLimit'];try{Error[_0x365062(0x235)]=0x1/0x0,_0xf56013[_0x365062(0x27a)](_0x2d3d52[_0x365062(0x276)]({'stackNode':!0x0},new Error()[_0x365062(0x1d5)],_0x14554e(_0x206920),{'strLength':0x1/0x0}));}finally{Error[_0x365062(0x235)]=_0x34be50;}}return{'method':_0x365062(0x1aa),'version':_0x24ebe9,'args':[{'ts':_0x35c8e7,'session':_0x240886,'args':_0xf56013,'id':_0x442dea,'context':_0x4d217d}]};}catch(_0x10855c){return{'method':_0x365062(0x1aa),'version':_0x24ebe9,'args':[{'ts':_0x35c8e7,'session':_0x240886,'args':[{'type':'unknown','error':_0x10855c&&_0x10855c[_0x365062(0x18e)]}],'id':_0x442dea,'context':_0x4d217d}]};}finally{try{if(_0x21e627&&_0xd51162){let _0x1de8e4=_0x3a4faa();_0x21e627[_0x365062(0x208)]++,_0x21e627['time']+=_0x2b9216(_0xd51162,_0x1de8e4),_0x21e627['ts']=_0x1de8e4,_0x392a1c[_0x365062(0x19f)][_0x365062(0x208)]++,_0x392a1c[_0x365062(0x19f)][_0x365062(0x1d7)]+=_0x2b9216(_0xd51162,_0x1de8e4),_0x392a1c['hits']['ts']=_0x1de8e4,(_0x21e627[_0x365062(0x208)]>0x32||_0x21e627['time']>0x64)&&(_0x21e627['reduceLimits']=!0x0),(_0x392a1c['hits'][_0x365062(0x208)]>0x3e8||_0x392a1c[_0x365062(0x19f)]['time']>0x12c)&&(_0x392a1c[_0x365062(0x19f)][_0x365062(0x21f)]=!0x0);}}catch{}}}return _0x3ba465;}((_0x3568b9,_0x3f86c1,_0x1375dc,_0xde4aa1,_0x3d7e57,_0x56a0ca,_0x7e7645,_0x303053,_0x14024c,_0x3430ee)=>{var _0x52db73=_0x2d7791;if(_0x3568b9['_console_ninja'])return _0x3568b9[_0x52db73(0x1eb)];if(!Y(_0x3568b9,_0x303053,_0x3d7e57))return _0x3568b9[_0x52db73(0x1eb)]={'consoleLog':()=>{},'consoleTrace':()=>{},'consoleTime':()=>{},'consoleTimeEnd':()=>{},'autoLog':()=>{},'autoLogMany':()=>{},'autoTraceMany':()=>{},'coverage':()=>{},'autoTrace':()=>{},'autoTime':()=>{},'autoTimeEnd':()=>{}},_0x3568b9[_0x52db73(0x1eb)];let _0x46431f=W(_0x3568b9),_0x411376=_0x46431f['elapsed'],_0x29441f=_0x46431f[_0x52db73(0x26f)],_0x263e68=_0x46431f[_0x52db73(0x227)],_0xe96a0f={'hits':{},'ts':{}},_0x4ffb2b=Q(_0x3568b9,_0x14024c,_0xe96a0f,_0x56a0ca),_0xdec271=_0x3d1bf3=>{_0xe96a0f['ts'][_0x3d1bf3]=_0x29441f();},_0x1e119d=(_0x1a89fb,_0x1e81a1)=>{var _0x302d87=_0x52db73;let _0x5495cc=_0xe96a0f['ts'][_0x1e81a1];if(delete _0xe96a0f['ts'][_0x1e81a1],_0x5495cc){let _0x4c4392=_0x411376(_0x5495cc,_0x29441f());_0x46025a(_0x4ffb2b(_0x302d87(0x1d7),_0x1a89fb,_0x263e68(),_0x3718dc,[_0x4c4392],_0x1e81a1));}},_0x192667=_0x3dae6c=>_0x73f083=>{var _0x234d15=_0x52db73;try{_0xdec271(_0x73f083),_0x3dae6c(_0x73f083);}finally{_0x3568b9[_0x234d15(0x1f5)][_0x234d15(0x1d7)]=_0x3dae6c;}},_0x5a6b7d=_0xd9ef74=>_0x2595dc=>{var _0x1e8a03=_0x52db73;try{let [_0x537ffc,_0x1d8a7c]=_0x2595dc[_0x1e8a03(0x25d)](':logPointId:');_0x1e119d(_0x1d8a7c,_0x537ffc),_0xd9ef74(_0x537ffc);}finally{_0x3568b9['console'][_0x1e8a03(0x268)]=_0xd9ef74;}};_0x3568b9[_0x52db73(0x1eb)]={'consoleLog':(_0x2d1152,_0x3438d1)=>{var _0x2fac8f=_0x52db73;_0x3568b9[_0x2fac8f(0x1f5)][_0x2fac8f(0x1aa)][_0x2fac8f(0x192)]!=='disabledLog'&&_0x46025a(_0x4ffb2b('log',_0x2d1152,_0x263e68(),_0x3718dc,_0x3438d1));},'consoleTrace':(_0x47e3cb,_0x198de1)=>{var _0x267a49=_0x52db73;_0x3568b9[_0x267a49(0x1f5)]['log'][_0x267a49(0x192)]!==_0x267a49(0x20b)&&_0x46025a(_0x4ffb2b('trace',_0x47e3cb,_0x263e68(),_0x3718dc,_0x198de1));},'consoleTime':()=>{var _0x279520=_0x52db73;_0x3568b9['console'][_0x279520(0x1d7)]=_0x192667(_0x3568b9[_0x279520(0x1f5)][_0x279520(0x1d7)]);},'consoleTimeEnd':()=>{var _0x3780dd=_0x52db73;_0x3568b9['console'][_0x3780dd(0x268)]=_0x5a6b7d(_0x3568b9[_0x3780dd(0x1f5)][_0x3780dd(0x268)]);},'autoLog':(_0x50b1f8,_0x450a5c)=>{var _0x5714b9=_0x52db73;_0x46025a(_0x4ffb2b(_0x5714b9(0x1aa),_0x450a5c,_0x263e68(),_0x3718dc,[_0x50b1f8]));},'autoLogMany':(_0x1ace08,_0x2c8791)=>{var _0x497242=_0x52db73;_0x46025a(_0x4ffb2b(_0x497242(0x1aa),_0x1ace08,_0x263e68(),_0x3718dc,_0x2c8791));},'autoTrace':(_0x1ddc92,_0x47d60a)=>{var _0x5a1e9b=_0x52db73;_0x46025a(_0x4ffb2b(_0x5a1e9b(0x23a),_0x47d60a,_0x263e68(),_0x3718dc,[_0x1ddc92]));},'autoTraceMany':(_0x280240,_0x47f8fb)=>{var _0x5ebd8a=_0x52db73;_0x46025a(_0x4ffb2b(_0x5ebd8a(0x23a),_0x280240,_0x263e68(),_0x3718dc,_0x47f8fb));},'autoTime':(_0x5cd56c,_0x44b796,_0x31bc26)=>{_0xdec271(_0x31bc26);},'autoTimeEnd':(_0x47ba98,_0x13adb5,_0x1e3ddd)=>{_0x1e119d(_0x13adb5,_0x1e3ddd);},'coverage':_0x11c4a0=>{var _0x4a6e10=_0x52db73;_0x46025a({'method':_0x4a6e10(0x281),'version':_0x56a0ca,'args':[{'id':_0x11c4a0}]});}};let _0x46025a=J(_0x3568b9,_0x3f86c1,_0x1375dc,_0xde4aa1,_0x3d7e57,_0x3430ee),_0x3718dc=_0x3568b9[_0x52db73(0x230)];return _0x3568b9[_0x52db73(0x1eb)];})(globalThis,_0x2d7791(0x212),_0x2d7791(0x229),_0x2d7791(0x1d1),_0x2d7791(0x241),_0x2d7791(0x194),_0x2d7791(0x1cf),_0x2d7791(0x1f9),_0x2d7791(0x221),'');");
}
catch (e) { } }
;
function oo_oo(i, ...v) { try {
    oo_cm().consoleLog(i, v);
}
catch (e) { } return v; }
;
oo_oo;
function oo_tr(i, ...v) { try {
    oo_cm().consoleTrace(i, v);
}
catch (e) { } return v; }
;
oo_tr;
function oo_ts() { try {
    oo_cm().consoleTime();
}
catch (e) { } }
;
oo_ts;
function oo_te() { try {
    oo_cm().consoleTimeEnd();
}
catch (e) { } }
;
oo_te; /*eslint eslint-comments/disable-enable-pair:,eslint-comments/no-unlimited-disable:,eslint-comments/no-aggregating-enable:,eslint-comments/no-duplicate-disable:,eslint-comments/no-unused-disable:,eslint-comments/no-unused-enable:,*/


/***/ }),

/***/ "./src/components/context/app-provider/index.ts":
/*!******************************************************!*\
  !*** ./src/components/context/app-provider/index.ts ***!
  \******************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
tslib_1.__exportStar(__webpack_require__(/*! ./app-provider.component */ "./src/components/context/app-provider/app-provider.component.tsx"), exports);


/***/ }),

/***/ "./src/components/context/breakpoint-provider/breakpoint-provider.component.tsx":
/*!**************************************************************************************!*\
  !*** ./src/components/context/breakpoint-provider/breakpoint-provider.component.tsx ***!
  \**************************************************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.BreakpointProvider = exports.findLast = void 0;
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
const react_1 = tslib_1.__importStar(__webpack_require__(/*! react */ "react"));
const react_jss_1 = __webpack_require__(/*! react-jss */ "react-jss");
const smarthub_common_1 = __webpack_require__(/*! smarthub-common */ "smarthub-common");
const use_debounce_1 = __webpack_require__(/*! use-debounce */ "use-debounce");
const resize_observer_polyfill_1 = tslib_1.__importDefault(__webpack_require__(/*! resize-observer-polyfill */ "resize-observer-polyfill"));
const useStyles = react_jss_1.createUseStyles({
    breakpoint: {
        margin: 0,
        padding: 0,
        border: 0,
        width: "100%",
        boxSizing: "border-box",
    },
});
function findLast(array, predicate) {
    let l = array.length;
    while (l--) {
        const o = array[l];
        if (predicate(o, l, array))
            return o;
    }
    return null;
}
exports.findLast = findLast;
const BreakpointProvider = (_a) => {
    var _b;
    var { children, className, as } = _a, props = tslib_1.__rest(_a, ["children", "className", "as"]);
    const ref = react_1.useRef(null);
    const styles = useStyles();
    const parentContextRef = smarthub_common_1.useHookRef(smarthub_common_1.useBreakpoint);
    const level = ((_b = parentContextRef.current) === null || _b === void 0 ? void 0 : _b.current) ? parentContextRef.current.current.level + 1
        : 0;
    const gridStyles = smarthub_common_1.useCreateGridStyles(`bp${level}`);
    const contextRef = react_1.useRef(null);
    const [context, setContextState] = react_1.useState(null);
    const [classNames, setClassNames] = react_1.useState(null);
    const RootElement = as || "div";
    const setContext = react_1.useCallback((next) => {
        const { current: currentContext } = contextRef;
        const { current: current } = currentContext || {};
        const root = (parentContextRef === null || parentContextRef === void 0 ? void 0 : parentContextRef.current) ? parentContextRef === null || parentContextRef === void 0 ? void 0 : parentContextRef.current : current;
        contextRef.current = {
            current: Object.assign(Object.assign({}, current), next),
            root,
        };
        setContextState(contextRef.current);
    }, []);
    const setBreakpoint = (width) => tslib_1.__awaiter(void 0, void 0, void 0, function* () {
        var _c;
        const currentBp = findLast(smarthub_common_1.responsiveBreakPoints, (bp) => width >= bp.width);
        if (((_c = contextRef.current) === null || _c === void 0 ? void 0 : _c.current.size) != currentBp.size) {
            smarthub_common_1.responsiveBreakPoints.indexOf(currentBp);
            const classes = smarthub_common_1.responsiveBreakPoints
                .slice(0, currentBp.size + 1)
                .reduce((value, bp) => `${value} ${gridStyles[`bp${bp.name}`]}`, "");
            setClassNames(classes);
            setContext(Object.assign(Object.assign({}, currentBp), { level, styles: gridStyles }));
        }
    });
    const debounce = use_debounce_1.useDebouncedCallback(setBreakpoint, 300);
    react_1.useEffect(() => {
        const { current: currentContext } = contextRef;
        if (!currentContext)
            return;
        const { current: currentLevel } = currentContext;
        if (currentLevel.styles == gridStyles)
            return;
        const classes = smarthub_common_1.responsiveBreakPoints
            .slice(0, currentLevel.size + 1)
            .reduce((value, bp) => `${value} ${gridStyles[`bp${bp.name}`]}`, "");
        setClassNames(classes);
        setContext({
            styles: gridStyles,
        });
    }, [gridStyles.grid]);
    react_1.useEffect(() => {
        if (level > 0) {
            const ro = new resize_observer_polyfill_1.default((entries) => setBreakpoint(entries[0].contentRect.width));
            const { current } = ref;
            ro.observe(current);
            debounce(current.clientWidth);
            return () => {
                if (current)
                    ro.unobserve(current);
            };
        }
        const handleResize = () => setBreakpoint(window.innerWidth);
        window.addEventListener("resize", handleResize);
        debounce(window.innerWidth);
        return () => window.removeEventListener("resize", handleResize);
    }, []);
    return RootElement == react_1.Fragment ? (react_1.default.createElement(react_1.default.Fragment, null, context && (react_1.default.createElement(smarthub_common_1.BreakpointContext.Provider, { value: context }, children)))) : (react_1.default.createElement(RootElement, Object.assign({}, props, { ref: ref, className: [
            (className === null || className === void 0 ? void 0 : className.length) ? className : styles.breakpoint,
            classNames,
        ].join(" ") }), context && (react_1.default.createElement(smarthub_common_1.BreakpointContext.Provider, { value: context }, children))));
};
exports.BreakpointProvider = BreakpointProvider;


/***/ }),

/***/ "./src/components/context/breakpoint-provider/index.ts":
/*!*************************************************************!*\
  !*** ./src/components/context/breakpoint-provider/index.ts ***!
  \*************************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
tslib_1.__exportStar(__webpack_require__(/*! ./breakpoint-provider.component */ "./src/components/context/breakpoint-provider/breakpoint-provider.component.tsx"), exports);


/***/ }),

/***/ "./src/components/context/chatbot-provider/chatbot-provider.component.tsx":
/*!********************************************************************************!*\
  !*** ./src/components/context/chatbot-provider/chatbot-provider.component.tsx ***!
  \********************************************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.ChatBotProvider = void 0;
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
const react_1 = tslib_1.__importStar(__webpack_require__(/*! react */ "react"));
const smarthub_common_1 = __webpack_require__(/*! smarthub-common */ "smarthub-common");
const botframework_webchat_1 = __webpack_require__(/*! botframework-webchat */ "botframework-webchat");
const react_2 = __webpack_require__(/*! react */ "react");
const botframework_directlinejs_1 = __webpack_require__(/*! botframework-directlinejs */ "botframework-directlinejs");
function getBrowserLocales(options = {}) {
    const defaultOptions = {
        languageCodeOnly: false,
    };
    const opt = Object.assign(Object.assign({}, defaultOptions), options);
    const browserLocales = navigator.languages === undefined
        ? [navigator.language]
        : navigator.languages;
    if (!browserLocales) {
        return undefined;
    }
    return browserLocales.map((locale) => {
        const trimmedLocale = locale.trim();
        return opt.languageCodeOnly ? trimmedLocale.split(/-|_/)[0] : trimmedLocale;
    });
}
const nextScope = (scopes, current, size) => {
    const first = scopes === null || scopes === void 0 ? void 0 : scopes[0];
    if (!current ||
        !(scopes === null || scopes === void 0 ? void 0 : scopes.length) ||
        (first.target === "panel" && size === "full"))
        return first;
    const scope = scopes.find(({ name, title, subTitle }) => current.name == name ||
        (current.title == title && current.subTitle == subTitle));
    return scope || first;
};
//TODO break out scope management
const ChatBotProvider = ({ children, webChatConfig, adaptiveCardHostConfig, }) => {
    const { cogsvc } = smarthub_common_1.useProviders();
    const authContext = smarthub_common_1.useAuth();
    const authContextRef = react_1.useRef(null);
    authContextRef.current = authContext;
    const profile = smarthub_common_1.useProfile();
    const profileRef = react_1.useRef(null);
    profileRef.current = profile;
    const theme = smarthub_common_1.useTheme();
    const setLocale = smarthub_common_1.useSetLocale();
    const { enabled: tpcEnabled } = smarthub_common_1.useTPCCheck();
    //TODO update state management of keywords - move to higher context
    const [, setKeywords] = smarthub_common_1.useKeywords();
    const sourceInfo = smarthub_common_1.useSourceInfo();
    const panelViewRef = smarthub_common_1.useHookRef(smarthub_common_1.usePanelView, "chat");
    const setPanelView = smarthub_common_1.useSetPanelView("chat");
    const setPanelState = react_1.useCallback((scope, selected = false) => {
        const { current: state } = panelViewRef;
        const isSearch = (scope === null || scope === void 0 ? void 0 : scope.target) === "panel";
        const visible = !isSearch ? selected : false;
        if (state.visible != visible) {
            setPanelView(Object.assign(Object.assign({}, state), { visible }));
        }
    }, []);
    const detectedLanguage = react_1.useMemo(() => {
        let language = getBrowserLocales({ languageCodeOnly: true })[0];
        // get the site language.  If it is not supported, use the default language
        let docLang = document.documentElement.lang.split(/-|_/)[0];
        let lang = docLang === language ? language : docLang;
        // let availLangs = languages.map((x: IPanelLanguage) => {
        //   return x.language;
        // });
        // if (!availLangs.includes(lang)) {
        //   // if not, use the default language
        //   lang = availLangs[0];
        // }
        return lang;
    }, []);
    react_2.useEffect(() => {
        setLocale(smarthub_common_1.LocalizeLanguages[detectedLanguage]);
    }, [detectedLanguage]);
    //TODO update state management of scopes - move to child context
    const setScopes = react_1.useCallback((scopes, params) => {
        var _a;
        contextRef.current.scopes = scopes;
        const { current: { scope: currentScope }, } = contextRef;
        const scope = nextScope(scopes, currentScope, (_a = panelViewRef.current) === null || _a === void 0 ? void 0 : _a.size);
        if (currentScope != scope)
            setPanelState(scope);
        applyScope(scope, params);
        setContext({
            scopes,
            scope,
        });
    }, []);
    const applyScope = react_1.useCallback((chatContext, params) => tslib_1.__awaiter(void 0, void 0, void 0, function* () {
        const { current: profile } = profileRef;
        try {
            if (chatContext === null || chatContext === void 0 ? void 0 : chatContext.scope) {
                const { current: { directlineContext: { config, directline }, }, } = contextRef;
                const scope = smarthub_common_1.deepReplaceParams(chatContext.scope, Object.assign(Object.assign({}, params), { profile }));
                yield smarthub_common_1.sendBackChannel(directline, config, profile, sourceInfo, {
                    payload: {
                        scope,
                    },
                    type: "context.scope",
                    version: "1.0",
                });
            }
            setKeywords(null);
        }
        catch (ex) {
            smarthub_common_1.Logger.error("Failed to apply chat scope", false, ex);
        }
    }), []);
    const setScope = react_1.useCallback((scope, params) => tslib_1.__awaiter(void 0, void 0, void 0, function* () {
        applyScope(scope, params);
        setPanelState(scope, true);
        setContext({
            scope,
        });
    }), []);
    const openDirectLine = react_1.useCallback((refresh) => tslib_1.__awaiter(void 0, void 0, void 0, function* () {
        const { current: profile } = profileRef;
        const { current: auth } = authContextRef;
        try {
            let config;
            for (var i = 0; i < cogsvc.length; i++) {
                config = yield cogsvc[i].process(auth, config, refresh);
            }
            const { bot: { user: { id: userId, tokenOnly, ref: userToken }, token, personality, }, } = config;
            const directline = botframework_webchat_1.createDirectLine({
                token: token,
                watermark: "SmartChat",
                conversationStartProperties: {
                    locale: `[{"key":"personality","value":"${personality}"},{"key":"locale","value":"${detectedLanguage}"}]`,
                },
            });
            if (!tokenOnly && directline.setUserId) {
                /*
                  HACK! when bot token does not contain a user attribute (v2)
                  the connection fails. Calling setUserId resolves the issue.
                  The WebChat still tries to set the userId which fails bc
                  directline has already connected.
                  Override the setUserId to fix this
                */
                directline.setUserId(userId);
                const setUserId = directline.setUserId;
                directline.setUserId = () => {
                    if (directline.connectionStatus$.getValue() !== botframework_directlinejs_1.ConnectionStatus.Online)
                        setUserId(userId);
                };
            }
            yield smarthub_common_1.sendBackChannel(directline, config, profile, sourceInfo, {
                payload: {
                    user: userToken,
                    personality,
                    tpc: tpcEnabled,
                },
                type: "context.user",
                version: "1.0",
            });
            setContext({
                directlineContext: {
                    directline,
                    config,
                },
            });
        }
        catch (ex) {
            smarthub_common_1.Logger.error("Failed to load directline", false, ex);
        }
    }), []);
    const reset = react_1.useCallback(() => tslib_1.__awaiter(void 0, void 0, void 0, function* () { return openDirectLine(true); }), []);
    const contextRef = react_1.useRef({
        setScopes,
        setScope,
        reset,
    });
    const [context, setContextState] = react_2.useState(contextRef.current);
    const setContext = react_1.useCallback((next) => {
        contextRef.current = Object.assign(Object.assign({}, contextRef.current), next);
        setContextState(contextRef.current);
    }, []);
    react_2.useEffect(() => {
        const hostConfig = smarthub_common_1.mergeHostConfigStyles(adaptiveCardHostConfig, theme.definition);
        const styleOptions = smarthub_common_1.mergeWebchatStyles(webChatConfig.styleOptions, theme.definition);
        const styleSet = smarthub_common_1.mergeWebchatStyleset(webChatConfig.styleSet, styleOptions, theme.definition);
        setContext({
            hostConfig,
            webChat: Object.assign(Object.assign({}, webChatConfig), { styleOptions,
                styleSet }),
        });
    }, [theme]);
    react_2.useEffect(() => {
        if (authContext &&
            profile &&
            !(context === null || context === void 0 ? void 0 : context.directlineContext) &&
            detectedLanguage)
            openDirectLine();
    }, [authContext, profile, detectedLanguage]);
    return (react_1.default.createElement(smarthub_common_1.ChatBotContext.Provider, { value: context }, children));
};
exports.ChatBotProvider = ChatBotProvider;


/***/ }),

/***/ "./src/components/context/chatbot-provider/index.ts":
/*!**********************************************************!*\
  !*** ./src/components/context/chatbot-provider/index.ts ***!
  \**********************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
tslib_1.__exportStar(__webpack_require__(/*! ./chatbot-provider.component */ "./src/components/context/chatbot-provider/chatbot-provider.component.tsx"), exports);


/***/ }),

/***/ "./src/components/context/core-context/core-context.component.tsx":
/*!************************************************************************!*\
  !*** ./src/components/context/core-context/core-context.component.tsx ***!
  \************************************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.CoreContext = void 0;
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
const react_1 = tslib_1.__importStar(__webpack_require__(/*! react */ "react"));
const __1 = __webpack_require__(/*! ../ */ "./src/components/context/index.ts");
const middleware_provider_1 = __webpack_require__(/*! ../middleware-provider */ "./src/components/context/middleware-provider/index.ts");
const personality_provider_1 = __webpack_require__(/*! ../personality-provider */ "./src/components/context/personality-provider/index.ts");
const CoreContext = (_a) => {
    var { children, middleware, localizeConfig, tpcCheck, themes, onAPIReady } = _a, props = tslib_1.__rest(_a, ["children", "middleware", "localizeConfig", "tpcCheck", "themes", "onAPIReady"]);
    return (react_1.default.createElement(__1.TPCCheckProvider, { config: tpcCheck },
        react_1.default.createElement(__1.BreakpointProvider, { as: react_1.Fragment },
            react_1.default.createElement(personality_provider_1.PersonalityProvider, null,
                react_1.default.createElement(__1.AppProvider, Object.assign({}, props),
                    react_1.default.createElement(__1.PageProvider, null,
                        react_1.default.createElement(__1.LocalizeProvider, { config: localizeConfig },
                            react_1.default.createElement(middleware_provider_1.MiddlewareProvider, { config: middleware },
                                react_1.default.createElement(__1.PreferenceProvider, null,
                                    react_1.default.createElement(__1.ThemeProvider, { themes: themes },
                                        react_1.default.createElement(__1.APIProvider, { onAPIReady: onAPIReady }, children)))))))))));
};
exports.CoreContext = CoreContext;


/***/ }),

/***/ "./src/components/context/core-context/index.ts":
/*!******************************************************!*\
  !*** ./src/components/context/core-context/index.ts ***!
  \******************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
tslib_1.__exportStar(__webpack_require__(/*! ./core-context.component */ "./src/components/context/core-context/core-context.component.tsx"), exports);


/***/ }),

/***/ "./src/components/context/extended-api/extended-api.component.tsx":
/*!************************************************************************!*\
  !*** ./src/components/context/extended-api/extended-api.component.tsx ***!
  \************************************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.ExtendedAPI = void 0;
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
const react_1 = tslib_1.__importStar(__webpack_require__(/*! react */ "react"));
const smarthub_common_1 = __webpack_require__(/*! smarthub-common */ "smarthub-common");
const ExtendedAPI = ({ children }) => {
    const setExtendedAPI = smarthub_common_1.useSetExtendedAPI();
    const command = smarthub_common_1.useHandleCommand();
    const setBotReady = smarthub_common_1.useSetBotReady();
    react_1.useEffect(() => {
        setExtendedAPI({
            command
        });
        setBotReady(true);
    }, []);
    return react_1.default.createElement(react_1.default.Fragment, null, children);
};
exports.ExtendedAPI = ExtendedAPI;


/***/ }),

/***/ "./src/components/context/extended-api/index.ts":
/*!******************************************************!*\
  !*** ./src/components/context/extended-api/index.ts ***!
  \******************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
tslib_1.__exportStar(__webpack_require__(/*! ./extended-api.component */ "./src/components/context/extended-api/extended-api.component.tsx"), exports);


/***/ }),

/***/ "./src/components/context/extended-context/extended-context.component.tsx":
/*!********************************************************************************!*\
  !*** ./src/components/context/extended-context/extended-context.component.tsx ***!
  \********************************************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.ExtendedContext = void 0;
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
const React = tslib_1.__importStar(__webpack_require__(/*! react */ "react"));
const __1 = __webpack_require__(/*! ../ */ "./src/components/context/index.ts");
const chat_root_1 = __webpack_require__(/*! ../../chat-root */ "./src/components/chat-root/index.ts");
const ExtendedContext = ({ children, adaptiveCardHostConfig, webChatConfig }) => {
    return (React.createElement(__1.ProfileProvider, null,
        React.createElement(__1.NotificationProvider, null,
            React.createElement(__1.PanelsProvider, null,
                React.createElement(__1.LocationProvider, null,
                    React.createElement(__1.ChatBotProvider, Object.assign({}, {
                        webChatConfig,
                        adaptiveCardHostConfig
                    }),
                        React.createElement(chat_root_1.ChatRoot, null,
                            React.createElement(__1.ExtendedAPI, null, children))))))));
};
exports.ExtendedContext = ExtendedContext;


/***/ }),

/***/ "./src/components/context/extended-context/index.ts":
/*!**********************************************************!*\
  !*** ./src/components/context/extended-context/index.ts ***!
  \**********************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
tslib_1.__exportStar(__webpack_require__(/*! ./extended-context.component */ "./src/components/context/extended-context/extended-context.component.tsx"), exports);


/***/ }),

/***/ "./src/components/context/index.ts":
/*!*****************************************!*\
  !*** ./src/components/context/index.ts ***!
  \*****************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
tslib_1.__exportStar(__webpack_require__(/*! ./api-provider */ "./src/components/context/api-provider/index.ts"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./extended-api */ "./src/components/context/extended-api/index.ts"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./extended-context */ "./src/components/context/extended-context/index.ts"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./core-context */ "./src/components/context/core-context/index.ts"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./app-provider */ "./src/components/context/app-provider/index.ts"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./theme-provider */ "./src/components/context/theme-provider/index.ts"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./chatbot-provider */ "./src/components/context/chatbot-provider/index.ts"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./profile-provider */ "./src/components/context/profile-provider/index.ts"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./panels-provider */ "./src/components/context/panels-provider/index.ts"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./localize-provider */ "./src/components/context/localize-provider/index.ts"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./middleware-provider */ "./src/components/context/middleware-provider/index.ts"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./breakpoint-provider */ "./src/components/context/breakpoint-provider/index.ts"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./location-provider */ "./src/components/context/location-provider/index.ts"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./notification-provider */ "./src/components/context/notification-provider/index.ts"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./preference-provider */ "./src/components/context/preference-provider/index.ts"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./panel-view-provider */ "./src/components/context/panel-view-provider/index.ts"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./page-provider */ "./src/components/context/page-provider/index.ts"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./tpc-check-provider */ "./src/components/context/tpc-check-provider/index.ts"), exports);


/***/ }),

/***/ "./src/components/context/localize-provider/index.ts":
/*!***********************************************************!*\
  !*** ./src/components/context/localize-provider/index.ts ***!
  \***********************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
tslib_1.__exportStar(__webpack_require__(/*! ./localize-provider.component */ "./src/components/context/localize-provider/localize-provider.component.tsx"), exports);


/***/ }),

/***/ "./src/components/context/localize-provider/localize-provider.component.tsx":
/*!**********************************************************************************!*\
  !*** ./src/components/context/localize-provider/localize-provider.component.tsx ***!
  \**********************************************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.LocalizeProvider = void 0;
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
const react_1 = tslib_1.__importStar(__webpack_require__(/*! react */ "react"));
const smarthub_common_1 = __webpack_require__(/*! smarthub-common */ "smarthub-common");
const dayjs_1 = tslib_1.__importDefault(__webpack_require__(/*! dayjs */ "dayjs"));
const LocalizeProvider = ({ children, config }) => {
    const setLocale = react_1.useCallback((lang) => {
        const localeConfig = config[lang];
        dayjs_1.default.locale(lang);
        if (localeConfig)
            setContext({
                config: localeConfig,
                locale: lang,
                setLocale
            });
    }, [config]);
    const [context, setContext] = react_1.useState(null);
    react_1.useEffect(() => {
        dayjs_1.default.locale(config.defaultLanguage);
        setContext({
            config: config[config.defaultLanguage],
            locale: config.defaultLanguage,
            setLocale
        });
    }, []);
    return react_1.default.createElement(smarthub_common_1.LocalizeContext.Provider, { value: context }, children);
};
exports.LocalizeProvider = LocalizeProvider;


/***/ }),

/***/ "./src/components/context/location-provider/index.ts":
/*!***********************************************************!*\
  !*** ./src/components/context/location-provider/index.ts ***!
  \***********************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.LocationProvider = void 0;
var location_provider_component_1 = __webpack_require__(/*! ./location-provider.component */ "./src/components/context/location-provider/location-provider.component.tsx");
Object.defineProperty(exports, "LocationProvider", ({ enumerable: true, get: function () { return location_provider_component_1.LocationProvider; } }));


/***/ }),

/***/ "./src/components/context/location-provider/is-partial-location.helper.ts":
/*!********************************************************************************!*\
  !*** ./src/components/context/location-provider/is-partial-location.helper.ts ***!
  \********************************************************************************/
/***/ ((__unused_webpack_module, exports) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.isPartialLocation = exports.isPartialItem = void 0;
const isPartialItem = (current, next) => {
    var _a, _b, _c, _d, _e, _f, _g;
    if (!current)
        return true;
    const { panel: currentPanel, tab: currentTab } = current || {};
    const { panel, tab } = next || {};
    return (panel === null || panel === void 0 ? void 0 : panel.id) == ((_a = current === null || current === void 0 ? void 0 : current.panel) === null || _a === void 0 ? void 0 : _a.id)
        && ((!((_b = currentPanel === null || currentPanel === void 0 ? void 0 : currentPanel.entity) === null || _b === void 0 ? void 0 : _b.length) && ((_c = panel === null || panel === void 0 ? void 0 : panel.entity) === null || _c === void 0 ? void 0 : _c.length) > 0)
            || (!((_d = currentTab === null || currentTab === void 0 ? void 0 : currentTab.id) === null || _d === void 0 ? void 0 : _d.length) && ((_e = tab === null || tab === void 0 ? void 0 : tab.id) === null || _e === void 0 ? void 0 : _e.length) > 0)
            || (!((_f = currentTab === null || currentTab === void 0 ? void 0 : currentTab.entity) === null || _f === void 0 ? void 0 : _f.length) && ((_g = tab === null || tab === void 0 ? void 0 : tab.entity) === null || _g === void 0 ? void 0 : _g.length) > 0));
};
exports.isPartialItem = isPartialItem;
const isPartialLocation = (current, next) => !current
    || ((next === null || next === void 0 ? void 0 : next.main) && exports.isPartialItem(current === null || current === void 0 ? void 0 : current.main, next === null || next === void 0 ? void 0 : next.main))
    || ((next === null || next === void 0 ? void 0 : next.page) && exports.isPartialItem(current === null || current === void 0 ? void 0 : current.page, next === null || next === void 0 ? void 0 : next.page));
exports.isPartialLocation = isPartialLocation;


/***/ }),

/***/ "./src/components/context/location-provider/location-provider.component.tsx":
/*!**********************************************************************************!*\
  !*** ./src/components/context/location-provider/location-provider.component.tsx ***!
  \**********************************************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.LocationProvider = void 0;
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
const react_1 = tslib_1.__importStar(__webpack_require__(/*! react */ "react"));
const smarthub_common_1 = __webpack_require__(/*! smarthub-common */ "smarthub-common");
const is_partial_location_helper_1 = __webpack_require__(/*! ./is-partial-location.helper */ "./src/components/context/location-provider/is-partial-location.helper.ts");
const parse_location_helper_1 = __webpack_require__(/*! ./parse-location.helper */ "./src/components/context/location-provider/parse-location.helper.ts");
const stringify_location_helper_1 = __webpack_require__(/*! ./stringify-location.helper */ "./src/components/context/location-provider/stringify-location.helper.ts");
const use_app_location_hook_1 = __webpack_require__(/*! ./use-app-location.hook */ "./src/components/context/location-provider/use-app-location.hook.ts");
const use_debounce_1 = __webpack_require__(/*! use-debounce */ "use-debounce");
const use_handle_redirect_hook_1 = __webpack_require__(/*! ./use-handle-redirect.hook */ "./src/components/context/location-provider/use-handle-redirect.hook.ts");
const LocationProvider = ({ children }) => {
    const contextRef = react_1.useRef({
        location: null,
        path: ''
    });
    const handleRedirect = use_handle_redirect_hook_1.useHandleRedirect();
    const [next, setNext] = use_app_location_hook_1.useAppLocation();
    const [context, setContext] = react_1.useState(contextRef.current);
    const debounceNext = use_debounce_1.useDebouncedCallback((value) => {
        const { current: { location: current, path: currentPath } } = contextRef;
        const path = stringify_location_helper_1.stringifyLocation(value);
        if (currentPath == path)
            return;
        contextRef.current = {
            path,
            location: next
        };
        setContext(contextRef.current);
        const replace = is_partial_location_helper_1.isPartialLocation(current, value);
        if (replace)
            history.replaceState({}, "", path);
        else
            history.pushState({}, "", path);
    }, 50);
    react_1.useEffect(() => debounceNext(next), [next]);
    const onUrlChange = react_1.useCallback((url) => tslib_1.__awaiter(void 0, void 0, void 0, function* () {
        let { path, location } = parse_location_helper_1.parseLocation(url);
        const redirected = yield handleRedirect(location);
        if (redirected) {
            const { current: { path: currentPath } = {} } = contextRef;
            history.replaceState({}, "", currentPath);
            return;
        }
        contextRef.current = {
            path,
            location
        };
        setContext(contextRef.current);
        setNext(location);
    }), []);
    react_1.useEffect(() => {
        const handleHashChange = ({ newURL }) => onUrlChange(newURL);
        window.addEventListener('hashchange', handleHashChange);
        onUrlChange(document.location.href);
        return () => {
            window.removeEventListener('hashchange', handleHashChange);
        };
    }, []);
    return (react_1.default.createElement(smarthub_common_1.LocationContext.Provider, { value: context }, context && children));
};
exports.LocationProvider = LocationProvider;


/***/ }),

/***/ "./src/components/context/location-provider/parse-location.helper.ts":
/*!***************************************************************************!*\
  !*** ./src/components/context/location-provider/parse-location.helper.ts ***!
  \***************************************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.parseLocation = void 0;
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
const query_string_1 = tslib_1.__importDefault(__webpack_require__(/*! query-string */ "query-string"));
const parseId = (path, endPos, current) => {
    const colonPos = path.indexOf(":");
    if (~colonPos && colonPos < endPos) {
        current.id = path.substring(0, colonPos).trim();
        current.entity = decodeURIComponent(path.substring(colonPos + 1, endPos).trim());
    }
    else
        current.id = path.substring(0, endPos).trim();
};
const parseParams = (search) => {
    if (search.length <= 1)
        return {};
    const query = query_string_1.default.parse(search, { decode: true });
    return Object.keys(query).reduce((params, key) => {
        const keys = key.split('.');
        const value = query[key];
        let obj = params;
        keys.forEach((subKey, idx, keys) => {
            if (idx == keys.length - 1)
                obj[subKey] = value;
            else
                obj = obj[subKey] = (obj[subKey] || {});
        });
        return params;
    }, {});
};
const parsePath = (path, current) => {
    const nextSlash = path.indexOf('/');
    const nextHash = path.indexOf('#');
    let end = 0;
    if (~nextSlash && (!~nextHash || nextSlash < nextHash))
        parseId(path, end = nextSlash, current);
    else if (~nextHash && (!~nextSlash || nextHash < nextSlash)) {
        parseId(path, nextHash, current);
        current.params = parseParams(path.substring(nextHash + 1, end = ~nextSlash
            ? nextSlash
            : path.length));
    }
    else
        parseId(path, end = path.length, current);
    return path.substring(end + 1);
};
const parsePaths = (path, items) => {
    path = parsePath(path.indexOf('/') == 0
        ? path.substring(1)
        : path, items.panel);
    if (path.length)
        path = parsePath(path, items.tab);
    return path;
};
const parseLocation = (uri) => {
    const pos = uri.indexOf('#');
    const searchPos = uri.lastIndexOf('?');
    const hash = pos > 0
        ? uri.substring(pos + 1, searchPos > pos ? searchPos : undefined)
        : '';
    const search = searchPos > 0
        ? uri.substring(searchPos + 1, pos > searchPos ? pos : undefined)
        : '';
    const location = {
        main: {
            panel: { id: null },
            tab: { id: null }
        },
        page: null,
        params: parseParams(search)
    };
    if (hash.length) {
        const path = parsePaths(hash, location.main);
        if (path.length) {
            location.page = {
                panel: { id: null },
                tab: { id: null }
            };
            parsePaths(path, location.page);
        }
    }
    return {
        location,
        path: `${(hash === null || hash === void 0 ? void 0 : hash.length) ? '#' : ''}${hash}${(search === null || search === void 0 ? void 0 : search.length) ? '?' : ''}${search}`
    };
};
exports.parseLocation = parseLocation;


/***/ }),

/***/ "./src/components/context/location-provider/stringify-location.helper.ts":
/*!*******************************************************************************!*\
  !*** ./src/components/context/location-provider/stringify-location.helper.ts ***!
  \*******************************************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.stringifyLocation = void 0;
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
const query_string_1 = tslib_1.__importDefault(__webpack_require__(/*! query-string */ "query-string"));
const flatten = (obj, flat, keyPath) => {
    const keys = Object.keys(obj);
    flat = flat !== null && flat !== void 0 ? flat : {};
    keyPath = keyPath !== null && keyPath !== void 0 ? keyPath : '';
    keys
        .sort()
        .forEach(key => {
        const value = obj[key];
        const flatKey = `${keyPath}${keyPath.length ? '.' : ''}${key}`;
        if (value && typeof value == 'object')
            flatten(value, flat, flatKey);
        else if (value && (typeof value != 'string' || value.length > 0))
            flat[flatKey] = value;
    });
    return flat;
};
const parseParams = (params, inline) => {
    if (!params || !Object.keys(params).length)
        return '';
    const flat = flatten(params);
    const serialised = query_string_1.default.stringify(flat, { encode: true });
    return serialised.length
        ? `${inline ? '#' : '?'}${serialised}`
        : '';
};
const parsePath = (item, separateEmpty) => {
    var _a;
    if (!((_a = item === null || item === void 0 ? void 0 : item.id) === null || _a === void 0 ? void 0 : _a.length))
        return separateEmpty ? '/' : '';
    const { id, entity, params } = item;
    const prms = parseParams(params, true);
    const entId = (entity === null || entity === void 0 ? void 0 : entity.length) ? `:${encodeURIComponent(entity)}` : '';
    return `/${id}${entId}${prms}`;
};
const parsePaths = (items, separateEmpty) => {
    const panel = parsePath(items === null || items === void 0 ? void 0 : items.panel, separateEmpty);
    const tab = parsePath(items === null || items === void 0 ? void 0 : items.tab, separateEmpty);
    return `${panel}${tab}`;
};
const stringifyLocation = (appLocation) => {
    var _a, _b, _c;
    const main = parsePaths(appLocation.main, ((_c = (_b = (_a = appLocation.page) === null || _a === void 0 ? void 0 : _a.panel) === null || _b === void 0 ? void 0 : _b.id) === null || _c === void 0 ? void 0 : _c.length) > 0);
    const page = parsePaths(appLocation.page);
    const params = parseParams(appLocation.params);
    return `#${main}${page}${params}`;
};
exports.stringifyLocation = stringifyLocation;


/***/ }),

/***/ "./src/components/context/location-provider/use-app-location.hook.ts":
/*!***************************************************************************!*\
  !*** ./src/components/context/location-provider/use-app-location.hook.ts ***!
  \***************************************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.useAppLocation = void 0;
const react_1 = __webpack_require__(/*! react */ "react");
const use_location_items_hook_1 = __webpack_require__(/*! ./use-location-items.hook */ "./src/components/context/location-provider/use-location-items.hook.ts");
const useAppLocation = () => {
    const [main, setMain] = use_location_items_hook_1.useLocationItems('main');
    const [page, setPage] = use_location_items_hook_1.useLocationItems('page');
    const value = react_1.useMemo(() => ({ main, page }), [main, page]);
    const setter = react_1.useCallback((location) => {
        setMain(location === null || location === void 0 ? void 0 : location.main);
        setPage(location === null || location === void 0 ? void 0 : location.page);
    }, []);
    return [value, setter];
};
exports.useAppLocation = useAppLocation;


/***/ }),

/***/ "./src/components/context/location-provider/use-handle-redirect.hook.ts":
/*!******************************************************************************!*\
  !*** ./src/components/context/location-provider/use-handle-redirect.hook.ts ***!
  \******************************************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.useHandleRedirect = void 0;
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
const react_1 = __webpack_require__(/*! react */ "react");
const smarthub_common_1 = __webpack_require__(/*! smarthub-common */ "smarthub-common");
const rgx = /^(?:http|https):\/\/(?:[a-z0-9-_.\/]*)/;
const parseAction = (param) => {
    if (typeof param == 'string')
        return {
            $id: '',
            $schema: smarthub_common_1.RouteActionSchema,
            uri: param
        };
    let { $schema } = param, rest = tslib_1.__rest(param, ["$schema"]);
    if (!$schema)
        $schema = smarthub_common_1.RouteActionSchema;
    else if (!rgx.test($schema))
        $schema = `${smarthub_common_1.ActionSchema}/${$schema}`;
    return Object.assign(Object.assign({}, rest), { $schema });
};
const useHandleRedirect = () => {
    const handleCommand = smarthub_common_1.useHandleCommand();
    return react_1.useCallback((next) => tslib_1.__awaiter(void 0, void 0, void 0, function* () {
        const { page, $action } = (next === null || next === void 0 ? void 0 : next.params) || {};
        const action = $action
            ? parseAction($action)
            : page
                ? parseAction(page)
                : null;
        if (action) {
            yield handleCommand(action);
            return true;
        }
        return false;
    }), []);
};
exports.useHandleRedirect = useHandleRedirect;


/***/ }),

/***/ "./src/components/context/location-provider/use-location-item-params.hook.ts":
/*!***********************************************************************************!*\
  !*** ./src/components/context/location-provider/use-location-item-params.hook.ts ***!
  \***********************************************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.useLocationItemParams = void 0;
const react_1 = __webpack_require__(/*! react */ "react");
const recoil_1 = __webpack_require__(/*! recoil */ "recoil");
const smarthub_common_1 = __webpack_require__(/*! smarthub-common */ "smarthub-common");
const group = 'shared';
const channel = 'uri';
const useLocationItemParams = (source, level) => {
    var _a, _b, _c;
    const state = smarthub_common_1.useSharedStatePartition(group, channel, source, level);
    const params = react_1.useRef();
    params.current = (_c = (_b = (_a = state === null || state === void 0 ? void 0 : state.shared) === null || _a === void 0 ? void 0 : _a.uri) === null || _b === void 0 ? void 0 : _b[source]) === null || _c === void 0 ? void 0 : _c[level];
    const settter = recoil_1.useRecoilCallback(({ set }) => (nextParams) => {
        const currentRefs = Object.keys(params.current || {})
            .map(name => ({
            name,
            channel,
            group,
            level,
            source
        }));
        const nextRefs = Object.keys(nextParams || {})
            .map(name => ({
            name,
            channel,
            group,
            level,
            source,
            value: nextParams[name]
        }));
        const refs = [
            ...currentRefs,
            ...nextRefs
        ];
        refs.forEach(ref => set(smarthub_common_1.sharedStateSelector(smarthub_common_1.sharedStateId(ref)), ref.value));
    }, []);
    return [params.current, settter];
};
exports.useLocationItemParams = useLocationItemParams;


/***/ }),

/***/ "./src/components/context/location-provider/use-location-items.hook.ts":
/*!*****************************************************************************!*\
  !*** ./src/components/context/location-provider/use-location-items.hook.ts ***!
  \*****************************************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.useLocationItems = void 0;
const react_1 = __webpack_require__(/*! react */ "react");
const use_panel_item_hook_1 = __webpack_require__(/*! ./use-panel-item.hook */ "./src/components/context/location-provider/use-panel-item.hook.ts");
const use_tab_item_hook_1 = __webpack_require__(/*! ./use-tab-item.hook */ "./src/components/context/location-provider/use-tab-item.hook.ts");
const useLocationItems = (type) => {
    const [panel, setPanel] = use_panel_item_hook_1.usePanelItem(type);
    const [tab, setTab] = use_tab_item_hook_1.useTabItem(type);
    const value = react_1.useMemo(() => ({ panel, tab }), [panel, tab]);
    const setter = react_1.useCallback((items) => {
        setPanel(items === null || items === void 0 ? void 0 : items.panel);
        setTab(items === null || items === void 0 ? void 0 : items.tab);
    }, []);
    return [value, setter];
};
exports.useLocationItems = useLocationItems;


/***/ }),

/***/ "./src/components/context/location-provider/use-panel-item.hook.ts":
/*!*************************************************************************!*\
  !*** ./src/components/context/location-provider/use-panel-item.hook.ts ***!
  \*************************************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.usePanelItem = void 0;
const react_1 = __webpack_require__(/*! react */ "react");
const smarthub_common_1 = __webpack_require__(/*! smarthub-common */ "smarthub-common");
const use_location_item_params_hook_1 = __webpack_require__(/*! ./use-location-item-params.hook */ "./src/components/context/location-provider/use-location-item-params.hook.ts");
const level = 'panel';
const usePanelItem = (type) => {
    const [params, setParams] = use_location_item_params_hook_1.useLocationItemParams(type, level);
    const id = smarthub_common_1.usePanelId(type);
    const setId = smarthub_common_1.useSetPanelId(type);
    const entity = smarthub_common_1.usePanelEntityId(type);
    const value = react_1.useMemo(() => ({ id, entity, params }), [id, entity, params]);
    const setter = react_1.useCallback((item) => {
        setId(item === null || item === void 0 ? void 0 : item.id, item === null || item === void 0 ? void 0 : item.entity);
        setParams(item === null || item === void 0 ? void 0 : item.params);
    }, []);
    return [value, setter];
};
exports.usePanelItem = usePanelItem;


/***/ }),

/***/ "./src/components/context/location-provider/use-tab-item.hook.ts":
/*!***********************************************************************!*\
  !*** ./src/components/context/location-provider/use-tab-item.hook.ts ***!
  \***********************************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.useTabItem = void 0;
const react_1 = __webpack_require__(/*! react */ "react");
const smarthub_common_1 = __webpack_require__(/*! smarthub-common */ "smarthub-common");
const use_location_item_params_hook_1 = __webpack_require__(/*! ./use-location-item-params.hook */ "./src/components/context/location-provider/use-location-item-params.hook.ts");
const level = 'tab';
const useTabItem = (type) => {
    const [params, setParams] = use_location_item_params_hook_1.useLocationItemParams(type, level);
    const id = smarthub_common_1.useTabId(type);
    const setId = smarthub_common_1.useSetTabId(type);
    const entity = smarthub_common_1.useTabEntityId(type);
    const value = react_1.useMemo(() => ({ id, entity, params }), [id, entity, params]);
    const setter = react_1.useCallback((item) => {
        setId(item === null || item === void 0 ? void 0 : item.id, item === null || item === void 0 ? void 0 : item.entity);
        setParams(item === null || item === void 0 ? void 0 : item.params);
    }, []);
    return [value, setter];
};
exports.useTabItem = useTabItem;


/***/ }),

/***/ "./src/components/context/middleware-provider/index.ts":
/*!*************************************************************!*\
  !*** ./src/components/context/middleware-provider/index.ts ***!
  \*************************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
tslib_1.__exportStar(__webpack_require__(/*! ./middleware-provider.component */ "./src/components/context/middleware-provider/middleware-provider.component.tsx"), exports);


/***/ }),

/***/ "./src/components/context/middleware-provider/middleware-provider.component.tsx":
/*!**************************************************************************************!*\
  !*** ./src/components/context/middleware-provider/middleware-provider.component.tsx ***!
  \**************************************************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.MiddlewareProvider = void 0;
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
const react_1 = tslib_1.__importStar(__webpack_require__(/*! react */ "react"));
const smarthub_common_1 = __webpack_require__(/*! smarthub-common */ "smarthub-common");
const MiddlewareProvider = ({ children, config }) => {
    var _a;
    const { transforms: transformProvider } = (_a = smarthub_common_1.useProviders()) !== null && _a !== void 0 ? _a : {};
    const authContext = smarthub_common_1.useAuth();
    const [context, setContext] = react_1.useState(null);
    const loadMiddleware = () => {
        const ctx = Object.keys(config).reduce((context, k) => {
            context[k] = k != 'transform' ? config[k].middleware : null;
            return context;
        }, {});
        setContext(ctx);
    };
    const loadTransforms = () => tslib_1.__awaiter(void 0, void 0, void 0, function* () {
        try {
            const templates = yield (transformProvider === null || transformProvider === void 0 ? void 0 : transformProvider.process(authContext));
            config.transform.collection.upsertTemplate(templates !== null && templates !== void 0 ? templates : []);
            setContext(Object.assign(Object.assign({}, context), { transform: config.transform.middleware }));
        }
        catch (ex) {
            smarthub_common_1.Logger.error(ex.message, false, { ex });
        }
    });
    react_1.useEffect(() => {
        if (!context)
            loadMiddleware();
        if (authContext && context && !(context === null || context === void 0 ? void 0 : context.transform) && transformProvider)
            loadTransforms();
    }, [authContext, context]);
    return react_1.default.createElement(smarthub_common_1.MiddlewareContext.Provider, { value: context }, context && children);
};
exports.MiddlewareProvider = MiddlewareProvider;


/***/ }),

/***/ "./src/components/context/notification-provider/index.ts":
/*!***************************************************************!*\
  !*** ./src/components/context/notification-provider/index.ts ***!
  \***************************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
tslib_1.__exportStar(__webpack_require__(/*! ./notification-provider.component */ "./src/components/context/notification-provider/notification-provider.component.tsx"), exports);


/***/ }),

/***/ "./src/components/context/notification-provider/notification-provider.component.tsx":
/*!******************************************************************************************!*\
  !*** ./src/components/context/notification-provider/notification-provider.component.tsx ***!
  \******************************************************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.NotificationProvider = void 0;
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
const react_1 = tslib_1.__importStar(__webpack_require__(/*! react */ "react"));
const react_2 = __webpack_require__(/*! react */ "react");
const smarthub_common_1 = __webpack_require__(/*! smarthub-common */ "smarthub-common");
const dayjs_1 = tslib_1.__importDefault(__webpack_require__(/*! dayjs */ "dayjs"));
const isSameOrBefore_1 = tslib_1.__importDefault(__webpack_require__(/*! dayjs/plugin/isSameOrBefore */ "dayjs/plugin/isSameOrBefore"));
dayjs_1.default.extend(isSameOrBefore_1.default);
const key = 'dismissed-notifications';
const NotificationProvider = ({ children }) => {
    const { notifications: notificationProviders } = smarthub_common_1.useProviders();
    const fetch = smarthub_common_1.useFetch();
    const auth = smarthub_common_1.useAuth();
    const transform = smarthub_common_1.useTransform();
    const [context, setContext] = react_1.useState(null);
    const dismissedPrefRef = smarthub_common_1.useHookRef(smarthub_common_1.usePreference, key, true, []);
    const notificationsRef = react_2.useRef([]);
    const dismiss = react_1.useCallback(({ $id, source, expires }) => tslib_1.__awaiter(void 0, void 0, void 0, function* () {
        const now = new Date();
        const [dismissedItems, setDismissedItems] = dismissedPrefRef.current;
        const items = dismissedItems.filter(d => dayjs_1.default(d.expires).isSameOrBefore(now)
            || (d.$id != $id && d.source != source));
        setDismissedItems([
            ...items,
            {
                $id,
                source,
                expires
            }
        ]);
        setNotifications(notificationsRef.current.filter(n => n.$id != $id && n.source != source));
    }), []);
    const dismissAll = react_1.useCallback(() => tslib_1.__awaiter(void 0, void 0, void 0, function* () {
        const now = new Date();
        const notifications = notificationsRef.current;
        const [dismissedItems, setDismissedItems] = dismissedPrefRef.current;
        const items = [
            ...dismissedItems.current.filter(d => dayjs_1.default(d.expires).isSameOrBefore(now)
                || !notifications.some(({ $id, source }) => d.$id != $id && d.source != source)),
            ...notifications.map(({ $id, source, expires }) => ({
                $id,
                source,
                expires
            }))
        ];
        setDismissedItems.current(items);
        setNotifications([]);
    }), []);
    const setNotifications = react_1.useCallback((notifications) => {
        notificationsRef.current = notifications;
        setContext({
            notifications,
            dismissAll,
            dismiss
        });
    }, []);
    react_1.useEffect(() => {
        let stop = false;
        setNotifications([]);
        const loadNotifications = () => tslib_1.__awaiter(void 0, void 0, void 0, function* () {
            try {
                notificationProviders === null || notificationProviders === void 0 ? void 0 : notificationProviders.forEach((provider) => tslib_1.__awaiter(void 0, void 0, void 0, function* () {
                    var e_1, _a;
                    try {
                        for (var _b = tslib_1.__asyncValues(provider.listen(fetch, transform, auth)), _c; _c = yield _b.next(), !_c.done;) {
                            const list = _c.value;
                            if (stop)
                                return;
                            const notifications = notificationsRef.current;
                            const [dismissedItems] = dismissedPrefRef.current;
                            const items = list.filter(n => !dismissedItems.some(({ $id, source }) => n.$id == $id && n.source == source)
                                && !notifications.some(({ $id, source }) => n.$id == $id && n.source == source));
                            if (items.length > 0)
                                setNotifications([
                                    ...notifications,
                                    ...items
                                ]);
                        }
                    }
                    catch (e_1_1) { e_1 = { error: e_1_1 }; }
                    finally {
                        try {
                            if (_c && !_c.done && (_a = _b.return)) yield _a.call(_b);
                        }
                        finally { if (e_1) throw e_1.error; }
                    }
                }));
            }
            catch (ex) {
                smarthub_common_1.Logger.error(ex.message, false, { ex });
            }
        });
        if (auth && fetch && transform)
            loadNotifications();
        return () => {
            stop = true;
        };
    }, [auth, fetch, transform]);
    return react_1.default.createElement(smarthub_common_1.NotificationContext.Provider, { value: context }, children);
};
exports.NotificationProvider = NotificationProvider;


/***/ }),

/***/ "./src/components/context/page-provider/index.ts":
/*!*******************************************************!*\
  !*** ./src/components/context/page-provider/index.ts ***!
  \*******************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
tslib_1.__exportStar(__webpack_require__(/*! ./page-provider.component */ "./src/components/context/page-provider/page-provider.component.tsx"), exports);


/***/ }),

/***/ "./src/components/context/page-provider/page-provider.component.tsx":
/*!**************************************************************************!*\
  !*** ./src/components/context/page-provider/page-provider.component.tsx ***!
  \**************************************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.PageProvider = void 0;
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
const react_1 = tslib_1.__importStar(__webpack_require__(/*! react */ "react"));
const smarthub_common_1 = __webpack_require__(/*! smarthub-common */ "smarthub-common");
const PageProvider = ({ children }) => {
    const [pageState, setPageState] = react_1.useState("closed");
    const [selectedPage, setSelectedPage] = react_1.useState(null);
    const [context, setContext] = react_1.useState({
        pageState,
        selectedPage,
        setPageState,
        setSelectedPage,
    });
    react_1.useEffect(() => {
        setContext({
            pageState,
            selectedPage,
            setPageState,
            setSelectedPage,
        });
    }, [pageState, selectedPage, setPageState, setSelectedPage]);
    return (react_1.default.createElement(smarthub_common_1.PageContext.Provider, { value: context }, children));
};
exports.PageProvider = PageProvider;


/***/ }),

/***/ "./src/components/context/panel-view-provider/entity-context.component.tsx":
/*!*********************************************************************************!*\
  !*** ./src/components/context/panel-view-provider/entity-context.component.tsx ***!
  \*********************************************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.EntityContext = void 0;
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
const react_1 = tslib_1.__importStar(__webpack_require__(/*! react */ "react"));
const smarthub_common_1 = __webpack_require__(/*! smarthub-common */ "smarthub-common");
const template_context_component_1 = __webpack_require__(/*! ./template-context.component */ "./src/components/context/panel-view-provider/template-context.component.tsx");
const EntityContext = ({ panel, children }) => {
    const config = (panel === null || panel === void 0 ? void 0 : panel.entity) || {};
    const { query, title, description, props: { entitySchema = smarthub_common_1.IPanelEntitySchema, defaultEntity } = {} } = config;
    const entityId = smarthub_common_1.usePanelEntityId();
    const setEntityId = smarthub_common_1.useSetPanelEntityId();
    const entity = smarthub_common_1.usePanelEntity();
    const setEntity = smarthub_common_1.useSetPanelEntity();
    const fetch = smarthub_common_1.useFetch();
    const profile = smarthub_common_1.useProfile();
    const transform = smarthub_common_1.useTransform();
    react_1.useEffect(() => {
        var _a;
        const fetchEntity = () => tslib_1.__awaiter(void 0, void 0, void 0, function* () {
            const { data } = yield fetch(query, { entityId });
            const entity = transform(entitySchema, data);
            setEntity(Object.assign(Object.assign({}, entity), { $entityId: entityId }));
        });
        if (!(panel === null || panel === void 0 ? void 0 : panel.entity)) {
            setEntity();
            return;
        }
        if (!(entityId === null || entityId === void 0 ? void 0 : entityId.length)) {
            if (defaultEntity && defaultEntity.source == 'profile' && ((_a = defaultEntity.property) === null || _a === void 0 ? void 0 : _a.length))
                setEntityId(profile[defaultEntity.property]);
            else if (entity)
                setEntityId(entity.$entityId);
            return;
        }
        if ((entity === null || entity === void 0 ? void 0 : entity.$entityId) == entityId)
            return;
        if (query)
            fetchEntity();
        else
            setEntity({
                $schema: smarthub_common_1.IPanelEntitySchema,
                $entityId: entityId,
                $id: entityId,
                uri: entityId.indexOf('http') == 0 ? entityId : null,
                type: null,
                title,
                description
            });
    }, [panel, entityId, entity, setEntity, setEntityId, config]);
    return react_1.default.createElement(template_context_component_1.TemplateContext, { panel: panel }, children);
};
exports.EntityContext = EntityContext;


/***/ }),

/***/ "./src/components/context/panel-view-provider/index.ts":
/*!*************************************************************!*\
  !*** ./src/components/context/panel-view-provider/index.ts ***!
  \*************************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
tslib_1.__exportStar(__webpack_require__(/*! ./panel-view-provider.component */ "./src/components/context/panel-view-provider/panel-view-provider.component.tsx"), exports);


/***/ }),

/***/ "./src/components/context/panel-view-provider/panel-context.component.tsx":
/*!********************************************************************************!*\
  !*** ./src/components/context/panel-view-provider/panel-context.component.tsx ***!
  \********************************************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.PanelContext = void 0;
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
const react_1 = tslib_1.__importStar(__webpack_require__(/*! react */ "react"));
const smarthub_common_1 = __webpack_require__(/*! smarthub-common */ "smarthub-common");
const entity_context_component_1 = __webpack_require__(/*! ./entity-context.component */ "./src/components/context/panel-view-provider/entity-context.component.tsx");
const template_context_component_1 = __webpack_require__(/*! ./template-context.component */ "./src/components/context/panel-view-provider/template-context.component.tsx");
const use_set_panel_data_hook_1 = __webpack_require__(/*! ./use-set-panel-data.hook */ "./src/components/context/panel-view-provider/use-set-panel-data.hook.ts");
const PanelContext = ({ children }) => {
    const panels = smarthub_common_1.usePanels();
    const panelId = smarthub_common_1.usePanelId();
    const panel = (panelId === null || panelId === void 0 ? void 0 : panelId.length) ? panels === null || panels === void 0 ? void 0 : panels.find(({ $id }) => $id == panelId) : null;
    const setData = use_set_panel_data_hook_1.useSetPanelData(panel, 'panel');
    const setInitialPanelId = smarthub_common_1.useSetInitialPanelId();
    react_1.useEffect(() => {
        setData();
    }, [setData]);
    react_1.useEffect(() => {
        if (!(panelId === null || panelId === void 0 ? void 0 : panelId.length))
            setInitialPanelId();
    }, [panels, panelId]);
    return (panel === null || panel === void 0 ? void 0 : panel.entity) ? react_1.default.createElement(entity_context_component_1.EntityContext, { panel: panel }, children)
        : react_1.default.createElement(template_context_component_1.TemplateContext, { panel: panel }, children);
};
exports.PanelContext = PanelContext;


/***/ }),

/***/ "./src/components/context/panel-view-provider/panel-view-provider.component.tsx":
/*!**************************************************************************************!*\
  !*** ./src/components/context/panel-view-provider/panel-view-provider.component.tsx ***!
  \**************************************************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.PanelViewProvider = void 0;
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
const react_1 = tslib_1.__importStar(__webpack_require__(/*! react */ "react"));
const smarthub_common_1 = __webpack_require__(/*! smarthub-common */ "smarthub-common");
const panel_context_component_1 = __webpack_require__(/*! ./panel-context.component */ "./src/components/context/panel-view-provider/panel-context.component.tsx");
const PanelViewProvider = ({ type, children }) => {
    const config = smarthub_common_1.useViewConfig();
    const { visibility } = config[type];
    const { visible } = smarthub_common_1.usePanelView(type);
    const context = react_1.useMemo(() => ({
        type
    }), [type]);
    return react_1.useMemo(() => visible || visibility == 'auto'
        ? react_1.default.createElement(smarthub_common_1.CurrentPanelContext.Provider, { value: context },
            react_1.default.createElement(panel_context_component_1.PanelContext, null, children))
        : react_1.default.createElement(react_1.default.Fragment, null), [context, visible, visibility]);
};
exports.PanelViewProvider = PanelViewProvider;


/***/ }),

/***/ "./src/components/context/panel-view-provider/tab-context.component.tsx":
/*!******************************************************************************!*\
  !*** ./src/components/context/panel-view-provider/tab-context.component.tsx ***!
  \******************************************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.TabContext = void 0;
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
const react_1 = tslib_1.__importStar(__webpack_require__(/*! react */ "react"));
const smarthub_common_1 = __webpack_require__(/*! smarthub-common */ "smarthub-common");
const use_set_panel_data_hook_1 = __webpack_require__(/*! ./use-set-panel-data.hook */ "./src/components/context/panel-view-provider/use-set-panel-data.hook.ts");
const view_context_component_1 = __webpack_require__(/*! ./view-context.component */ "./src/components/context/panel-view-provider/view-context.component.tsx");
const TabContext = ({ panel, template, tabs, children }) => {
    const [tab, setTab] = react_1.useState();
    const setTabId = smarthub_common_1.useSetTabId();
    const tabId = smarthub_common_1.useTabId();
    const setData = use_set_panel_data_hook_1.useSetPanelData(tab, 'tab');
    smarthub_common_1.useAsyncEffect(() => tslib_1.__awaiter(void 0, void 0, void 0, function* () {
        setData();
    }), [setData]);
    smarthub_common_1.useAsyncEffect(() => tslib_1.__awaiter(void 0, void 0, void 0, function* () {
        const { items, preferred: { $id: preferredId } = {} } = tabs;
        const tab = (tabId === null || tabId === void 0 ? void 0 : tabId.length) ? items.find(({ $id }) => $id == tabId)
            : null;
        if (!tab)
            setTabId(preferredId);
        else
            setTab(tab);
    }), [tabId, tabs]);
    return tab
        ? react_1.default.createElement(view_context_component_1.ViewContext, { panel: panel, template: template, tabs: tabs.items, tab: tab }, children)
        : react_1.default.createElement(react_1.default.Fragment, null);
};
exports.TabContext = TabContext;


/***/ }),

/***/ "./src/components/context/panel-view-provider/tabs-context.component.tsx":
/*!*******************************************************************************!*\
  !*** ./src/components/context/panel-view-provider/tabs-context.component.tsx ***!
  \*******************************************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.TabsContext = void 0;
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
const react_1 = tslib_1.__importDefault(__webpack_require__(/*! react */ "react"));
const smarthub_common_1 = __webpack_require__(/*! smarthub-common */ "smarthub-common");
const tab_context_component_1 = __webpack_require__(/*! ./tab-context.component */ "./src/components/context/panel-view-provider/tab-context.component.tsx");
const TabsContext = ({ panel, template, children }) => {
    const allowed = smarthub_common_1.useConditions(`${template === null || template === void 0 ? void 0 : template.$id}-tabs`, template === null || template === void 0 ? void 0 : template.tabs, undefined, 'panel');
    const tabs = smarthub_common_1.useOrdered(allowed);
    return template && tabs.preferred
        ? react_1.default.createElement(tab_context_component_1.TabContext, { panel: panel, template: template, tabs: tabs }, children)
        : react_1.default.createElement(react_1.default.Fragment, null);
};
exports.TabsContext = TabsContext;


/***/ }),

/***/ "./src/components/context/panel-view-provider/template-context.component.tsx":
/*!***********************************************************************************!*\
  !*** ./src/components/context/panel-view-provider/template-context.component.tsx ***!
  \***********************************************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.TemplateContext = void 0;
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
const react_1 = tslib_1.__importStar(__webpack_require__(/*! react */ "react"));
const smarthub_common_1 = __webpack_require__(/*! smarthub-common */ "smarthub-common");
const tabs_context_component_1 = __webpack_require__(/*! ./tabs-context.component */ "./src/components/context/panel-view-provider/tabs-context.component.tsx");
const use_set_panel_data_hook_1 = __webpack_require__(/*! ./use-set-panel-data.hook */ "./src/components/context/panel-view-provider/use-set-panel-data.hook.ts");
const TemplateContext = ({ panel, children }) => {
    const allowed = smarthub_common_1.useConditions(`${panel === null || panel === void 0 ? void 0 : panel.$id}-templates`, panel === null || panel === void 0 ? void 0 : panel.templates, undefined, 'panel');
    const ordered = smarthub_common_1.useOrdered(allowed);
    const template = panel && (allowed === null || allowed === void 0 ? void 0 : allowed.length)
        ? ordered.preferred
        : null;
    const setData = use_set_panel_data_hook_1.useSetPanelData(template, 'panel');
    react_1.useEffect(() => {
        setData();
    }, [setData]);
    return template
        ? react_1.default.createElement(tabs_context_component_1.TabsContext, { panel: panel, template: template }, children)
        : react_1.default.createElement(react_1.default.Fragment, null);
};
exports.TemplateContext = TemplateContext;


/***/ }),

/***/ "./src/components/context/panel-view-provider/use-set-panel-data.hook.ts":
/*!*******************************************************************************!*\
  !*** ./src/components/context/panel-view-provider/use-set-panel-data.hook.ts ***!
  \*******************************************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.useSetPanelData = void 0;
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
const react_1 = __webpack_require__(/*! react */ "react");
const smarthub_common_1 = __webpack_require__(/*! smarthub-common */ "smarthub-common");
const channel = 'state';
const group = 'shared';
const useSetPanelData = (component, level) => {
    const { $id, dataSets } = component || {};
    const fetch = smarthub_common_1.useFetch();
    const transform = smarthub_common_1.useTransform();
    const source = smarthub_common_1.usePanelType();
    const consumes = react_1.useMemo(() => dataSets === null || dataSets === void 0 ? void 0 : dataSets.reduce((all, { consumes }) => {
        return [
            ...all,
            ...(consumes || [])
        ];
    }, []), [dataSets]);
    const [sharedState, setSharedState] = smarthub_common_1.useSharedStates($id, undefined, level);
    const setSharedStates = smarthub_common_1.useSetSharedStates();
    react_1.useEffect(() => setSharedState(consumes), [consumes]);
    return react_1.useCallback(() => tslib_1.__awaiter(void 0, void 0, void 0, function* () {
        if (!(dataSets === null || dataSets === void 0 ? void 0 : dataSets.length))
            return Promise.resolve();
        const results = yield Promise.all(dataSets.map(({ name, query, schema }) => tslib_1.__awaiter(void 0, void 0, void 0, function* () {
            const { data } = yield fetch(query, sharedState);
            const value = transform(schema, data);
            return { name, value };
        })));
        const dataItems = results.map(({ name, value }) => ({
            group,
            source,
            name,
            channel,
            level,
            value
        }));
        setSharedStates(dataItems);
    }), [sharedState, component]);
};
exports.useSetPanelData = useSetPanelData;


/***/ }),

/***/ "./src/components/context/panel-view-provider/view-context.component.tsx":
/*!*******************************************************************************!*\
  !*** ./src/components/context/panel-view-provider/view-context.component.tsx ***!
  \*******************************************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.ViewContext = void 0;
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
const react_1 = tslib_1.__importStar(__webpack_require__(/*! react */ "react"));
const smarthub_common_1 = __webpack_require__(/*! smarthub-common */ "smarthub-common");
const ViewContext = ({ panel, template, tab, tabs, children }) => {
    const globalScopes = smarthub_common_1.useGlobalChatScopes();
    const [context, setContext] = react_1.useState(null);
    const type = smarthub_common_1.usePanelType();
    const setScopes = smarthub_common_1.useSetChatScopes();
    const contextRef = react_1.useRef({
        type,
        panel,
        initialFocus: null,
        actions: null,
        regions: null,
        scopes: null,
        tab,
        tabs: tabs,
        template,
    });
    react_1.useEffect(() => {
        var _a;
        if (type == 'main' && ((_a = context === null || context === void 0 ? void 0 : context.scopes) === null || _a === void 0 ? void 0 : _a.length))
            setScopes(context.scopes);
    }, [context === null || context === void 0 ? void 0 : context.scopes]);
    react_1.useEffect(() => {
        if (!tab)
            return;
        const actions = [
            ...(panel.actions || []),
            ...(template.actions || []),
            ...(tab.actions || [])
        ];
        const scopes = [
            ...(tab.chatScopes || []),
            ...(template.chatScopes || []),
            ...(panel.chatScopes || []),
            ...(globalScopes || [])
        ];
        const regions = Object.assign(Object.assign(Object.assign({}, panel), template), tab);
        const { initialFocus } = regions;
        contextRef.current = Object.assign(Object.assign({}, contextRef.current), { type,
            panel,
            initialFocus,
            template,
            tabs,
            tab,
            regions,
            actions,
            scopes });
        setContext(contextRef.current);
    }, [tab]);
    react_1.useEffect(() => {
        const { current, current: { tabs: currentTabs } = {} } = contextRef;
        if (tabs == currentTabs)
            return;
        contextRef.current = Object.assign(Object.assign({}, current), { tabs });
        setContext(contextRef.current);
    }, [tabs]);
    react_1.useEffect(() => {
        const { current } = contextRef;
        contextRef.current = Object.assign(Object.assign({}, current), { panel });
        setContext(contextRef.current);
    }, [tabs]);
    return react_1.default.createElement(smarthub_common_1.PanelViewContext.Provider, { value: context }, context != null && children);
};
exports.ViewContext = ViewContext;


/***/ }),

/***/ "./src/components/context/panel-view-state-provider/index.ts":
/*!*******************************************************************!*\
  !*** ./src/components/context/panel-view-state-provider/index.ts ***!
  \*******************************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
tslib_1.__exportStar(__webpack_require__(/*! ./panel-view-state-provider.component */ "./src/components/context/panel-view-state-provider/panel-view-state-provider.component.tsx"), exports);


/***/ }),

/***/ "./src/components/context/panel-view-state-provider/panel-view-state-provider.component.tsx":
/*!**************************************************************************************************!*\
  !*** ./src/components/context/panel-view-state-provider/panel-view-state-provider.component.tsx ***!
  \**************************************************************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.PanelViewStateProvider = void 0;
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
const react_1 = tslib_1.__importStar(__webpack_require__(/*! react */ "react"));
const smarthub_common_1 = __webpack_require__(/*! smarthub-common */ "smarthub-common");
//TODO refactor
const PanelViewStateProvider = ({ children, type, }) => {
    var _a;
    const viewConfig = smarthub_common_1.useViewConfig();
    const view = viewConfig[type];
    const dockConfig = smarthub_common_1.useResponsiveProps(view === null || view === void 0 ? void 0 : view.dockSizes);
    const [size] = smarthub_common_1.usePreference(smarthub_common_1.preferenceKeys[`${type}DockSize`], false, dockConfig.preferred);
    const [position] = smarthub_common_1.usePreference(smarthub_common_1.preferenceKeys[`${type}DockPosition`], false, (_a = view === null || view === void 0 ? void 0 : view.dockPositions) === null || _a === void 0 ? void 0 : _a.preferred);
    const [launcher] = smarthub_common_1.usePreference(smarthub_common_1.preferenceKeys[`${type}LauncherState`], false, "closed");
    const [pages] = smarthub_common_1.usePreference(smarthub_common_1.preferenceKeys[`${type}PagesState`], false, "closed");
    const [content] = smarthub_common_1.usePreference(smarthub_common_1.preferenceKeys[`${type}ContentView`], false, "normal");
    const setPanelView = smarthub_common_1.useSetPanelView(type);
    const panelViewRef = smarthub_common_1.useHookRef(smarthub_common_1.usePanelView, type);
    react_1.useEffect(() => {
        const { initialPanel: { visible } = {} } = view;
        if (!panelViewRef.current)
            setPanelView({
                size,
                position,
                visible,
                launcher,
                pages,
                content,
            });
    }, []);
    react_1.useEffect(() => {
        let { current: state } = panelViewRef;
        if (!state)
            return;
        if (size != state.size && (size != "full" || state.size != "asside"))
            state = Object.assign(Object.assign({}, state), { size });
        if (position != state.position)
            state = Object.assign(Object.assign({}, state), { position });
        if (content != state.content)
            state = Object.assign(Object.assign({}, state), { content });
        if (state != panelViewRef.current) {
            panelViewRef.current = state;
            setPanelView(state);
        }
    }, [size, position, content]);
    return react_1.default.createElement(react_1.default.Fragment, null, children);
};
exports.PanelViewStateProvider = PanelViewStateProvider;


/***/ }),

/***/ "./src/components/context/panels-provider/index.ts":
/*!*********************************************************!*\
  !*** ./src/components/context/panels-provider/index.ts ***!
  \*********************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
tslib_1.__exportStar(__webpack_require__(/*! ./panels-provider.component */ "./src/components/context/panels-provider/panels-provider.component.tsx"), exports);


/***/ }),

/***/ "./src/components/context/panels-provider/panels-provider.component.tsx":
/*!******************************************************************************!*\
  !*** ./src/components/context/panels-provider/panels-provider.component.tsx ***!
  \******************************************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.PanelsProvider = void 0;
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
const react_1 = tslib_1.__importStar(__webpack_require__(/*! react */ "react"));
const smarthub_common_1 = __webpack_require__(/*! smarthub-common */ "smarthub-common");
const panel_view_state_provider_1 = __webpack_require__(/*! ../panel-view-state-provider */ "./src/components/context/panel-view-state-provider/index.ts");
const PanelsProvider = ({ children }) => {
    const { panels: panelsProvider } = smarthub_common_1.useProviders();
    const authContext = smarthub_common_1.useAuth();
    const profile = smarthub_common_1.useProfile();
    const [context, setContext] = react_1.useState(null);
    const loadPanels = () => tslib_1.__awaiter(void 0, void 0, void 0, function* () {
        try {
            const panels = yield panelsProvider.process(authContext, profile);
            setContext(panels);
        }
        catch (ex) {
            smarthub_common_1.Logger.error(ex.message, false, { ex });
        }
    });
    react_1.useEffect(() => {
        if (authContext && profile && !context)
            loadPanels();
    }, [authContext, profile]);
    return react_1.default.createElement(smarthub_common_1.PanelsContext.Provider, { value: context },
        react_1.default.createElement(panel_view_state_provider_1.PanelViewStateProvider, { type: "main" }),
        react_1.default.createElement(panel_view_state_provider_1.PanelViewStateProvider, { type: "page" }),
        react_1.default.createElement(panel_view_state_provider_1.PanelViewStateProvider, { type: "chat" }),
        children);
};
exports.PanelsProvider = PanelsProvider;


/***/ }),

/***/ "./src/components/context/personality-provider/index.ts":
/*!**************************************************************!*\
  !*** ./src/components/context/personality-provider/index.ts ***!
  \**************************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
tslib_1.__exportStar(__webpack_require__(/*! ./personality-provider.component */ "./src/components/context/personality-provider/personality-provider.component.tsx"), exports);


/***/ }),

/***/ "./src/components/context/personality-provider/personality-provider.component.tsx":
/*!****************************************************************************************!*\
  !*** ./src/components/context/personality-provider/personality-provider.component.tsx ***!
  \****************************************************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.PersonalityProvider = void 0;
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
const react_1 = tslib_1.__importStar(__webpack_require__(/*! react */ "react"));
const smarthub_common_1 = __webpack_require__(/*! smarthub-common */ "smarthub-common");
const PersonalityProvider = ({ children, }) => {
    const [personality, setPersonality] = react_1.useState("");
    const [context, setContext] = react_1.useState({
        personality,
        setPersonality,
    });
    react_1.useEffect(() => {
        setContext({
            personality,
            setPersonality,
        });
    }, [personality, setPersonality]);
    return (react_1.default.createElement(smarthub_common_1.PersonalityContext.Provider, { value: context }, children));
};
exports.PersonalityProvider = PersonalityProvider;


/***/ }),

/***/ "./src/components/context/preference-provider/index.ts":
/*!*************************************************************!*\
  !*** ./src/components/context/preference-provider/index.ts ***!
  \*************************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
tslib_1.__exportStar(__webpack_require__(/*! ./preference-provider.component */ "./src/components/context/preference-provider/preference-provider.component.tsx"), exports);


/***/ }),

/***/ "./src/components/context/preference-provider/preference-provider.component.tsx":
/*!**************************************************************************************!*\
  !*** ./src/components/context/preference-provider/preference-provider.component.tsx ***!
  \**************************************************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.PreferenceProvider = void 0;
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
const react_1 = tslib_1.__importStar(__webpack_require__(/*! react */ "react"));
const smarthub_common_1 = __webpack_require__(/*! smarthub-common */ "smarthub-common");
const PreferenceProvider = ({ children }) => {
    const { preferences: providers } = smarthub_common_1.useProviders();
    const authContext = smarthub_common_1.useAuth();
    const authContextRef = react_1.useRef();
    authContextRef.current = authContext;
    const [preferences, setPreferences] = react_1.useState([]);
    const [context, setContext] = react_1.useState(null);
    const set = react_1.useCallback((key, value, cacheLevel = 'permanent') => tslib_1.__awaiter(void 0, void 0, void 0, function* () {
        try {
            const { current: auth } = authContextRef;
            const provider = providers === null || providers === void 0 ? void 0 : providers[cacheLevel];
            if (value == null) {
                if (provider)
                    yield provider.remove(key, auth);
                setPreferences([
                    ...preferences.filter(p => p.key !== key)
                ]);
            }
            else {
                const preference = {
                    key,
                    value: typeof value == 'string'
                        ? value
                        : JSON.stringify(value)
                };
                if (provider)
                    yield provider.add(preference, auth);
                setPreferences([
                    ...preferences.filter(p => p.key !== key),
                    preference
                ]);
            }
        }
        catch (ex) {
            smarthub_common_1.Logger.error("Could not set preference", true, ex);
        }
    }), [preferences]);
    const remove = react_1.useCallback((key, cacheLevel = 'permanent') => tslib_1.__awaiter(void 0, void 0, void 0, function* () {
        try {
            const provider = providers === null || providers === void 0 ? void 0 : providers[cacheLevel];
            if (provider)
                yield provider.remove(key, authContextRef.current);
            setPreferences([
                ...preferences.filter(p => p.key !== key)
            ]);
        }
        catch (ex) {
            smarthub_common_1.Logger.error("Could not remove preference", true, ex);
        }
    }), [preferences]);
    const get = react_1.useCallback((key, parse, defaultValue) => {
        var _a;
        try {
            const { value } = (_a = preferences.find(p => p.key == key)) !== null && _a !== void 0 ? _a : {};
            return (value === null || value === void 0 ? void 0 : value.length) ? parse
                ? JSON.parse(value)
                : value
                : defaultValue;
        }
        catch (ex) {
            smarthub_common_1.Logger.error("Could not get preference", true, ex);
        }
    }, [preferences]);
    const loadPreferences = () => tslib_1.__awaiter(void 0, void 0, void 0, function* () {
        try {
            const { current: auth } = authContextRef;
            const permanent = (providers === null || providers === void 0 ? void 0 : providers.permanent) && ((providers === null || providers === void 0 ? void 0 : providers.permanent.localStorage) || auth)
                ? yield providers.permanent.getAll(auth)
                : [];
            const temporary = (providers === null || providers === void 0 ? void 0 : providers.temporary) && (providers.temporary.localStorage
                || auth)
                ? yield providers.temporary.getAll(auth)
                : [];
            setPreferences([
                ...permanent,
                ...temporary
            ]);
        }
        catch (ex) {
            smarthub_common_1.Logger.error(ex.message, false, { ex });
        }
    });
    react_1.useEffect(() => {
        setContext({
            set,
            remove,
            get
        });
    }, [preferences]);
    react_1.useEffect(() => {
        loadPreferences();
    }, [authContext]);
    return react_1.default.createElement(smarthub_common_1.PreferenceContext.Provider, { value: context }, children);
};
exports.PreferenceProvider = PreferenceProvider;


/***/ }),

/***/ "./src/components/context/profile-provider/index.ts":
/*!**********************************************************!*\
  !*** ./src/components/context/profile-provider/index.ts ***!
  \**********************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
tslib_1.__exportStar(__webpack_require__(/*! ./profile-provider.component */ "./src/components/context/profile-provider/profile-provider.component.tsx"), exports);


/***/ }),

/***/ "./src/components/context/profile-provider/profile-provider.component.tsx":
/*!********************************************************************************!*\
  !*** ./src/components/context/profile-provider/profile-provider.component.tsx ***!
  \********************************************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.ProfileProvider = void 0;
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
const react_1 = tslib_1.__importStar(__webpack_require__(/*! react */ "react"));
const smarthub_common_1 = __webpack_require__(/*! smarthub-common */ "smarthub-common");
const ProfileProvider = ({ children }) => {
    const { profile: profileProvider } = smarthub_common_1.useProviders();
    const profile = smarthub_common_1.useProfile();
    const setProfile = smarthub_common_1.useSetProfile();
    const fetch = smarthub_common_1.useFetch();
    const transform = smarthub_common_1.useTransform();
    const authContext = smarthub_common_1.useAuth();
    const loadProfile = () => tslib_1.__awaiter(void 0, void 0, void 0, function* () {
        const baseProfile = {
            $schema: smarthub_common_1.IPersonSchema,
            $id: null,
        };
        try {
            const profile = yield (profileProvider === null || profileProvider === void 0 ? void 0 : profileProvider.reduce((promise, provider) => tslib_1.__awaiter(void 0, void 0, void 0, function* () {
                return (promise.then(profile => provider.process(fetch, transform, profile)));
            }), Promise.resolve(baseProfile)));
            setProfile(profile !== null && profile !== void 0 ? profile : baseProfile);
        }
        catch (ex) {
            smarthub_common_1.Logger.error(ex.message, false, { ex });
        }
    });
    react_1.useEffect(() => {
        if (authContext && fetch && transform && !profile)
            loadProfile();
    }, [authContext, fetch, transform]);
    return react_1.default.createElement(react_1.default.Fragment, null, children);
};
exports.ProfileProvider = ProfileProvider;


/***/ }),

/***/ "./src/components/context/theme-provider/index.ts":
/*!********************************************************!*\
  !*** ./src/components/context/theme-provider/index.ts ***!
  \********************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
tslib_1.__exportStar(__webpack_require__(/*! ./theme-provider.component */ "./src/components/context/theme-provider/theme-provider.component.tsx"), exports);


/***/ }),

/***/ "./src/components/context/theme-provider/theme-provider.component.tsx":
/*!****************************************************************************!*\
  !*** ./src/components/context/theme-provider/theme-provider.component.tsx ***!
  \****************************************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.ThemeProvider = void 0;
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
const react_1 = tslib_1.__importStar(__webpack_require__(/*! react */ "react"));
const smarthub_common_1 = __webpack_require__(/*! smarthub-common */ "smarthub-common");
const react_jss_1 = __webpack_require__(/*! react-jss */ "react-jss");
const react_2 = __webpack_require__(/*! @fluentui/react */ "@fluentui/react");
const ThemeProviderWrapper = react_1.forwardRef(({ children }, ref) => react_1.default.createElement(react_1.default.Fragment, null, children));
const ThemeProvider = ({ children, themes }) => {
    const [preferredThemeId] = smarthub_common_1.usePreference(smarthub_common_1.preferenceKeys.userTheme);
    const [selectedTheme, setSelectedTheme] = react_1.useState(null);
    const [context, setContext] = react_1.useState(null);
    const setTheme = react_1.useCallback((id) => {
        var _a;
        setSelectedTheme((_a = themes.find(t => t.$id == id)) !== null && _a !== void 0 ? _a : themes[0]);
    }, [themes]);
    react_1.useEffect(() => {
        var _a;
        const theme = selectedTheme != null
            ? selectedTheme
            : (preferredThemeId === null || preferredThemeId === void 0 ? void 0 : preferredThemeId.length) ? (_a = themes.find(({ $id }) => $id == preferredThemeId)) !== null && _a !== void 0 ? _a : themes[0] : themes[0];
        const fluentTheme = smarthub_common_1.mergeFluentTheme(theme.definition);
        setContext({
            setTheme,
            themes,
            theme,
            fluentTheme
        });
    }, [themes, preferredThemeId, selectedTheme]);
    return react_1.default.createElement(smarthub_common_1.ThemeContext.Provider, { value: context }, context && react_1.default.createElement(react_jss_1.ThemeProvider, { theme: context.theme.definition },
        react_1.default.createElement(react_2.ThemeProvider, { theme: context === null || context === void 0 ? void 0 : context.fluentTheme, as: ThemeProviderWrapper, applyTo: "none" }, children)));
};
exports.ThemeProvider = ThemeProvider;


/***/ }),

/***/ "./src/components/context/tpc-check-provider/index.ts":
/*!************************************************************!*\
  !*** ./src/components/context/tpc-check-provider/index.ts ***!
  \************************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
tslib_1.__exportStar(__webpack_require__(/*! ./tpc-check-provider.component */ "./src/components/context/tpc-check-provider/tpc-check-provider.component.tsx"), exports);


/***/ }),

/***/ "./src/components/context/tpc-check-provider/tpc-check-provider.component.tsx":
/*!************************************************************************************!*\
  !*** ./src/components/context/tpc-check-provider/tpc-check-provider.component.tsx ***!
  \************************************************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.TPCCheckProvider = void 0;
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
const react_1 = tslib_1.__importStar(__webpack_require__(/*! react */ "react"));
const smarthub_common_1 = __webpack_require__(/*! smarthub-common */ "smarthub-common");
const TPCCheckProvider = ({ children, config }) => {
    const { level, checkUri, infoUri } = config || { level: 'none' };
    const checkDisabled = !(checkUri === null || checkUri === void 0 ? void 0 : checkUri.length);
    const contextRef = react_1.useRef({
        checked: checkDisabled,
        level,
        enabled: checkDisabled,
        infoUri
    });
    const [context, setContext] = react_1.useState(contextRef.current);
    const callback = react_1.useCallback((e) => {
        var _a, _b;
        const enabled = (_b = (_a = e.data) === null || _a === void 0 ? void 0 : _a.smarthub) === null || _b === void 0 ? void 0 : _b.tpcCheck;
        if (enabled == undefined)
            return;
        const { current } = contextRef;
        setContext(Object.assign(Object.assign({}, current), {
            checked: true,
            enabled
        }));
    }, []);
    react_1.useEffect(() => {
        window.addEventListener('message', callback);
        return () => window.removeEventListener('message', callback);
    }, []);
    const allowUI = level !== 'error' || context.enabled;
    return react_1.default.createElement(react_1.default.Fragment, null,
        !context.checked && react_1.default.createElement("iframe", { src: `${checkUri}`, style: {
                width: '0px',
                height: '0px',
                border: '0px'
            } }),
        allowUI && react_1.default.createElement(smarthub_common_1.TPCCheckContext.Provider, { value: context }, children));
};
exports.TPCCheckProvider = TPCCheckProvider;


/***/ }),

/***/ "./src/components/focus-trap/focus-trap.component.tsx":
/*!************************************************************!*\
  !*** ./src/components/focus-trap/focus-trap.component.tsx ***!
  \************************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.FocusTrap = void 0;
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
const react_1 = tslib_1.__importStar(__webpack_require__(/*! react */ "react"));
const smarthub_common_1 = __webpack_require__(/*! smarthub-common */ "smarthub-common");
const react_jss_1 = __webpack_require__(/*! react-jss */ "react-jss");
const candidateSelectors = [
    'input',
    'select',
    'textarea',
    'a[href]',
    'button',
    'not("[data-first]")',
    'not("[data-last]")',
    '[tabindex]:not([tabindex="-1"])',
    'audio[controls]',
    'video[controls]',
    '[contenteditable]:not([contenteditable="false"])',
    'details>summary:first-of-type',
    'details',
].join(',');
const useStyles = react_jss_1.createUseStyles((theme) => {
    var _a, _b;
    const { palette, spacing, fonts, sizes, styles } = theme;
    const panel = (_b = (_a = styles === null || styles === void 0 ? void 0 : styles.core) === null || _a === void 0 ? void 0 : _a.panel) !== null && _b !== void 0 ? _b : {};
    const props = { theme };
    const baseStyles = Object.assign(Object.assign({}, fonts.normal), { position: "absolute", height: `${sizes.normal}`, lineHeight: `${sizes.normal}`, padding: `0 ${spacing.smallPlus}`, textAlign: 'center', margin: 'auto', boxSizing: 'border-box', zIndex: 1, alignSelf: 'center', transition: "transform ease-out 300ms", backgroundColor: palette.primary, color: palette.primaryOn, transform: "scale(0)", "&:focus": {
            transform: "scale(1)"
        } });
    return {
        rootStyles: Object.assign({ position: 'relative' }, (smarthub_common_1.themeStyle(panel.root, props))),
        startStyles: Object.assign(Object.assign(Object.assign({}, baseStyles), { top: spacing.smallPlus }), (smarthub_common_1.themeStyle(panel.start, props))),
        endStyles: Object.assign(Object.assign(Object.assign({}, baseStyles), { bottom: spacing.smallPlus }), (smarthub_common_1.themeStyle(panel.start, props))),
    };
});
const FocusTrap = (_a) => {
    var { onClose, as, name, initialFocus, resetFocus, trapFocus, className, startLabel, endLabel, startText, endText, children } = _a, props = tslib_1.__rest(_a, ["onClose", "as", "name", "initialFocus", "resetFocus", "trapFocus", "className", "startLabel", "endLabel", "startText", "endText", "children"]);
    const { startStyles, endStyles, rootStyles } = useStyles();
    const register = smarthub_common_1.useRegisterFocus();
    const Tag = as || 'div';
    const start = react_1.useRef();
    const end = react_1.useRef();
    const ref = react_1.useRef(null);
    const focus = smarthub_common_1.useFocus();
    const onKeyDown = react_1.useCallback(({ key, target, shiftKey, stopPropagation, preventDefault }) => {
        if (key === "Escape") {
            onClose();
        }
        if (key !== 'Tab' || trapFocus === false)
            return;
        const { current: startEl } = start;
        const { current: endEl } = end;
        const nextEl = !shiftKey && target == endEl
            ? startEl
            : shiftKey && target == startEl
                ? endEl
                : null;
        if (nextEl) {
            nextEl.focus();
            stopPropagation();
            preventDefault();
        }
    }, []);
    react_1.useEffect(() => {
        var _a, _b, _c;
        if (initialFocus == 'first') {
            const el = (_a = ref.current) === null || _a === void 0 ? void 0 : _a.querySelector(candidateSelectors);
            if (el)
                el.focus();
        }
        else if (initialFocus == 'self')
            (_b = ref.current) === null || _b === void 0 ? void 0 : _b.focus();
        else if (initialFocus == 'start')
            (_c = start.current) === null || _c === void 0 ? void 0 : _c.focus();
        else if (initialFocus === null || initialFocus === void 0 ? void 0 : initialFocus.length)
            focus(initialFocus);
    }, [resetFocus]);
    react_1.useEffect(() => {
        if (name === null || name === void 0 ? void 0 : name.length)
            register(name, () => {
                ref.current && ref.current.focus();
            });
    }, []);
    return (react_1.default.createElement(Tag, Object.assign({}, props, { ref: ref, tabIndex: 0, className: [rootStyles, className].join(' ') }),
        react_1.default.createElement("div", { role: 'button', ref: start, onKeyDown: onKeyDown, "aria-label": startLabel, className: startStyles, tabIndex: 0 }, startText),
        children,
        react_1.default.createElement("div", { role: 'button', ref: end, onKeyDown: onKeyDown, "aria-label": endLabel, className: endStyles, tabIndex: 0 }, endText)));
};
exports.FocusTrap = FocusTrap;


/***/ }),

/***/ "./src/components/focus-trap/index.ts":
/*!********************************************!*\
  !*** ./src/components/focus-trap/index.ts ***!
  \********************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
tslib_1.__exportStar(__webpack_require__(/*! ./focus-trap.component */ "./src/components/focus-trap/focus-trap.component.tsx"), exports);


/***/ }),

/***/ "./src/components/grid/column.component.tsx":
/*!**************************************************!*\
  !*** ./src/components/grid/column.component.tsx ***!
  \**************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.Column = void 0;
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
const React = tslib_1.__importStar(__webpack_require__(/*! react */ "react"));
const smarthub_common_1 = __webpack_require__(/*! smarthub-common */ "smarthub-common");
const component_wrapper_component_1 = __webpack_require__(/*! ./component-wrapper.component */ "./src/components/grid/component-wrapper.component.tsx");
const get_responsive_class_helper_1 = __webpack_require__(/*! ./get-responsive-class.helper */ "./src/components/grid/get-responsive-class.helper.ts");
const row_component_1 = __webpack_require__(/*! ./row.component */ "./src/components/grid/row.component.tsx");
const Column = ({ layout, column, contentView }) => {
    const styles = smarthub_common_1.useGridStyles();
    const { zones: layoutZones } = layout;
    const { tokens: { padding, hideOnExpand, spacer } = {}, responsive, zones } = column;
    const { col, padR, padL } = styles;
    const className = [col, padding == "normal" ? padR : "", (spacer == 'normal' ? padL : ''), get_responsive_class_helper_1.getResponsiveClass(styles, responsive)].join(" ");
    return (contentView != 'expanded' || !hideOnExpand)
        ? React.createElement("div", { className: className },
            column.zones && zones.map((zone, zoneIndex) => {
                const zoneConfig = layoutZones.find(c => c.id == zone.id);
                return (React.createElement(React.Fragment, { key: zoneIndex }, zoneConfig &&
                    zoneConfig.components.map((component) => React.createElement(component_wrapper_component_1.ComponentWrapper, { key: component.$id, config: component }))));
            }),
            column.rows && column.rows.map((row, rowIndex) => {
                return React.createElement(row_component_1.Row, { key: rowIndex, row: row, layout: layout, contentView: contentView });
            }))
        : null;
};
exports.Column = Column;


/***/ }),

/***/ "./src/components/grid/component-wrapper.component.tsx":
/*!*************************************************************!*\
  !*** ./src/components/grid/component-wrapper.component.tsx ***!
  \*************************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.ComponentWrapper = void 0;
const smarthub_common_1 = __webpack_require__(/*! smarthub-common */ "smarthub-common");
const ComponentWrapper = ({ config, data, fallback }) => {
    const render = smarthub_common_1.useRender();
    return render(config, data, fallback)();
};
exports.ComponentWrapper = ComponentWrapper;


/***/ }),

/***/ "./src/components/grid/get-responsive-class.helper.ts":
/*!************************************************************!*\
  !*** ./src/components/grid/get-responsive-class.helper.ts ***!
  \************************************************************/
/***/ ((__unused_webpack_module, exports) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.getResponsiveClass = void 0;
const getResponsiveClass = (gridStyles, responsive) => {
    let className = [];
    if (responsive) {
        Object.keys(responsive).forEach(k => {
            let design = responsive[k];
            Object.keys(design).forEach(key => {
                const name = key == 'display' || key == 'size' || key == 'align' || key == 'wrap'
                    ? gridStyles[`${k}${design[key]}`]
                    : key == 'order' || key == 'max' || key == 'min'
                        ? gridStyles[`${k}${key}${design[key]}`]
                        : gridStyles[`${k}${key}`];
                className.push(name);
            });
        });
    }
    return className.join(" ");
};
exports.getResponsiveClass = getResponsiveClass;


/***/ }),

/***/ "./src/components/grid/grid.component.tsx":
/*!************************************************!*\
  !*** ./src/components/grid/grid.component.tsx ***!
  \************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.Grid = void 0;
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
const react_1 = tslib_1.__importDefault(__webpack_require__(/*! react */ "react"));
const smarthub_common_1 = __webpack_require__(/*! smarthub-common */ "smarthub-common");
const get_responsive_class_helper_1 = __webpack_require__(/*! ./get-responsive-class.helper */ "./src/components/grid/get-responsive-class.helper.ts");
const row_component_1 = __webpack_require__(/*! ./row.component */ "./src/components/grid/row.component.tsx");
const Grid = ({ resetScroll, layout, as, className }) => {
    const styles = smarthub_common_1.useGridStyles();
    const { grid, padR, padB } = styles;
    const { content: contentView } = smarthub_common_1.usePanelView();
    const { grid: { tokens: { padding, spacer } = {}, responsive, rows } } = layout;
    const Tag = as || 'div';
    const combinedClass = [className, grid, padding == "none" ? "" : padR, (spacer == 'normal' ? padB : ''), get_responsive_class_helper_1.getResponsiveClass(styles, responsive)].join(" ");
    return (react_1.default.createElement(Tag, { className: combinedClass }, rows === null || rows === void 0 ? void 0 : rows.map((row, rowIndex) => react_1.default.createElement(row_component_1.Row, { key: `${rowIndex}-${resetScroll}`, row: row, layout: layout, contentView: contentView }))));
};
exports.Grid = Grid;


/***/ }),

/***/ "./src/components/grid/index.ts":
/*!**************************************!*\
  !*** ./src/components/grid/index.ts ***!
  \**************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
tslib_1.__exportStar(__webpack_require__(/*! ./grid.component */ "./src/components/grid/grid.component.tsx"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./row.component */ "./src/components/grid/row.component.tsx"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./column.component */ "./src/components/grid/column.component.tsx"), exports);


/***/ }),

/***/ "./src/components/grid/row.component.tsx":
/*!***********************************************!*\
  !*** ./src/components/grid/row.component.tsx ***!
  \***********************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.Row = void 0;
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
const React = tslib_1.__importStar(__webpack_require__(/*! react */ "react"));
const smarthub_common_1 = __webpack_require__(/*! smarthub-common */ "smarthub-common");
const column_component_1 = __webpack_require__(/*! ./column.component */ "./src/components/grid/column.component.tsx");
const get_responsive_class_helper_1 = __webpack_require__(/*! ./get-responsive-class.helper */ "./src/components/grid/get-responsive-class.helper.ts");
const Row = ({ layout, row, contentView }) => {
    const styles = smarthub_common_1.useGridStyles();
    const { tokens: { padding, hideOnExpand, spacer } = {}, responsive } = row;
    const { row: rowStyle, padT, padB } = styles;
    const className = [rowStyle, (padding == "normal" ? padT : ""), (spacer == 'normal' ? padB : ''), get_responsive_class_helper_1.getResponsiveClass(styles, responsive)].join(" ");
    return (contentView != 'expanded' || !hideOnExpand)
        ? React.createElement("div", { className: className }, row.columns && row.columns.map((col, colIndex) => React.createElement(column_component_1.Column, { key: colIndex, column: col, layout: layout, contentView: contentView })))
        : null;
};
exports.Row = Row;


/***/ }),

/***/ "./src/components/index.ts":
/*!*********************************!*\
  !*** ./src/components/index.ts ***!
  \*********************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
tslib_1.__exportStar(__webpack_require__(/*! ./app */ "./src/components/app/index.ts"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./chat-root */ "./src/components/chat-root/index.ts"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./chrome */ "./src/components/chrome/index.ts"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./context */ "./src/components/context/index.ts"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./focus-trap */ "./src/components/focus-trap/index.ts"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./grid */ "./src/components/grid/index.ts"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./launcher */ "./src/components/launcher/index.ts"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./main-menu */ "./src/components/main-menu/index.ts"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./panel */ "./src/components/panel/index.ts"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./panel-chrome */ "./src/components/panel-chrome/index.ts"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./region */ "./src/components/region/index.ts"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./skip-links */ "./src/components/skip-links/index.ts"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./tpc-message */ "./src/components/tpc-message/index.ts"), exports);


/***/ }),

/***/ "./src/components/launcher/index.ts":
/*!******************************************!*\
  !*** ./src/components/launcher/index.ts ***!
  \******************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
tslib_1.__exportStar(__webpack_require__(/*! ./launcher.component */ "./src/components/launcher/launcher.component.tsx"), exports);


/***/ }),

/***/ "./src/components/launcher/launcher.component.tsx":
/*!********************************************************!*\
  !*** ./src/components/launcher/launcher.component.tsx ***!
  \********************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.Launcher = void 0;
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
const context_1 = __webpack_require__(/*! ../context */ "./src/components/context/index.ts");
const react_1 = tslib_1.__importDefault(__webpack_require__(/*! react */ "react"));
const smarthub_common_1 = __webpack_require__(/*! smarthub-common */ "smarthub-common");
const tpc_message_1 = __webpack_require__(/*! ../tpc-message */ "./src/components/tpc-message/index.ts");
const launchButtonTemplateID = 'component.launch-button';
const splashTemplateID = 'component.splash-screen';
const Launcher = (_a) => {
    var { children } = _a, props = tslib_1.__rest(_a, ["children"]);
    const [chromeState] = smarthub_common_1.useChromeState();
    const botReady = smarthub_common_1.useBotReady();
    const render = smarthub_common_1.useRender();
    return chromeState == 'closed'
        ? render(launchButtonTemplateID)()
        : react_1.default.createElement(tpc_message_1.TPCMessage, null,
            react_1.default.createElement(context_1.ExtendedContext, Object.assign({}, props),
                !botReady && render(splashTemplateID)(),
                children));
};
exports.Launcher = Launcher;


/***/ }),

/***/ "./src/components/main-menu/build-panel-links.helper.tsx":
/*!***************************************************************!*\
  !*** ./src/components/main-menu/build-panel-links.helper.tsx ***!
  \***************************************************************/
/***/ ((__unused_webpack_module, exports) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.buildPanelLinks = void 0;
const buildPanelLinks = (panels, panelLinks, selectPanel, current) => panels.filter(({ navigation }) => navigation == 'primary' || navigation == 'secondary')
    .sort((a, b) => a.order - b.order)
    .reduce((panels, panel) => {
    const { $id, icon, shortTitle, title, description, navigation } = panel;
    const checked = current == $id;
    panels[navigation].push({
        key: $id,
        iconProps: {
            iconName: `${icon === null || icon === void 0 ? void 0 : icon.name}`
        },
        "aria-current": checked,
        checked,
        text: shortTitle,
        title: description,
        ariaLabel: title,
        ariaDescription: description,
        onClick: () => {
            selectPanel(panel);
        }
    });
    return panels;
}, panelLinks);
exports.buildPanelLinks = buildPanelLinks;


/***/ }),

/***/ "./src/components/main-menu/get-cache-key.helper.ts":
/*!**********************************************************!*\
  !*** ./src/components/main-menu/get-cache-key.helper.ts ***!
  \**********************************************************/
/***/ ((__unused_webpack_module, exports) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.getCacheKey = void 0;
const getCacheKey = ({ primaryItems, overflowItems, farItems }) => {
    const returnKey = (acc, { key }) => {
        return acc + key;
    };
    const primaryKey = (primaryItems === null || primaryItems === void 0 ? void 0 : primaryItems.length) && primaryItems.reduce(returnKey, '');
    const farKey = (farItems === null || farItems === void 0 ? void 0 : farItems.length) && farItems.reduce(returnKey, '');
    const overflowKey = (overflowItems === null || overflowItems === void 0 ? void 0 : overflowItems.length) ? 'overflow' : '';
    return [primaryKey, farKey, overflowKey].join('');
};
exports.getCacheKey = getCacheKey;


/***/ }),

/***/ "./src/components/main-menu/index.ts":
/*!*******************************************!*\
  !*** ./src/components/main-menu/index.ts ***!
  \*******************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.MainMenu = void 0;
var main_menu_component_1 = __webpack_require__(/*! ./main-menu.component */ "./src/components/main-menu/main-menu.component.tsx");
Object.defineProperty(exports, "MainMenu", ({ enumerable: true, get: function () { return main_menu_component_1.MainMenu; } }));


/***/ }),

/***/ "./src/components/main-menu/main-menu.component.tsx":
/*!**********************************************************!*\
  !*** ./src/components/main-menu/main-menu.component.tsx ***!
  \**********************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.MainMenu = void 0;
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
const react_1 = tslib_1.__importStar(__webpack_require__(/*! react */ "react"));
const react_jss_1 = __webpack_require__(/*! react-jss */ "react-jss");
const smarthub_common_1 = __webpack_require__(/*! smarthub-common */ "smarthub-common");
const react_2 = __webpack_require__(/*! @fluentui/react */ "@fluentui/react");
const menu_link_component_1 = __webpack_require__(/*! ./menu-link.component */ "./src/components/main-menu/menu-link.component.tsx");
const menu_more_button_component_1 = __webpack_require__(/*! ./menu-more-button.component */ "./src/components/main-menu/menu-more-button.component.tsx");
const use_menu_links_hook_1 = __webpack_require__(/*! ./use-menu-links.hook */ "./src/components/main-menu/use-menu-links.hook.tsx");
const get_cache_key_helper_1 = __webpack_require__(/*! ./get-cache-key.helper */ "./src/components/main-menu/get-cache-key.helper.ts");
const useStyles = react_jss_1.createUseStyles(({ palette, sizes }) => ({
    resize: {
        height: '100vh',
        ["& > div > div:not([data-automation-id]) .ms-FocusZone"]: {
            height: "auto"
        }
    },
    focusZone: {
        display: "flex",
        flexDirection: "column",
        height: '100vh',
        justifyContent: "space-between"
    },
    menu: {
        zIndex: 1,
        transition: "margin-left 300ms ease-in-out",
        flex: "0 0",
        height: '100vh',
        minWidth: sizes.xxLarge,
        position: "relative",
        display: "flex",
        flexDirection: "column",
        backgroundColor: palette.primaryNavBackground,
    },
    nav: {
        flex: "1 1",
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-between",
    },
}));
const onReduceData = (data) => {
    let { primaryItems, overflowItems, farItems } = data;
    if (primaryItems.length > 0) {
        overflowItems = [...primaryItems.slice(-1), ...overflowItems];
        primaryItems = primaryItems.slice(0, -1);
    }
    else if (farItems.length > 0) {
        overflowItems = [...farItems.slice(-1), ...overflowItems];
        farItems = farItems.slice(0, -1);
    }
    else
        return undefined;
    const cacheKey = get_cache_key_helper_1.getCacheKey(data);
    return {
        primaryItems,
        overflowItems,
        farItems,
        cacheKey
    };
};
const onRenderOverflow = (data, styles, localize) => {
    const hasSecondSet = data.farItems && data.farItems.length > 0;
    return react_1.default.createElement(react_2.FocusZone, { direction: react_2.FocusZoneDirection.bidirectional, className: styles.focusZone },
        react_1.default.createElement(react_2.OverflowSet, { role: "menubar", "aria-label": localize.mainMenuPrimaryLabel, vertical: true, items: data.primaryItems, overflowItems: data.overflowItems.length ? data.overflowItems : null, onRenderItem: (item) => react_1.default.createElement(menu_link_component_1.MenuLink, Object.assign({}, item)), onRenderOverflowButton: (items) => react_1.default.createElement(menu_more_button_component_1.MenuMoreButton, { items: items }) }),
        hasSecondSet && react_1.default.createElement(react_2.OverflowSet, { role: "menubar", "aria-label": localize.mainMenuSecondaryLabel, vertical: true, items: data.farItems, onRenderItem: (item) => react_1.default.createElement(menu_link_component_1.MenuLink, Object.assign({}, item)), onRenderOverflowButton: () => { return null; } }));
};
const MainMenu = () => {
    const styles = useStyles();
    const localize = smarthub_common_1.useLocalizeConfig();
    const menuLinks = use_menu_links_hook_1.useMenuLinks();
    const { mode } = smarthub_common_1.useViewConfig();
    const hasLinks = ((menuLinks === null || menuLinks === void 0 ? void 0 : menuLinks.farItems.length) + (menuLinks === null || menuLinks === void 0 ? void 0 : menuLinks.overflowItems.length)
        + (menuLinks === null || menuLinks === void 0 ? void 0 : menuLinks.primaryItems.length)) > 0;
    return react_1.useMemo(() => (hasLinks && mode == 'full'
        ? react_1.default.createElement("nav", { className: styles.menu, title: localize.navTitle },
            react_1.default.createElement("section", { className: styles.nav },
                react_1.default.createElement(react_2.ResizeGroup, { className: styles.resize, role: "tabpanel", "aria-label": "Primary navigation", direction: react_2.ResizeGroupDirection.vertical, data: menuLinks, onReduceData: onReduceData, onRenderData: (data) => onRenderOverflow(data, styles, localize) })))
        : react_1.default.createElement(react_1.default.Fragment, null)), [menuLinks, styles, localize]);
};
exports.MainMenu = MainMenu;


/***/ }),

/***/ "./src/components/main-menu/menu-link.component.tsx":
/*!**********************************************************!*\
  !*** ./src/components/main-menu/menu-link.component.tsx ***!
  \**********************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.MenuLink = void 0;
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
const react_1 = tslib_1.__importStar(__webpack_require__(/*! react */ "react"));
const smarthub_common_1 = __webpack_require__(/*! smarthub-common */ "smarthub-common");
const react_2 = __webpack_require__(/*! @fluentui/react */ "@fluentui/react");
const fluentStyles = (({ theme: { palette, fonts, sizes, spacing } }) => ({
    root: {
        display: "block",
        boxSizing: "border-box",
        margin: 0,
        padding: 0,
        width: "100%",
        minWidth: 0,
        maxWidth: sizes.xxLarge,
        height: sizes.xLarge,
        border: `${spacing.tiny} solid transparent`,
        borderLeft: `${spacing.small} solid transparent`,
        backgroundColor: 'transparent',
        transitionTimingFunction: "ease-in",
        transitionDuration: "300ms",
        transitionProperty: "color, border-color, background-color",
    },
    rootHovered: {
        color: palette.filmOn,
        backgroundColor: palette.film,
    },
    rootPressed: {
        color: palette.filmOn,
        backgroundColor: palette.film,
    },
    rootFocused: {
        color: palette.filmOn,
        backgroundColor: palette.film,
        borderColor: palette.filmOn,
    },
    rootChecked: {
        color: palette.filmOn,
        backgroundColor: palette.film,
        borderLeftColor: palette.filmOn,
    },
    rootCheckedHovered: {
        color: palette.filmOn,
        backgroundColor: palette.film,
        borderColor: palette.filmOn,
    },
    rootCheckedPressed: {
        color: palette.filmOn,
        backgroundColor: palette.film,
        borderColor: palette.filmOn,
    },
    flexContainer: {
        width: "100%",
        flexDirection: "column",
        boxSizing: "border-box"
    },
    icon: Object.assign(Object.assign({}, fonts.xxLarge), { color: palette.primaryNavText, margin: `${spacing.medium} 0 0 -${spacing.small}`, width: "100%", height: sizes.small }),
    iconChecked: {
        color: palette.filmOn
    },
    label: Object.assign(Object.assign({}, fonts.tiny), { color: palette.primaryNavText, margin: `-${spacing.smallPlus} 0 0 -${spacing.smallPlus}`, height: sizes.smallPlus, lineHeight: sizes.smallPlus }),
    labelChecked: {
        color: palette.filmOn
    }
}));
const MenuLink = (_a) => {
    var { checked, data, onClick } = _a, rest = tslib_1.__rest(_a, ["checked", "data", "onClick"]);
    const styles = smarthub_common_1.useFluentStylesWithProps(fluentStyles);
    const registerLastFocus = smarthub_common_1.useRegisterLastAction();
    const buttonContent = react_1.useRef();
    const registerFocusCallback = react_1.useCallback(() => {
        registerLastFocus('main', () => {
            buttonContent.current.focus();
        });
    }, []);
    const handleClick = react_1.useCallback(() => {
        onClick(data);
        registerFocusCallback();
    }, [onClick, data]);
    return react_1.default.createElement(react_2.DefaultButton, Object.assign({ componentRef: buttonContent, checked: checked, styles: styles, onClick: handleClick }, rest));
};
exports.MenuLink = MenuLink;


/***/ }),

/***/ "./src/components/main-menu/menu-more-button.component.tsx":
/*!*****************************************************************!*\
  !*** ./src/components/main-menu/menu-more-button.component.tsx ***!
  \*****************************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.MenuMoreButton = void 0;
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
const react_1 = tslib_1.__importDefault(__webpack_require__(/*! react */ "react"));
const smarthub_common_1 = __webpack_require__(/*! smarthub-common */ "smarthub-common");
const react_2 = __webpack_require__(/*! @fluentui/react */ "@fluentui/react");
const fluentStyles = (({ theme: { palette, fonts, sizes, spacing } }) => ({
    menu: {
        subComponentStyles: {
            callout: {},
            menuItem: ({ checked }) => ({
                label: {
                    fontWeight: checked && '600',
                    color: checked && palette.primary
                },
                icon: {
                    fontWeight: checked && '600',
                    color: checked && palette.primary
                }
            })
        }
    },
    more: {
        root: {
            display: "block",
            boxSizing: "border-box",
            margin: 0,
            padding: 0,
            width: "100%",
            minWidth: 0,
            maxWidth: sizes.xxLarge,
            height: sizes.xLarge,
            border: `${spacing.tiny} solid transparent`,
            borderLeft: `${spacing.small} solid transparent`,
            backgroundColor: 'transparent',
            transitionTimingFunction: "ease-in",
            transitionDuration: "300ms",
            transitionProperty: "color, border-color, background-color",
            "& .ms-Button-menuIcon": {
                color: palette.primaryNavText,
            }
        },
        rootHovered: {
            color: palette.filmOn,
            backgroundColor: palette.film,
            "& .ms-Button-menuIcon": {
                color: palette.filmOn,
            }
        },
        rootFocused: {
            color: palette.filmOn,
            backgroundColor: palette.film,
            borderColor: palette.filmOn,
            "& .ms-Button-menuIcon": {
                color: palette.filmOn,
            }
        },
        rootExpanded: {
            color: palette.filmOn,
            backgroundColor: palette.film,
            borderColor: palette.filmOn,
            "& .ms-Button-menuIcon": {
                color: palette.filmOn,
            }
        },
        rootExpandedHovered: {
            color: palette.filmOn,
            backgroundColor: palette.film,
            borderColor: palette.filmOn,
            "& .ms-Button-menuIcon": {
                color: palette.filmOn,
            }
        },
        rootPressed: {
            color: palette.filmOn,
            backgroundColor: palette.film,
            borderColor: palette.filmOn,
            "& .ms-Button-menuIcon": {
                color: palette.filmOn,
            }
        },
        flexContainer: {
            width: "100%",
            flexDirection: "column-reverse",
            boxSizing: "border-box"
        },
        menuIcon: Object.assign(Object.assign({}, fonts.xxLarge), { color: palette.primaryNavText, order: 1, margin: `${spacing.medium} 0 0 ${spacing.small}`, width: "100%", height: fonts.xxLarge.fontSize }),
        menuIconHovered: {
            color: palette.filmOn,
        },
        menuIconPressed: {
            color: palette.filmOn,
        },
        menuIconExpanded: {
            color: palette.filmOn,
        },
        menuIconExpandedHovered: {
            color: palette.filmOn,
        },
        label: Object.assign(Object.assign({}, fonts.tiny), { order: 2, color: palette.primaryNavText, margin: `-${spacing.smallPlus} 0 0 -${spacing.smallPlus}`, height: sizes.smallPlus, lineHeight: sizes.smallPlus }),
    }
}));
const MenuMoreButton = ({ items }) => {
    const styles = smarthub_common_1.useFluentStylesWithProps(fluentStyles);
    const localize = smarthub_common_1.useLocalizeConfig();
    return (react_1.default.createElement(react_2.CommandBarButton, { role: "menuitem", "aria-label": localize.panelMenuMoreLabel, title: localize.panelMenuMoreLabel, styles: styles.more, text: localize.panelMenuMoreText, menuIconProps: { iconName: 'More' }, menuProps: {
            styles: styles.menu,
            items: items
        } }));
};
exports.MenuMoreButton = MenuMoreButton;


/***/ }),

/***/ "./src/components/main-menu/use-action-links.hook.tsx":
/*!************************************************************!*\
  !*** ./src/components/main-menu/use-action-links.hook.tsx ***!
  \************************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.useActionLinks = void 0;
const react_1 = __webpack_require__(/*! react */ "react");
const smarthub_common_1 = __webpack_require__(/*! smarthub-common */ "smarthub-common");
const useActionLinks = () => {
    const actions = smarthub_common_1.useAppActions();
    const getThemeImage = smarthub_common_1.useGetThemeImageURI();
    const handleCommand = smarthub_common_1.useHandleCommand();
    return react_1.useMemo(() => actions
        .reduce((actions, appAction, idx) => {
        const { action, name, title, description, shortTitle, icon, position, coachmark } = appAction;
        actions[position !== null && position !== void 0 ? position : smarthub_common_1.AppActionPosition.farBefore].push({
            key: `${name}-${idx}`,
            text: shortTitle,
            iconProps: {
                iconName: typeof icon == 'string' ? icon : undefined,
                imageProps: icon && typeof icon == 'object'
                    ? {
                        src: getThemeImage(icon.image),
                        alt: typeof icon.image == 'object'
                            ? icon.image.text
                            : title
                    }
                    : undefined
            },
            ariaDescription: description,
            ariaLabel: title,
            title,
            coachmark: coachmark,
            onClick: () => handleCommand(action)
        });
        return actions;
    }, {
        [smarthub_common_1.AppActionPosition.farAfter]: [],
        [smarthub_common_1.AppActionPosition.farBefore]: [],
        [smarthub_common_1.AppActionPosition.moreAfter]: [],
        [smarthub_common_1.AppActionPosition.moreBefore]: [],
        [smarthub_common_1.AppActionPosition.nearAfter]: [],
        [smarthub_common_1.AppActionPosition.nearBefore]: [],
    }), [actions, getThemeImage]);
};
exports.useActionLinks = useActionLinks;


/***/ }),

/***/ "./src/components/main-menu/use-menu-links.hook.tsx":
/*!**********************************************************!*\
  !*** ./src/components/main-menu/use-menu-links.hook.tsx ***!
  \**********************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.useMenuLinks = void 0;
const react_1 = __webpack_require__(/*! react */ "react");
const use_action_links_hook_1 = __webpack_require__(/*! ./use-action-links.hook */ "./src/components/main-menu/use-action-links.hook.tsx");
const use_panel_links_hook_1 = __webpack_require__(/*! ./use-panel-links.hook */ "./src/components/main-menu/use-panel-links.hook.tsx");
const useMenuLinks = () => {
    const panelLinks = use_panel_links_hook_1.usePanelLinks();
    const actionLinks = use_action_links_hook_1.useActionLinks();
    return react_1.useMemo(() => {
        const data = {
            primaryItems: [
                ...actionLinks.nearBefore,
                ...panelLinks.primary,
                ...actionLinks.nearAfter,
            ],
            farItems: [
                ...actionLinks.farBefore,
                ...panelLinks.secondary,
                ...actionLinks.farAfter
            ],
            overflowItems: [
                ...actionLinks.moreBefore,
                ...actionLinks.moreAfter,
            ]
        };
        return data;
    }, [panelLinks, actionLinks]);
};
exports.useMenuLinks = useMenuLinks;


/***/ }),

/***/ "./src/components/main-menu/use-panel-links.hook.tsx":
/*!***********************************************************!*\
  !*** ./src/components/main-menu/use-panel-links.hook.tsx ***!
  \***********************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.usePanelLinks = void 0;
const react_1 = __webpack_require__(/*! react */ "react");
const smarthub_common_1 = __webpack_require__(/*! smarthub-common */ "smarthub-common");
const build_panel_links_helper_1 = __webpack_require__(/*! ./build-panel-links.helper */ "./src/components/main-menu/build-panel-links.helper.tsx");
const usePanelLinks = () => {
    const panels = smarthub_common_1.usePanels();
    const setPanelId = smarthub_common_1.useSetPanelId();
    const current = smarthub_common_1.usePanelId();
    const setChatPanelView = smarthub_common_1.useSetPanelView();
    const chatPanelViewRef = smarthub_common_1.useHookRef(smarthub_common_1.usePanelView, 'chat');
    const pageViewRef = smarthub_common_1.useHookRef(smarthub_common_1.usePanelView, 'page');
    const setPage = smarthub_common_1.useSetPanelId('page');
    //TODO move to panelviewstate provider
    const selectPanel = react_1.useCallback((panel) => {
        if (chatPanelViewRef.current.visible && (chatPanelViewRef.current.size == 'full' || chatPanelViewRef.current.size == 'asside'))
            setChatPanelView(Object.assign(Object.assign({}, chatPanelViewRef.current), { visible: false }));
        if (pageViewRef.current.size == 'full')
            setPage();
        setPanelId(panel.$id);
    }, []);
    return react_1.useMemo(() => {
        const panelLinks = {
            primary: [],
            secondary: [],
        };
        return (panels === null || panels === void 0 ? void 0 : panels.length) ? build_panel_links_helper_1.buildPanelLinks(panels, panelLinks, selectPanel, current)
            : panelLinks;
    }, [panels, current]);
};
exports.usePanelLinks = usePanelLinks;


/***/ }),

/***/ "./src/components/panel-chrome/index.ts":
/*!**********************************************!*\
  !*** ./src/components/panel-chrome/index.ts ***!
  \**********************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
tslib_1.__exportStar(__webpack_require__(/*! ./panel-chrome.component */ "./src/components/panel-chrome/panel-chrome.component.tsx"), exports);


/***/ }),

/***/ "./src/components/panel-chrome/panel-chrome.component.tsx":
/*!****************************************************************!*\
  !*** ./src/components/panel-chrome/panel-chrome.component.tsx ***!
  \****************************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.PanelChrome = void 0;
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
const react_1 = tslib_1.__importStar(__webpack_require__(/*! react */ "react"));
const smarthub_common_1 = __webpack_require__(/*! smarthub-common */ "smarthub-common");
const react_jss_1 = __webpack_require__(/*! react-jss */ "react-jss");
const context_1 = __webpack_require__(/*! ../context */ "./src/components/context/index.ts");
const focus_trap_1 = __webpack_require__(/*! ../focus-trap */ "./src/components/focus-trap/index.ts");
const panel_inner_component_1 = __webpack_require__(/*! ./panel-inner.component */ "./src/components/panel-chrome/panel-inner.component.tsx");
const region_1 = __webpack_require__(/*! ../region */ "./src/components/region/index.ts");
const useStyles = react_jss_1.createUseStyles((theme) => {
    var _a, _b;
    const { palette, spacing, styles } = theme;
    const panel = (_b = (_a = styles === null || styles === void 0 ? void 0 : styles.panel) === null || _a === void 0 ? void 0 : _a.chrome) !== null && _b !== void 0 ? _b : {};
    const props = { theme };
    return {
        root: ({ config: { type }, }) => (Object.assign({ display: "flex", flexDirection: "column", justifyContent: "center", boxSizing: "border-box", transition: "top 200ms ease-in-out", height: "100vh", width: "100%", zIndex: 2, backgroundColor: type == "page"
                ? palette.neutralEmpty
                : type == "chat"
                    ? palette.neutralMinus3
                    : palette.neutralMinus5, color: type == "page"
                ? palette.neutralEmptyOn
                : type == "chat"
                    ? palette.neutralMinus3On
                    : palette.neutralMinus5On, boxShadow: `0 0 ${spacing.normal} ${palette.filmMinus1}`, "& *": {
                overscrollBehavior: "auto",
            }, "& *::-webkit-scrollbar-track": {
                borderRadius: spacing.xSmall,
                background: "transparent",
                border: "0",
            }, "& *::-webkit-scrollbar": {
                width: spacing.medium,
                height: spacing.medium,
                border: "0",
            }, "& *:hover::-webkit-scrollbar": {
                width: spacing.medium,
                height: spacing.medium,
            }, "& *::-webkit-scrollbar-thumb": {
                background: palette.primary,
                borderRadius: spacing.xSmall,
                border: "0",
            } }, smarthub_common_1.themeStyle(panel.root, props))),
        docked: ({ config: { size }, responsive, }) => (Object.assign({ transition: "width 200ms ease-in-out", width: smarthub_common_1.responsiveColumnWidths[responsive[size]], maxWidth: "450px" }, smarthub_common_1.themeStyle(panel.docked, { config: { size }, responsive, theme }))),
        full: ({ config: { size }, responsive, }) => (Object.assign(Object.assign({ left: 0, top: 0, right: 0, bottom: 0, display: "flex", position: responsive.overlay === false ? "relative" : "absolute", flex: responsive.overlay === false ? "1 1" : undefined }, smarthub_common_1.themeStyle(panel.full, { config: { size }, responsive, theme })), { ["& $inner"]: Object.assign({ width: responsive.overlay === false
                    ? "100%"
                    : smarthub_common_1.responsiveColumnWidths[responsive[size]] }, smarthub_common_1.themeStyle(panel.fullFrame, { config: { size }, responsive, theme })), ["& $overlay"]: Object.assign({ transition: "top 200ms ease-in-out", position: "absolute", left: 0, width: "100%", height: "100%", top: 0, backgroundColor: palette.neutralMinus5 }, smarthub_common_1.themeStyle(panel.fullOverlay, {
                config: { size },
                responsive,
                theme,
            })) })),
        overlay: Object.assign({}, smarthub_common_1.themeStyle(panel.overlay, props)),
        inner: Object.assign({ overflow: "hidden", display: "flex", flexDirection: "column", flex: "1 1", width: "100%", height: "100%", alignSelf: "center" }, smarthub_common_1.themeStyle(panel.inner, props)),
        "@supports (-webkit-touch-callout: none)": {
            root: ({ config: { type }, }) => ({
                height: "86vh",
            }),
        },
    };
});
const PanelChrome = () => {
    var _a, _b;
    const { panel, type, panel: { title, initialFocus }, regions, regions: { menu, launcher, pages }, } = smarthub_common_1.usePanelViewContext();
    const entity = smarthub_common_1.usePanelEntity(type);
    const localise = smarthub_common_1.useLocalizeConfig();
    const endText = localise[`${type}EndText`];
    const startText = localise[`${type}StartText`];
    const endLabel = localise[`${type}EndLabel`];
    const startLabel = localise[`${type}StartLabel`];
    const panelLabel = localise[`${type}PanelLabel`];
    const viewConfig = smarthub_common_1.useViewConfig();
    const { dockSizes, trapFocus } = viewConfig[type];
    const viewState = smarthub_common_1.usePanelView();
    const gridStyles = smarthub_common_1.useGridStyles();
    const styleConfig = react_1.useMemo(() => (Object.assign(Object.assign({}, viewState), { type })), [viewState, type]);
    const styleProps = smarthub_common_1.useStyleProps(styleConfig, (_b = (_a = panel === null || panel === void 0 ? void 0 : panel.dock) === null || _a === void 0 ? void 0 : _a.options) !== null && _b !== void 0 ? _b : dockSizes);
    const styles = useStyles(styleProps);
    const panelStyles = smarthub_common_1.usePanelStyles();
    const resetFocus = `${panel.$id}${entity === null || entity === void 0 ? void 0 : entity.$entityId}`;
    const resetPanelId = smarthub_common_1.useResetPanelId(type);
    const focusLastAction = smarthub_common_1.useFocusLastAction();
    const onClose = react_1.useCallback(() => {
        resetPanelId();
        focusLastAction(type);
    }, [type]);
    return react_1.useMemo(() => {
        var _a;
        return (react_1.default.createElement(focus_trap_1.FocusTrap, Object.assign({}, {
            as: "article",
            name: `${type}-panel`,
            endLabel,
            endText,
            startLabel,
            startText,
            trapFocus,
            initialFocus,
            resetFocus,
            onClose,
        }, { className: [
                styles.root,
                viewState.size == "full" ? styles.full : styles.docked,
            ].join(" "), "aria-label": `${panelLabel}, ${title}${((_a = entity === null || entity === void 0 ? void 0 : entity.title) === null || _a === void 0 ? void 0 : _a.length) ? `, ${entity.title}` : ""}` }),
            launcher && react_1.default.createElement(region_1.Region, { layout: launcher }),
            pages && react_1.default.createElement(region_1.Region, { layout: pages }),
            react_1.default.createElement("div", { className: styles.overlay }),
            menu && (react_1.default.createElement("nav", null,
                react_1.default.createElement(region_1.Region, { layout: menu }))),
            react_1.default.createElement(context_1.BreakpointProvider, { className: styles.inner },
                react_1.default.createElement(panel_inner_component_1.PanelInner, { regions: regions, resetScroll: resetFocus }))));
    }, [gridStyles, styles, panelStyles, regions, viewState, resetFocus, onClose]);
};
exports.PanelChrome = PanelChrome;


/***/ }),

/***/ "./src/components/panel-chrome/panel-inner.component.tsx":
/*!***************************************************************!*\
  !*** ./src/components/panel-chrome/panel-inner.component.tsx ***!
  \***************************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.PanelInner = exports.useStyles = void 0;
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
const react_1 = tslib_1.__importStar(__webpack_require__(/*! react */ "react"));
const smarthub_common_1 = __webpack_require__(/*! smarthub-common */ "smarthub-common");
const region_1 = __webpack_require__(/*! ../region */ "./src/components/region/index.ts");
const react_jss_1 = __webpack_require__(/*! react-jss */ "react-jss");
exports.useStyles = react_jss_1.createUseStyles((theme) => {
    var _a, _b, _c;
    const panel = (_c = (_b = (_a = theme.styles) === null || _a === void 0 ? void 0 : _a.panel) === null || _b === void 0 ? void 0 : _b.chrome) !== null && _c !== void 0 ? _c : {};
    const props = { theme };
    return {
        sidebar: ({ responsive: { overlay } }) => (Object.assign({ position: overlay ? "absolute" : "relative", height: "100%" }, smarthub_common_1.themeStyle(panel.sidebar, props))),
        header: smarthub_common_1.themeStyle(panel.header, props),
        bodyWrapper: {
            display: "flex",
            flex: "1",
            fontSize: "16px",
            overflow: "hidden",
            position: "relative",
            "& p": {
                fontSize: "16px",
                lineHeight: "1.5em",
                color: "inherit !important",
                fontFamily: `Calibri, "Helvetica Neue", Arial, "sans-serif"`,
            },
            "& .wechat__bubble__content > p": {
                padding: "10px !important",
            },
            "& img": {
                display: "inherit !important",
            },
        },
        body: Object.assign({ flex: "1 1" }, smarthub_common_1.themeStyle(panel.body, props)),
        menu: Object.assign({ flex: "1 0 100%", width: "100%" }, smarthub_common_1.themeStyle(panel.menu, props)),
        footer: smarthub_common_1.themeStyle(panel.footer, props),
    };
});
const responsive = {
    sm: { overlay: true },
    lg: { overlay: false },
};
const PanelInner = ({ regions, resetScroll }) => {
    const { body, footer, header, sidebar, splash } = regions;
    const gridStyles = smarthub_common_1.useGridStyles();
    const styleProps = smarthub_common_1.useStyleProps(null, responsive);
    const styles = exports.useStyles(styleProps);
    const panelStyles = smarthub_common_1.usePanelStyles();
    return react_1.useMemo(() => (react_1.default.createElement("div", { className: [gridStyles.grid, gridStyles.row, gridStyles.smstretch].join(" ") },
        sidebar && (react_1.default.createElement("aside", { className: [
                gridStyles.col,
                gridStyles.smmax12,
                gridStyles.lgmax6,
                gridStyles.lgxmax4,
                gridStyles.xlmax3,
                gridStyles.xlxmax2,
                styles.sidebar,
            ].join(" ") },
            react_1.default.createElement(region_1.Region, { layout: sidebar }))),
        react_1.default.createElement("div", { className: [
                gridStyles.col,
                gridStyles.sm12,
                gridStyles.lg6,
                gridStyles.lgx8,
                gridStyles.xl9,
                gridStyles.xlx10,
                gridStyles.smclip,
                gridStyles.smfill,
                panelStyles.body,
            ].join(" ") },
            header && (react_1.default.createElement("header", null,
                react_1.default.createElement(region_1.Region, { layout: header }))),
            body && (react_1.default.createElement("div", { className: styles.bodyWrapper },
                splash && react_1.default.createElement(region_1.Region, { layout: splash }),
                react_1.default.createElement(region_1.Region, { as: "section", layout: body, className: styles.body, resetScroll: resetScroll }))),
            footer && (react_1.default.createElement("footer", null,
                react_1.default.createElement(region_1.Region, { layout: footer })))))), [
        gridStyles,
        styles,
        panelStyles,
        body,
        footer,
        header,
        sidebar,
        resetScroll,
    ]);
};
exports.PanelInner = PanelInner;


/***/ }),

/***/ "./src/components/panel/index.ts":
/*!***************************************!*\
  !*** ./src/components/panel/index.ts ***!
  \***************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
tslib_1.__exportStar(__webpack_require__(/*! ./panel.component */ "./src/components/panel/panel.component.tsx"), exports);


/***/ }),

/***/ "./src/components/panel/panel.component.tsx":
/*!**************************************************!*\
  !*** ./src/components/panel/panel.component.tsx ***!
  \**************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.Panel = void 0;
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
const react_1 = tslib_1.__importDefault(__webpack_require__(/*! react */ "react"));
const context_1 = __webpack_require__(/*! ../context */ "./src/components/context/index.ts");
const panel_chrome_1 = __webpack_require__(/*! ../panel-chrome */ "./src/components/panel-chrome/index.ts");
const Panel = ({ type }) => {
    return (react_1.default.createElement(context_1.PanelViewProvider, { type: type },
        react_1.default.createElement(panel_chrome_1.PanelChrome, null)));
};
exports.Panel = Panel;


/***/ }),

/***/ "./src/components/region/index.ts":
/*!****************************************!*\
  !*** ./src/components/region/index.ts ***!
  \****************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
tslib_1.__exportStar(__webpack_require__(/*! ./region.component */ "./src/components/region/region.component.tsx"), exports);


/***/ }),

/***/ "./src/components/region/region.component.tsx":
/*!****************************************************!*\
  !*** ./src/components/region/region.component.tsx ***!
  \****************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.Region = void 0;
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
const react_1 = tslib_1.__importStar(__webpack_require__(/*! react */ "react"));
const smarthub_common_1 = __webpack_require__(/*! smarthub-common */ "smarthub-common");
const grid_1 = __webpack_require__(/*! ../grid */ "./src/components/grid/index.ts");
const Region = (_a) => {
    var { layout, fallback, resetScroll } = _a, props = tslib_1.__rest(_a, ["layout", "fallback", "resetScroll"]);
    const render = smarthub_common_1.useRender();
    const isComponent = layout.hasOwnProperty('template')
        || layout.$schema == smarthub_common_1.IComponentSchema;
    return react_1.useMemo(() => isComponent
        ? render(layout, null, fallback)()
        : react_1.default.createElement(grid_1.Grid, Object.assign({ layout: layout, resetScroll: resetScroll }, props)), [layout, isComponent, fallback, resetScroll]);
};
exports.Region = Region;


/***/ }),

/***/ "./src/components/skip-links/index.ts":
/*!********************************************!*\
  !*** ./src/components/skip-links/index.ts ***!
  \********************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
tslib_1.__exportStar(__webpack_require__(/*! ./skip-links.component */ "./src/components/skip-links/skip-links.component.tsx"), exports);


/***/ }),

/***/ "./src/components/skip-links/skip-links.component.tsx":
/*!************************************************************!*\
  !*** ./src/components/skip-links/skip-links.component.tsx ***!
  \************************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.SkipLinks = void 0;
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
const react_1 = tslib_1.__importStar(__webpack_require__(/*! react */ "react"));
const react_2 = __webpack_require__(/*! @fluentui/react */ "@fluentui/react");
const smarthub_common_1 = __webpack_require__(/*! smarthub-common */ "smarthub-common");
const react_jss_1 = __webpack_require__(/*! react-jss */ "react-jss");
const useStyles = react_jss_1.createUseStyles(({ sizes }) => ({
    root: {
        position: "absolute",
        top: `-${sizes.mediumPlus}`,
        height: `${sizes.mediumPlus}`,
        width: "100%",
        zIndex: 1,
        transition: "top ease-out 300ms",
        "&:focus-within": {
            top: 0
        }
    }
}));
const SkipLinks = () => {
    const styles = useStyles();
    const focus = smarthub_common_1.useFocus();
    const localize = smarthub_common_1.useLocalizeConfig();
    return react_1.useMemo(() => (react_1.default.createElement("div", { className: styles.root },
        react_1.default.createElement(react_2.CommandBar, { items: [{
                    key: 'main-panel',
                    ariaLabel: localize.skipToMain,
                    title: localize.skipToMain,
                    text: localize.skipToMain,
                    onClick: () => { focus('main-panel'); }
                }, {
                    key: 'chat-controls',
                    ariaLabel: localize.skipToChat,
                    title: localize.skipToChat,
                    text: localize.skipToChat,
                    onClick: () => { focus('chat-controls'); }
                }] }))), []);
};
exports.SkipLinks = SkipLinks;


/***/ }),

/***/ "./src/components/tpc-message/index.ts":
/*!*********************************************!*\
  !*** ./src/components/tpc-message/index.ts ***!
  \*********************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
tslib_1.__exportStar(__webpack_require__(/*! ./tpc-message.component */ "./src/components/tpc-message/tpc-message.component.tsx"), exports);


/***/ }),

/***/ "./src/components/tpc-message/tpc-message.component.tsx":
/*!**************************************************************!*\
  !*** ./src/components/tpc-message/tpc-message.component.tsx ***!
  \**************************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.TPCMessage = void 0;
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
const react_1 = tslib_1.__importStar(__webpack_require__(/*! react */ "react"));
const react_2 = __webpack_require__(/*! @fluentui/react */ "@fluentui/react");
const smarthub_common_1 = __webpack_require__(/*! smarthub-common */ "smarthub-common");
const cacheKey = 'tpc';
const cacheOptions = {
    storage: 'session'
};
const modalProps = {
    isBlocking: false,
    styles: { main: { maxWidth: 550 } },
};
const TPCMessage = ({ children }) => {
    const { enabled, checked, level, infoUri } = smarthub_common_1.useTPCCheck();
    const allowUI = level == 'none'
        || (checked && level == 'info');
    const { mode } = smarthub_common_1.useViewConfig();
    const { tpcMessage: strings } = smarthub_common_1.useLocalizeConfig();
    const { okText, okTitle, okLabel, closeText, closeTitle, closeLabel, infoText, infoTitle, infoLabel, title, subText: subTextTypes } = strings[mode];
    const subText = subTextTypes[level];
    const [dismissed, setDismissed] = react_1.useState(true);
    react_1.useEffect(() => {
        const hasDismissed = level == 'none'
            || (checked && enabled)
            || (level == 'info'
                && smarthub_common_1.Cache.get(cacheKey, cacheOptions));
        setDismissed(hasDismissed);
    }, [enabled, checked]);
    const toggle = react_1.useCallback(() => {
        if (level == 'info')
            smarthub_common_1.Cache.set(cacheKey, true, cacheOptions);
        setDismissed(true);
    }, [level]);
    const dialogContentProps = {
        type: react_2.DialogType.largeHeader,
        title,
        subText
    };
    return react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(react_2.Dialog, { hidden: dismissed, onDismiss: toggle, dialogContentProps: dialogContentProps, modalProps: modalProps },
            react_1.default.createElement(react_2.DialogFooter, null,
                allowUI
                    ? react_1.default.createElement(react_2.PrimaryButton, { onClick: toggle, text: okText, title: okTitle, ariaLabel: okLabel })
                    : react_1.default.createElement(react_2.PrimaryButton, { onClick: toggle, title: closeTitle, text: closeText, ariaLabel: closeLabel }),
                (infoUri === null || infoUri === void 0 ? void 0 : infoUri.length) > 0 && react_1.default.createElement(react_2.DefaultButton, { text: infoText, title: infoTitle, href: infoUri, ariaLabel: infoLabel }))),
        allowUI && children);
};
exports.TPCMessage = TPCMessage;


/***/ }),

/***/ "./src/index.ts":
/*!**********************!*\
  !*** ./src/index.ts ***!
  \**********************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
tslib_1.__exportStar(__webpack_require__(/*! ./components */ "./src/components/index.ts"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./middleware */ "./src/middleware/index.ts"), exports);


/***/ }),

/***/ "./src/middleware/bot/action-collection.middleware.ts":
/*!************************************************************!*\
  !*** ./src/middleware/bot/action-collection.middleware.ts ***!
  \************************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.ActionCollection = void 0;
const smarthub_common_1 = __webpack_require__(/*! smarthub-common */ "smarthub-common");
class ActionCollection extends smarthub_common_1.BaseMiddlewareCollection {
    constructor() {
        super();
    }
    testFallback(config, info) {
        return info.cardAction.type == config.id;
    }
}
exports.ActionCollection = ActionCollection;


/***/ }),

/***/ "./src/middleware/bot/activity-collection.middleware.ts":
/*!**************************************************************!*\
  !*** ./src/middleware/bot/activity-collection.middleware.ts ***!
  \**************************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.ActivityCollection = void 0;
const smarthub_common_1 = __webpack_require__(/*! smarthub-common */ "smarthub-common");
class ActivityCollection extends smarthub_common_1.BaseMiddlewareCollection {
    constructor() {
        super();
    }
    testFallback(config, info) {
        return info.activity.type == config.id;
    }
}
exports.ActivityCollection = ActivityCollection;


/***/ }),

/***/ "./src/middleware/bot/attachment-collection.middleware.ts":
/*!****************************************************************!*\
  !*** ./src/middleware/bot/attachment-collection.middleware.ts ***!
  \****************************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.AttachmentCollection = void 0;
const smarthub_common_1 = __webpack_require__(/*! smarthub-common */ "smarthub-common");
class AttachmentCollection extends smarthub_common_1.BaseMiddlewareCollection {
    constructor() {
        super();
    }
    testFallback(config, info) {
        return info.attachment.contentType == config.id;
    }
}
exports.AttachmentCollection = AttachmentCollection;


/***/ }),

/***/ "./src/middleware/bot/components/handle-any.fn.tsx":
/*!*********************************************************!*\
  !*** ./src/middleware/bot/components/handle-any.fn.tsx ***!
  \*********************************************************/
/***/ ((__unused_webpack_module, exports) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.handleAny = void 0;
const handleAny = ({ focus }, info) => {
    focus('chat-controls');
    return false;
};
exports.handleAny = handleAny;


/***/ }),

/***/ "./src/middleware/bot/components/handle-open-url.fn.tsx":
/*!**************************************************************!*\
  !*** ./src/middleware/bot/components/handle-open-url.fn.tsx ***!
  \**************************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.handleOpenUrl = void 0;
const smarthub_common_1 = __webpack_require__(/*! smarthub-common */ "smarthub-common");
const handleOpenUrl = ({ handleCommand, focus }, { cardAction }) => {
    const { value } = cardAction;
    //const redirectorLink = value.match(/^https?:\/\/(?<domain>[a-zA-Z0-9\.\-]*)\/concierge\/linkredirector\.ashx\?FLEX_RESULT_URL=(?<url>[a-zA-Z0-9\.\-\%\_]*)&FLEX_RESULT_ID\=(?<id>[a-zA-Z0-9\-]*)$/)
    handleCommand({
        $id: "",
        $schema: smarthub_common_1.RouteActionSchema,
        uri: value,
    });
    focus("chat-controls");
    return true;
};
exports.handleOpenUrl = handleOpenUrl;


/***/ }),

/***/ "./src/middleware/bot/components/handle-sign-in.fn.tsx":
/*!*************************************************************!*\
  !*** ./src/middleware/bot/components/handle-sign-in.fn.tsx ***!
  \*************************************************************/
/***/ ((__unused_webpack_module, exports) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.handleSignIn = void 0;
const attempts = [];
//TODO replace this with an action
const handleSignIn = ({ focus, localizeConfig }, { cardAction }) => {
    const { value } = cardAction;
    const repeat = attempts.indexOf(value) > -1;
    focus('chat-controls');
    if (!repeat)
        attempts.push(value);
    else
        alert(localizeConfig.chatSigningInMessage);
    return repeat;
};
exports.handleSignIn = handleSignIn;


/***/ }),

/***/ "./src/middleware/bot/components/index.ts":
/*!************************************************!*\
  !*** ./src/middleware/bot/components/index.ts ***!
  \************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.handleAny = exports.handleSignIn = exports.handleOpenUrl = void 0;
var handle_open_url_fn_1 = __webpack_require__(/*! ./handle-open-url.fn */ "./src/middleware/bot/components/handle-open-url.fn.tsx");
Object.defineProperty(exports, "handleOpenUrl", ({ enumerable: true, get: function () { return handle_open_url_fn_1.handleOpenUrl; } }));
var handle_sign_in_fn_1 = __webpack_require__(/*! ./handle-sign-in.fn */ "./src/middleware/bot/components/handle-sign-in.fn.tsx");
Object.defineProperty(exports, "handleSignIn", ({ enumerable: true, get: function () { return handle_sign_in_fn_1.handleSignIn; } }));
var handle_any_fn_1 = __webpack_require__(/*! ./handle-any.fn */ "./src/middleware/bot/components/handle-any.fn.tsx");
Object.defineProperty(exports, "handleAny", ({ enumerable: true, get: function () { return handle_any_fn_1.handleAny; } }));


/***/ }),

/***/ "./src/middleware/bot/core-actionmiddleware.fn.ts":
/*!********************************************************!*\
  !*** ./src/middleware/bot/core-actionmiddleware.fn.ts ***!
  \********************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.coreActionMiddleware = void 0;
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
const components_1 = __webpack_require__(/*! ./components */ "./src/middleware/bot/components/index.ts");
const coreActionMiddleware = (props) => () => next => (actionInfo) => tslib_1.__awaiter(void 0, void 0, void 0, function* () {
    const { cardAction: { type } } = actionInfo;
    const handled = type == 'openUrl'
        ? components_1.handleOpenUrl(props, actionInfo)
        : type == 'signin'
            ? components_1.handleSignIn(props, actionInfo)
            : components_1.handleAny(props, actionInfo);
    if (!handled)
        return next(actionInfo);
});
exports.coreActionMiddleware = coreActionMiddleware;


/***/ }),

/***/ "./src/middleware/bot/create-action-middleware.fn.ts":
/*!***********************************************************!*\
  !*** ./src/middleware/bot/create-action-middleware.fn.ts ***!
  \***********************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.createActionMiddleware = void 0;
const smarthub_common_1 = __webpack_require__(/*! smarthub-common */ "smarthub-common");
const createActionMiddleware = (coreMiddleware, additionalMiddleware) => {
    return (props) => smarthub_common_1.concatMiddleware(additionalMiddleware, coreMiddleware(props));
};
exports.createActionMiddleware = createActionMiddleware;


/***/ }),

/***/ "./src/middleware/bot/create-activity-middleware.fn.ts":
/*!*************************************************************!*\
  !*** ./src/middleware/bot/create-activity-middleware.fn.ts ***!
  \*************************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.createActivityMiddleware = void 0;
const smarthub_common_1 = __webpack_require__(/*! smarthub-common */ "smarthub-common");
const createActivityMiddleware = (coreMiddleware, additionalMiddleware) => {
    return (props) => smarthub_common_1.concatMiddleware(additionalMiddleware, coreMiddleware(props));
};
exports.createActivityMiddleware = createActivityMiddleware;


/***/ }),

/***/ "./src/middleware/bot/create-attachment-middleware.fn.ts":
/*!***************************************************************!*\
  !*** ./src/middleware/bot/create-attachment-middleware.fn.ts ***!
  \***************************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.createAttachmentMiddleware = void 0;
const smarthub_common_1 = __webpack_require__(/*! smarthub-common */ "smarthub-common");
const createAttachmentMiddleware = (coreMiddleware, additionalMiddleware) => {
    return (props) => smarthub_common_1.concatMiddleware(additionalMiddleware, coreMiddleware(props));
};
exports.createAttachmentMiddleware = createAttachmentMiddleware;


/***/ }),

/***/ "./src/middleware/bot/index.ts":
/*!*************************************!*\
  !*** ./src/middleware/bot/index.ts ***!
  \*************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
tslib_1.__exportStar(__webpack_require__(/*! ./components */ "./src/middleware/bot/components/index.ts"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./action-collection.middleware */ "./src/middleware/bot/action-collection.middleware.ts"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./activity-collection.middleware */ "./src/middleware/bot/activity-collection.middleware.ts"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./attachment-collection.middleware */ "./src/middleware/bot/attachment-collection.middleware.ts"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./core-actionmiddleware.fn */ "./src/middleware/bot/core-actionmiddleware.fn.ts"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./create-action-middleware.fn */ "./src/middleware/bot/create-action-middleware.fn.ts"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./create-activity-middleware.fn */ "./src/middleware/bot/create-activity-middleware.fn.ts"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./create-attachment-middleware.fn */ "./src/middleware/bot/create-attachment-middleware.fn.ts"), exports);


/***/ }),

/***/ "./src/middleware/fetch/components/fetch-concat.fn.ts":
/*!************************************************************!*\
  !*** ./src/middleware/fetch/components/fetch-concat.fn.ts ***!
  \************************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.fetchConcat = void 0;
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
const helpers_1 = __webpack_require__(/*! ../helpers */ "./src/middleware/fetch/helpers/index.ts");
const fetchConcat = (info) => tslib_1.__awaiter(void 0, void 0, void 0, function* () {
    const { query } = info;
    const results = yield helpers_1.fetchGroupResults(query, info);
    return results.reduce((result, { id, data, continuation }) => {
        var _a;
        return ({
            id: query.id,
            data: [
                ...(_a = result === null || result === void 0 ? void 0 : result.data) !== null && _a !== void 0 ? _a : [],
                ...(data
                    ? Array.isArray(data)
                        ? data
                        : [data]
                    : [])
            ],
            continuation: (result === null || result === void 0 ? void 0 : result.continuation) || continuation
                ? Object.assign(Object.assign({}, result === null || result === void 0 ? void 0 : result.continuation), (continuation !== null && continuation !== void 0 ? continuation : { [id]: continuation })) : null
        });
    }, null);
});
exports.fetchConcat = fetchConcat;


/***/ }),

/***/ "./src/middleware/fetch/components/fetch-group.fn.ts":
/*!***********************************************************!*\
  !*** ./src/middleware/fetch/components/fetch-group.fn.ts ***!
  \***********************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.fetchGroup = exports.IGroupQuerySchema = void 0;
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
const helpers_1 = __webpack_require__(/*! ../helpers */ "./src/middleware/fetch/helpers/index.ts");
exports.IGroupQuerySchema = "https://ics.ai/smarthub/query/group";
const fetchGroup = (info) => tslib_1.__awaiter(void 0, void 0, void 0, function* () {
    const { query } = info;
    const results = yield helpers_1.fetchGroupResults(query, info);
    return results.reduce((result, { id, data, continuation }) => {
        var _a, _b;
        return ({
            id: query.id,
            data: Object.assign(Object.assign({ $schema: (_a = query.schema) !== null && _a !== void 0 ? _a : exports.IGroupQuerySchema, $id: query.id }, (_b = result === null || result === void 0 ? void 0 : result.data) !== null && _b !== void 0 ? _b : {}), (data ? { [id]: data } : {})),
            continuation: (result === null || result === void 0 ? void 0 : result.continuation) || continuation
                ? Object.assign(Object.assign({}, result === null || result === void 0 ? void 0 : result.continuation), (continuation !== null && continuation !== void 0 ? continuation : { [id]: continuation })) : null
        });
    }, null);
});
exports.fetchGroup = fetchGroup;


/***/ }),

/***/ "./src/middleware/fetch/components/fetch-items.fn.ts":
/*!***********************************************************!*\
  !*** ./src/middleware/fetch/components/fetch-items.fn.ts ***!
  \***********************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.fetchItems = void 0;
const smarthub_common_1 = __webpack_require__(/*! smarthub-common */ "smarthub-common");
const fetchItems = (info) => {
    var _a, _b;
    const { query, context, providers } = info;
    const provider = ((_a = query.provider) === null || _a === void 0 ? void 0 : _a.length) > 0
        ? providers.find(p => p.name == query.provider)
        : null;
    if (provider)
        return (context === null || context === void 0 ? void 0 : context.body) || ((_b = query.request) === null || _b === void 0 ? void 0 : _b.body)
            ? provider.submit(query, context)
            : provider.query(query, context);
    else
        smarthub_common_1.Logger.warn(`Provider ${query.provider} for query not found`, info);
    return Promise.reject();
};
exports.fetchItems = fetchItems;


/***/ }),

/***/ "./src/middleware/fetch/components/fetch-list.fn.ts":
/*!**********************************************************!*\
  !*** ./src/middleware/fetch/components/fetch-list.fn.ts ***!
  \**********************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.fetchList = exports.IListQuerySchema = void 0;
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
const helpers_1 = __webpack_require__(/*! ../helpers */ "./src/middleware/fetch/helpers/index.ts");
exports.IListQuerySchema = "https://ics.ai/smarthub/query/list";
const fetchList = (info) => tslib_1.__awaiter(void 0, void 0, void 0, function* () {
    const { query } = info;
    const results = yield helpers_1.fetchGroupResults(query, info);
    return results.reduce((result, { id, data, continuation }) => {
        var _a, _b;
        return ({
            id: query.id,
            data: [
                ...(_a = result === null || result === void 0 ? void 0 : result.data) !== null && _a !== void 0 ? _a : [],
                {
                    $schema: (_b = query.schema) !== null && _b !== void 0 ? _b : exports.IListQuerySchema,
                    $id: id,
                    data
                }
            ],
            continuation: (result === null || result === void 0 ? void 0 : result.continuation) || continuation
                ? Object.assign(Object.assign({}, result === null || result === void 0 ? void 0 : result.continuation), (continuation !== null && continuation !== void 0 ? continuation : { [id]: continuation })) : null
        });
    }, null);
});
exports.fetchList = fetchList;


/***/ }),

/***/ "./src/middleware/fetch/components/index.ts":
/*!**************************************************!*\
  !*** ./src/middleware/fetch/components/index.ts ***!
  \**************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
tslib_1.__exportStar(__webpack_require__(/*! ./fetch-concat.fn */ "./src/middleware/fetch/components/fetch-concat.fn.ts"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./fetch-group.fn */ "./src/middleware/fetch/components/fetch-group.fn.ts"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./fetch-items.fn */ "./src/middleware/fetch/components/fetch-items.fn.ts"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./fetch-list.fn */ "./src/middleware/fetch/components/fetch-list.fn.ts"), exports);


/***/ }),

/***/ "./src/middleware/fetch/core-fetch-middleware.fn.ts":
/*!**********************************************************!*\
  !*** ./src/middleware/fetch/core-fetch-middleware.fn.ts ***!
  \**********************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.coreFetchMiddleware = void 0;
const components_1 = __webpack_require__(/*! ./components */ "./src/middleware/fetch/components/index.ts");
const coreFetchMiddleware = () => next => (info) => {
    if (info.query.hasOwnProperty("queries")) {
        const { action } = info.query;
        switch (action) {
            case 'group': return components_1.fetchGroup(info);
            case 'list': return components_1.fetchList(info);
            default: return components_1.fetchConcat(info);
        }
    }
    else
        return components_1.fetchItems(info);
};
exports.coreFetchMiddleware = coreFetchMiddleware;


/***/ }),

/***/ "./src/middleware/fetch/create-fetch-middleware.fn.ts":
/*!************************************************************!*\
  !*** ./src/middleware/fetch/create-fetch-middleware.fn.ts ***!
  \************************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.createFetchMiddleware = void 0;
const smarthub_common_1 = __webpack_require__(/*! smarthub-common */ "smarthub-common");
const createFetchMiddleware = (coreMiddleware, additionalMiddleware) => {
    const middleware = smarthub_common_1.concatMiddleware(additionalMiddleware, coreMiddleware)({});
    //TODO redability
    return (...args) => {
        try {
            return middleware((obj) => {
                smarthub_common_1.Logger.error("[createMiddleware] fetch not found", false, { args: args, obj: obj });
                return obj;
            })(...args);
        }
        catch (err) {
            return JSON.stringify(err, null, 2);
        }
    };
};
exports.createFetchMiddleware = createFetchMiddleware;


/***/ }),

/***/ "./src/middleware/fetch/fetch-collection.middleware.ts":
/*!*************************************************************!*\
  !*** ./src/middleware/fetch/fetch-collection.middleware.ts ***!
  \*************************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.FetchCollection = void 0;
const smarthub_common_1 = __webpack_require__(/*! smarthub-common */ "smarthub-common");
class FetchCollection extends smarthub_common_1.BaseMiddlewareCollection {
    constructor() {
        super();
    }
    testFallback(config, info) {
        return info.query.id == config.id;
    }
}
exports.FetchCollection = FetchCollection;


/***/ }),

/***/ "./src/middleware/fetch/helpers/fetch-group-results.helper.ts":
/*!********************************************************************!*\
  !*** ./src/middleware/fetch/helpers/fetch-group-results.helper.ts ***!
  \********************************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.fetchGroupResults = void 0;
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
const fetchGroupResults = (group, { context, providers, fetch }) => tslib_1.__awaiter(void 0, void 0, void 0, function* () {
    const infos = group.queries.reduce((collection, query) => {
        const continuation = context.continuation
            ? context.continuation[query.id]
            : null;
        if (!context.continuation || continuation)
            collection.push({
                context: Object.assign(Object.assign({}, context), { continuation: continuation }),
                query,
                providers,
                fetch
            });
        return collection;
    }, []);
    return yield Promise.all(infos.map(info => fetch(info)));
});
exports.fetchGroupResults = fetchGroupResults;


/***/ }),

/***/ "./src/middleware/fetch/helpers/index.ts":
/*!***********************************************!*\
  !*** ./src/middleware/fetch/helpers/index.ts ***!
  \***********************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
tslib_1.__exportStar(__webpack_require__(/*! ./fetch-group-results.helper */ "./src/middleware/fetch/helpers/fetch-group-results.helper.ts"), exports);


/***/ }),

/***/ "./src/middleware/fetch/index.ts":
/*!***************************************!*\
  !*** ./src/middleware/fetch/index.ts ***!
  \***************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
tslib_1.__exportStar(__webpack_require__(/*! ./components */ "./src/middleware/fetch/components/index.ts"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./helpers */ "./src/middleware/fetch/helpers/index.ts"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./core-fetch-middleware.fn */ "./src/middleware/fetch/core-fetch-middleware.fn.ts"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./create-fetch-middleware.fn */ "./src/middleware/fetch/create-fetch-middleware.fn.ts"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./fetch-collection.middleware */ "./src/middleware/fetch/fetch-collection.middleware.ts"), exports);


/***/ }),

/***/ "./src/middleware/index.ts":
/*!*********************************!*\
  !*** ./src/middleware/index.ts ***!
  \*********************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
tslib_1.__exportStar(__webpack_require__(/*! ./fetch */ "./src/middleware/fetch/index.ts"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./render */ "./src/middleware/render/index.ts"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./bot */ "./src/middleware/bot/index.ts"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./transform */ "./src/middleware/transform/index.ts"), exports);


/***/ }),

/***/ "./src/middleware/render/create-render-middleware.fn.tsx":
/*!***************************************************************!*\
  !*** ./src/middleware/render/create-render-middleware.fn.tsx ***!
  \***************************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.createRenderMiddleware = void 0;
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
const react_1 = tslib_1.__importDefault(__webpack_require__(/*! react */ "react"));
const smarthub_common_1 = __webpack_require__(/*! smarthub-common */ "smarthub-common");
const createRenderMiddleware = (coreMiddleware, additionalMiddleware) => {
    const middleware = smarthub_common_1.concatMiddleware(additionalMiddleware, coreMiddleware)({});
    return (...args) => {
        try {
            return middleware(({ component, options, FallBack }) => (children) => {
                return FallBack
                    ? react_1.default.createElement(FallBack, { config: component, data: options }, children)
                    : react_1.default.createElement("div", null,
                        react_1.default.createElement("p", null, "No renderer for this component"),
                        react_1.default.createElement("pre", null, JSON.stringify({ component, options }, null, 2)));
            })(...args);
        }
        catch (err) {
            return () => (react_1.default.createElement("div", null,
                react_1.default.createElement("p", null, "Failed to render component"),
                react_1.default.createElement("pre", null, JSON.stringify(err, null, 2))));
        }
    };
};
exports.createRenderMiddleware = createRenderMiddleware;


/***/ }),

/***/ "./src/middleware/render/index.ts":
/*!****************************************!*\
  !*** ./src/middleware/render/index.ts ***!
  \****************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
const tslib_1 = __webpack_require__(/*! tslib */ "tslib");
tslib_1.__exportStar(__webpack_require__(/*! ./create-render-middleware.fn */ "./src/middleware/render/create-render-middleware.fn.tsx"), exports);
tslib_1.__exportStar(__webpack_require__(/*! ./render-collection.middleware */ "./src/middleware/render/render-collection.middleware.ts"), exports);


/***/ }),

/***/ "./src/middleware/render/render-collection.middleware.ts":
/*!***************************************************************!*\
  !*** ./src/middleware/render/render-collection.middleware.ts ***!
  \***************************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.RenderCollection = void 0;
const smarthub_common_1 = __webpack_require__(/*! smarthub-common */ "smarthub-common");
class RenderCollection extends smarthub_common_1.BaseMiddlewareCollection {
    constructor() {
        super();
    }
    testFallback(config, info) {
        return info.component.template == config.id;
    }
}
exports.RenderCollection = RenderCollection;


/***/ }),

/***/ "./src/middleware/transform/core-transform-middleware.fn.ts":
/*!******************************************************************!*\
  !*** ./src/middleware/transform/core-transform-middleware.fn.ts ***!
  \******************************************************************/
/***/ ((__unused_webpack_module, exports) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.coreTransformMiddleware = void 0;
const coreTransformMiddleware = () => next => (info) => {
    return next(info);
};
exports.coreTransformMiddleware = coreTransformMiddleware;


/***/ }),

/***/ "./src/middleware/transform/create-transform-middleware.fn.ts":
/*!********************************************************************!*\
  !*** ./src/middleware/transform/create-transform-middleware.fn.ts ***!
  \********************************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.createTransformMiddleware = void 0;
const smarthub_common_1 = __webpack_require__(/*! smarthub-common */ "smarthub-common");
const createTransformMiddleware = (coreMiddleware, additionalMiddleware) => {
    const middleware = smarthub_common_1.concatMiddleware(additionalMiddleware, coreMiddleware)({});
    //TODO redability
    return (...args) => {
        try {
            return middleware((obj) => {
                smarthub_common_1.Logger.error("[createMiddleware] transform not found", false, { args: args, obj: obj });
                return Array.isArray(obj === null || obj === void 0 ? void 0 : obj.data)
                    ? []
                    : null;
            })(...args);
        }
        catch (err) {
            return JSON.stringify(err, null, 2);
        }
    };
};
exports.createTransformMiddleware = createTransformMiddleware;


/***/ }),

/***/ "./src/middleware/transform/index.ts":
/*!*******************************************!*\
  !*** ./src/middleware/transform/index.ts ***!
  \*******************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.TransformCollection = exports.createTransformMiddleware = exports.coreTransformMiddleware = void 0;
var core_transform_middleware_fn_1 = __webpack_require__(/*! ./core-transform-middleware.fn */ "./src/middleware/transform/core-transform-middleware.fn.ts");
Object.defineProperty(exports, "coreTransformMiddleware", ({ enumerable: true, get: function () { return core_transform_middleware_fn_1.coreTransformMiddleware; } }));
var create_transform_middleware_fn_1 = __webpack_require__(/*! ./create-transform-middleware.fn */ "./src/middleware/transform/create-transform-middleware.fn.ts");
Object.defineProperty(exports, "createTransformMiddleware", ({ enumerable: true, get: function () { return create_transform_middleware_fn_1.createTransformMiddleware; } }));
var transform_collection_class_1 = __webpack_require__(/*! ./transform-collection.class */ "./src/middleware/transform/transform-collection.class.ts");
Object.defineProperty(exports, "TransformCollection", ({ enumerable: true, get: function () { return transform_collection_class_1.TransformCollection; } }));


/***/ }),

/***/ "./src/middleware/transform/transform-collection.class.ts":
/*!****************************************************************!*\
  !*** ./src/middleware/transform/transform-collection.class.ts ***!
  \****************************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.TransformCollection = void 0;
const smarthub_common_1 = __webpack_require__(/*! smarthub-common */ "smarthub-common");
class TransformCollection extends smarthub_common_1.BaseMiddlewareCollection {
    constructor() {
        super();
    }
    upsertTemplate(template) {
        if (template instanceof Array) {
            const handlers = template.map(t => this.createHandler(t));
            this.upsert(handlers);
            return;
        }
        const handler = this.createHandler(template);
        this.upsert(handler);
    }
    createHandler({ id, sourceSchema, targetSchema, template, priority }) {
        return {
            id,
            priority,
            sourceSchema,
            targetSchema,
            template: null,
            handle: function (info) {
                try {
                    return smarthub_common_1.transformData(template, info, this);
                }
                catch (ex) {
                    smarthub_common_1.Logger.error(`Failed to transform data ${ex}`, false, { info, template });
                }
            }
        };
    }
    testFallback(config, info) {
        var _a, _b, _c;
        if (Array.isArray(info.data))
            return ((_a = info.data) === null || _a === void 0 ? void 0 : _a.length) > 0 && ((_b = info.data[0]) === null || _b === void 0 ? void 0 : _b.$schema) == config.sourceSchema && info.targetSchema == config.targetSchema;
        else
            return ((_c = info.data) === null || _c === void 0 ? void 0 : _c.$schema) == config.sourceSchema && info.targetSchema == config.targetSchema;
    }
}
exports.TransformCollection = TransformCollection;


/***/ }),

/***/ "@fluentui/react":
/*!**********************************!*\
  !*** external "@fluentui/react" ***!
  \**********************************/
/***/ ((module) => {

module.exports = require("@fluentui/react");

/***/ }),

/***/ "botframework-directlinejs":
/*!********************************************!*\
  !*** external "botframework-directlinejs" ***!
  \********************************************/
/***/ ((module) => {

module.exports = require("botframework-directlinejs");

/***/ }),

/***/ "botframework-webchat":
/*!***************************************!*\
  !*** external "botframework-webchat" ***!
  \***************************************/
/***/ ((module) => {

module.exports = require("botframework-webchat");

/***/ }),

/***/ "dayjs":
/*!************************!*\
  !*** external "dayjs" ***!
  \************************/
/***/ ((module) => {

module.exports = require("dayjs");

/***/ }),

/***/ "dayjs/plugin/isSameOrBefore":
/*!**********************************************!*\
  !*** external "dayjs/plugin/isSameOrBefore" ***!
  \**********************************************/
/***/ ((module) => {

module.exports = require("dayjs/plugin/isSameOrBefore");

/***/ }),

/***/ "query-string":
/*!*******************************!*\
  !*** external "query-string" ***!
  \*******************************/
/***/ ((module) => {

module.exports = require("query-string");

/***/ }),

/***/ "react":
/*!************************!*\
  !*** external "react" ***!
  \************************/
/***/ ((module) => {

module.exports = require("react");

/***/ }),

/***/ "react-jss":
/*!****************************!*\
  !*** external "react-jss" ***!
  \****************************/
/***/ ((module) => {

module.exports = require("react-jss");

/***/ }),

/***/ "recoil":
/*!*************************!*\
  !*** external "recoil" ***!
  \*************************/
/***/ ((module) => {

module.exports = require("recoil");

/***/ }),

/***/ "resize-observer-polyfill":
/*!*******************************************!*\
  !*** external "resize-observer-polyfill" ***!
  \*******************************************/
/***/ ((module) => {

module.exports = require("resize-observer-polyfill");

/***/ }),

/***/ "smarthub-common":
/*!**********************************!*\
  !*** external "smarthub-common" ***!
  \**********************************/
/***/ ((module) => {

module.exports = require("smarthub-common");

/***/ }),

/***/ "tslib":
/*!************************!*\
  !*** external "tslib" ***!
  \************************/
/***/ ((module) => {

module.exports = require("tslib");

/***/ }),

/***/ "use-debounce":
/*!*******************************!*\
  !*** external "use-debounce" ***!
  \*******************************/
/***/ ((module) => {

module.exports = require("use-debounce");

/***/ })

/******/ 	});
/************************************************************************/
/******/ 	// The module cache
/******/ 	var __webpack_module_cache__ = {};
/******/ 	
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/ 		// Check if module is in cache
/******/ 		var cachedModule = __webpack_module_cache__[moduleId];
/******/ 		if (cachedModule !== undefined) {
/******/ 			return cachedModule.exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = __webpack_module_cache__[moduleId] = {
/******/ 			// no module.id needed
/******/ 			// no module.loaded needed
/******/ 			exports: {}
/******/ 		};
/******/ 	
/******/ 		// Execute the module function
/******/ 		__webpack_modules__[moduleId](module, module.exports, __webpack_require__);
/******/ 	
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/ 	
/************************************************************************/
/******/ 	
/******/ 	// startup
/******/ 	// Load entry module and return exports
/******/ 	// This entry module is referenced by other modules so it can't be inlined
/******/ 	var __webpack_exports__ = __webpack_require__("./src/index.ts");
/******/ 	var __webpack_export_target__ = exports;
/******/ 	for(var i in __webpack_exports__) __webpack_export_target__[i] = __webpack_exports__[i];
/******/ 	if(__webpack_exports__.__esModule) Object.defineProperty(__webpack_export_target__, "__esModule", { value: true });
/******/ 	
/******/ })()
;
//# sourceMappingURL=index.js.map